/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable no-empty-pattern */
import React, {
  useLayoutEffect,
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import TipsConfirmPopUp from './tipsConfirmationPopUpRevamp';
import TipsAdvanceConfirmPopUp from './adavancrTipConfirmationPopup';
import FullWithModal from '@components/common/Modal/FullWidthModal';
import ReceiptScreenPopUp from '@components/checksCommon/receiptscreenPopUp';
import Loader from '@components/common/Loader/newLoaderModal';
import ReceiptScreen from '@components/ReceiptScreenNewUI';
import ReceiptScreenLandScape from '@components/ReceiptScreenNewUI/receiptLandScape';
import PaymentScreenReVamp from '@components/ServerAppPaymentScreens';
import ErrorPaymentIndex from '@components/PaymentScreens/errorPaymentIndex';
import Processindex from '@components/PaymentScreens/Processindex';
import NumberKeyboard from '@components/common/formElements/SimpleKeyboard/numberKeyboard';
import Modal from '@components/common/Modal';
import EmployeeCheck from '@components/checksCommon/employeeCheck';
import ItemizedCheck from '../../components/ItemizedCheckModal/index';
import ReceiptFooter from '../../components/ReceiptFooter/index';
import {
  paymentInitialization,
  paymentCash,
  paymentAuth,
  paymentAuthError,
  paymentAuthComplete,
  receiptEmail,
  paymentSale,
  paymentNewPaymentCreditSale,
  preAuthPayment,
  receiptSms,
  paymentSignature,
  setAuthResponse,
  receiptPrint,
  giftCardBalance,
  giftCardBalanceCheck,
  clearGiftCardBalanceInfo,
  giftCardPaymentInit,
  giftCardPayments,
  textToPay,
  clearAuthResponse,
  ingenicoLog,
  ingenicoPayment,
  getTips,
  orderTicketPrint,
  giftCardImages,
  paymentSplitCheck,
  applyTipForPayment,
  applyGiftCardBalance,
  giftCardDeleteBalance,
  toggleOtherPaymentOption,
  payByCreditCard,
  paymentNewInitialization,
  paymentNewPaymentComplete,
  paymentNewPaymentAtCounter,
  paymentNewPaymentError,
  creditCardDeleteBalance,
  paymentByCash,
  cashClearBalance,
  tipClear,
  paymentClearSplit,
  newIngenicoPayment,
  spiltCheckPayment,
  orderPayNewPaymentComplete,
} from '@reducers/payment';
import { updateChecksAfterResponse, moveChecks, sendChecks, setIsTipOnlyEnabled } from '@reducers/storeChecks';
import NotesIcon from '@assets/images/NotesIcon';

import {
  setNotification,
  setPrintNotification,
  closePrintNotification,
  setErrorPopUp,
  showSuccessCheckMark,
  closePrintSuccessPopUp,
  closePrint,
} from '@reducers/notification';
import {
  removeSeat,
  removePaymentCheck,
  updateSeatInfo,
  setPaymentCheck,
  checkVoid,
  setSeat,
  updateWithPaymentStages,
  setPosition,
  seatClear,
  setOfflineVoid
} from '@reducers/orders';
import { submitSurvey, getSurvey, getPaymentNewSurvey } from '@reducers/survey';
import { openEmployeeCheck } from '@reducers/oauth';
import { callServer, occupySeat } from '@reducers/checks';
import { setConfirmStageSplit } from '@reducers/stage';
import EventEmitter from '@utility/eventSubscribers';
import ensureCardReaderConnection from '@utility/ensureCardReaderConnection';
import { getObjectValue, urlSearchParams } from '@utility/utills';
import { flowType } from '@utility/userInfo';
import {
  playRingtone,
  sort,
  generateRandomString,
} from '@utility/helperFunction';
import { ReactComponent as SearchIcon } from '@assets/images/searchImgView.svg';
import PaymentImg from '@assets/images/Payment152.png';
import swipeGiftCard from '@assets/images/GIFs/Swipe_Gift_Card.gif';
import Ringtone from '@assets/tones/beep-08b.mp3';
import PaymentImg_white from '@assets/images/PaymentImg_white.png';
import { ReactComponent as BackChevron } from '@assets/images/backChevron.svg';
import { ReactComponent as LockIcon } from '@assets/images/Lock.svg';
import { APP_CONFIG, COUNTRY_CODE } from '@constants';
import { CUSTOM_MESSAGES, LABEL } from '../../veriables';
import cn from 'classnames';
import style from './viewreceipt.module.scss';
import {
  applyLoyaltyOffer,
  handleDeleteOffer,
  clearSelectedOffers,
  handleLoyaltyInfo,
  loyaltySplitOffers,
} from '@reducers/loyalty';
import { differenceWith, isEqual, filter } from 'lodash';
import AddSeat from '../../components/OrderMenuTop/Modals/AddSeat';
import DeleteSeat from '../../components/OrderMenuTop/Modals/DeleteSeat';
import { ERROR_MESSAGE } from '../../constants/index';
import {
  TouchableDiv,
  TouchableButton,
} from '../../components/common/Touchable/index';
import { Subtotal } from '../../components/ReceiptScreenNewUI/Subtotal/index';
import { Items } from '../../components/ReceiptScreenNewUI/Items/index';
import FullWidthModal from '../../components/common/Modal/FullWidthModal';
import LoyaltyListPopUp from './loyaltyListPopUp';
import DetailLoyaltyOffers from "../../components/ReceiptScreenNewUI/DetailLoyaltyOffers/index";
import SplitOffersList from './splitOffersListModal';
import { ReactComponent as SuccessIcon } from '@assets/images/check_circle.svg';
import { safeJsonParse } from '../../utility/helperFunction';
import {ReactComponent as Cross} from '@assets/images/cross.svg';
import styles from './viewreceipt.module.scss';

const ProcessSaleFlowLandscape = ({
  ShowLandscapeMode,
  checkAndSeats,
  setCheckAndSeats,
  orderingPortraitOrientation,
  paymentLandscapeOrientation,
  ...props
}) => {
  const { serverAppTheme } = props;
  const CREDIT_CARD = LABEL().CREDIT_CARD_PAY;
  const GIFT_CARD = LABEL().GIFT_CARD_PAY;
  const CASH = LABEL().CASH_PAY;
  const DEFAULT = LABEL().DEFAULT_PAY;

  const [cardReaderConnectionState, setCardReaderConnectionState] = useState({
    isLoading: false,
    message: '',
  });
  const [tableData, setTableData] = useState(props.paymentCheck);
  const AmountToPay = props?.seat?.paymentCheck;
  const hasAutoGratuity = props?.seat?.paymentCheck?.hasAutoGratuity;
  const seatData = JSON.parse(window.sessionStorage.getItem('seat'));
  const displayCoupon = seatData?.paymentCheck?.offer?.isCoupon;

  const isAutoGratuityPresent =
    (props.auth?.autoGratuityTipInfo ?? false) != null;
  const buttonControl = props.seat?.control || {};
  const serverAppThemeNumber = useMemo(
    () => getObjectValue(() => props.auth?.serverAppTheme, 1),
    []
  );
  const [isAmountEdit, setIsAmountEdit] = useState({
    isOpen: false,
    isError: false,
    isFirstClick: true,
  });

  const [payModeType, setPayModeType] = useState(DEFAULT);
  const [infoDeletion, setInfoDeletion] = useState({ isOpen: false, type: '' });
  const [giftCardReceiptModal, setGiftCardReceiptModal] = useState({
    isOpen: false,
    show: true,
  });
  const seatItemHashTable = {};
  const [splitTableData, setSplitTableData] = useState({});
  const [selectedStage, setSelectedStage] = useState('');
  const [selectedItem, setSelectedItem] = useState({});
  const [selectedSeats, setSelectedSeats] = useState([]);
  const [editStageModal, setEditStageModal] = useState({
    isEditStageModalOpen: false,
    isClearModalOpen: false,
    data: {},
  });

  const [selectedSeat, setSelectedSeat] = useState();
  const [isMoveModalOpen, setMoveModalOpen] = useState(false);
  const [paymentcheckLocksModal, setPaymentcheckLocksModal] = useState(false);
  const isSpeedOrder = getObjectValue(
    () => props.seat?.sourceType === 11,
    false
  );
  const isOffPremiseOrder = getObjectValue(
    () => [6, 7, 8].includes(props.seat?.sourceType),
    false
  );
  const [printSuccess, setPrintSuccess] = useState(false);
  const disablePayment =
    props.deviceInfo?.deviceGroup?.serverAppSettings.disablePayment;
  const [splitConfirm, setSplitConfirm] = useState(false);
  const billingRef = useRef(null);
  const paymentRef = useRef(null);
  const [billingHeight, setBillingHeight] = useState(0);
  const [paymentHeight, setPaymentHeight] = useState(0);
  const [loyaltyOffset, setLoyaltyOffset] = useState(0);
  const [seatMove, setSeatMove] = useState('');
  const [loyaltyList, setLoyaltyList] = useState(null);
  const [selectedLoyalty, setSelectedLoyalty] = useState(null);
  const [openLoyalty, setOpenLoyalty] = useState(false);
  const splitSeat = 'splitBySeat';
  const splitSelectedSeat = 'splitBySelectedSeat';
  const isLandScape = true; // Force landscape mode
  const [sendOrderConfirmation, setSendOrderConfirmation] = useState({ isOpen: false, type: '' });
  const [voidCancel, setVoidCancel] = useState(false);

  const defaultCountryCode = useMemo(() => getObjectValue(
    () => COUNTRY_CODE[props.auth.country].dialCode,
    '1'
  ), []);
  const storeTips = useMemo(() => props.auth.tipInfo
    ? props.auth.tipInfo.tips.map((item, index) => {
      return props.auth.tipInfo.ruleType === 1
        ? {
          ...item,
          id: index + 1,
          key: item.value * 100,
          displayKey: `${item.value * 100}%`,
          ruleType: props.auth.tipInfo.ruleType,
        }
        : {
          ...item,
          id: index + 1,
          key: item.value,
          displayKey: `${LABEL().CURRENCY_SYMBOL}${Number(
            item.value
          ).toFixed(2)}`,
          ruleType: props.auth.tipInfo.ruleType,
        };
    })
    : [], [])
  const autoGratuityStoreTips = useMemo(() => props?.auth?.autoGratuityTipInfo
    ? props.auth?.autoGratuityTipInfo?.tips?.map((item, index) => {
      return props?.auth?.autoGratuityTipInfo?.ruleType === 1
        ? {
          ...item,
          id: index + 1,
          key: item.value * 100,
          displayKey: `${item.value * 100}%`,
          ruleType: props?.auth?.autoGratuityTipInfo?.ruleType,
        }
        : {
          ...item,
          id: index + 1,
          key: item.value,
          displayKey: `${LABEL().CURRENCY_SYMBOL}${Number(
            item.value
          )?.toFixed(2)}`,
          ruleType: props?.auth?.autoGratuityTipInfo?.ruleType,
        };
    })
    : [], []);
  const charityList = useMemo(() => {
    let charityValue = props.auth?.charity?.enableFixedAmount
      ? [
        {
          id: 1,
          displayKey: `${LABEL().CURRENCY_SYMBOL}${props.auth.charity.fixedValue1
            }.00`,
        },
        {
          id: 2,
          displayKey: `${LABEL().CURRENCY_SYMBOL}${props.auth.charity.fixedValue2
            }.00`,
        },
        {
          id: 3,
          displayKey: `${LABEL().CURRENCY_SYMBOL}${props.auth.charity.fixedValue3
            }.00`,
        },
      ]
      : [];
    charityValue = props.auth?.charity?.enableRoundUp
      ? [...charityValue, { id: 4, displayKey: LABEL().ROUND_UP }]
      : charityValue;
    charityValue = props.auth?.charity?.enableCustomAmount
      ? [
        ...charityValue,
        { id: 4, displayKey: `${LABEL().CUSTOM} ${LABEL().CURRENCY_SYMBOL}` },
      ]
      : charityValue
    return charityValue
  }, []);

  const supportsTips = useMemo(() => getObjectValue(
    () => props.auth?.tipInfo?.tips?.length > 0,
    false
  ), []);

  const tipInfo = props?.auth?.tipInfo;
  const tipsList = supportsTips
    ? [
      ...storeTips,
      {
        id: 4,
        key: `${LABEL().OTHER_AMOUNT}`,
        displayKey: `${LABEL().OTHER_AMOUNT}`,
      },
    ]
    : [];
  const autoGratuityTipsList =
    props.auth?.autoGratuityTipInfo?.tips?.length > 0
      ? [
        ...autoGratuityStoreTips,
        {
          id: 4,
          key: `${LABEL().OTHER_AMOUNT}`,
          displayKey: `${LABEL().OTHER_AMOUNT}`,
        },
      ]
      : [];
  const isExternalCreditCard =
    defaultCountryCode === '44' &&
    getObjectValue(
      () => props.deviceInfo?.deviceGroup?.paymentTypes?.externalCreditCard,
      false
    );
  const hideSignature =
    props.auth.serverAppFeatures.supportsNoSignatureOnPayment;
  const defaultPaymentType = useMemo(
    () => Number(urlSearchParams('screenType')) || 1
    , [window.location.search]);
  const [paymentType, setPaymentType] = useState(defaultPaymentType);


  const moreSeats = useMemo(() => {
    const checkSeats = checkAndSeats?.seats?.map(item => {
      if (item?.name === null) {
        return `${item?.number}`;
      } else {
        const truncatedName =
          item?.name?.length > 4
            ? item?.name?.substring(0, 4) + '...'
            : item?.name;
        return `${item?.number}(${truncatedName})`;
      }
    });
    return checkSeats?.join(',');
  }, [checkAndSeats?.seats]);

  const currenySymbol = LABEL().CURRENCY_SYMBOL;
  const supportCashPayment = useMemo(() => getObjectValue(
    () =>
      props.auth.serverAppFeatures.supportsCashPayment &&
      props.userInfo.supportsCash,
    false
  ), []);
  const selectedAnswers =
    useMemo(() => JSON.parse(window.sessionStorage.getItem('selectedQuestions')) || [], [])
  const supportsWarnOnUnusualTip = useMemo(() => getObjectValue(
    () =>
      hasAutoGratuity
        ? props.auth.autoGratuityTipInfo.warnIfTipUnusual
        : props.auth.tipInfo.warnIfTipUnusual,
    false
  ), []);
  const skipSurvey = useMemo(
    () =>
      getObjectValue(
        () =>
          props.seat.sourceType === 6 ||
          props.seat.sourceType === 7 ||
          props.seat.sourceType === 8,
        false
      ),
    []
  );
  const getTheme = useMemo(
    () =>
      getObjectValue(
        () => JSON.parse(window.sessionStorage.getItem('auth')).serverAppTheme
      ),
    []
  );

  const flowTypeValue = useMemo(() => flowType());
  const isServerApp = flowTypeValue === 'serverApp';
  const isTableTop = flowTypeValue === 'tableTop';
  const isKiosk = flowTypeValue === 'kiosk';
  const isWalkUp = useMemo(
    () =>
      getObjectValue(() => props.seat && props.seat.sourceType === 7, false),
    []
  );
  const isSpeedOrderMode = useMemo(
    () =>
      getObjectValue(
        () => [1].includes(props.deviceInfo.deviceGroup.startMode),
        false
      ),
    []
  );
  const isTogo = useMemo(
   () =>
      getObjectValue(() => props?.seat?.sourceType === 8, false),
    []
  );

  const isDefaultMode = useMemo(() => getObjectValue(
    () =>
      !isWalkUp &&
      (!props.deviceInfo.deviceGroup ||
        [0].includes(props.deviceInfo.deviceGroup.startMode)),
    false
  ), [props.deviceInfo.deviceGroup]);

     const speedOrderMode = useMemo(
    () =>
      getObjectValue(() => props?.seat?.sourceType === 11, false),[props.seat]
  );

  const isCounter = useMemo(() => getObjectValue(
    () => isServerApp && [1].includes(props.deviceInfo.deviceGroup.startMode),
    false
  ), [isServerApp]);

  const isCallCenter = useMemo(() => getObjectValue(
    () => isServerApp && [2].includes(props.deviceInfo.deviceGroup.startMode),
    false
  ), [isServerApp]);
  const isOrderPayMode = useMemo(() => getObjectValue(
    () => isTableTop && [1].includes(props.deviceInfo.deviceGroup.startMode),
    false
  ), [isTableTop]);
  const lockPaymentScreen = useMemo(() => getObjectValue(
    () =>
      ((isServerApp && isDefaultMode) || isPaymentTerminal) &&
      props.auth.serverAppFeatures.lockPaymentScreen,
    false
  ), [props.auth.serverAppFeatures]);
  const isTipRequried = getObjectValue(
    () => props.auth.tipInfo.requireTipSelection,
    false
  );
  const receiptTypes = getObjectValue(
    () => props.deviceInfo.deviceGroup.receiptTypes,
    null
  );

  const isDriveThru = useMemo(() => getObjectValue(
    () => [3].includes(props?.deviceInfo?.deviceGroup?.startMode),
    false
  ), [props.deviceInfo])

  const showCheckSeat = useCallback(() => {
    if (!['1', '3'].includes(urlSearchParams('ticketSplitTypeId')?.trim())) {
      if (
        !['29', '30'].includes(urlSearchParams('screenType')?.trim()) &&
        !isSpeedOrder &&
        !isCallCenter &&
        !isOffPremiseOrder
      ) {
        return true;
      }
    } else {
      return false;
    }
  }, [window.location.search, isSpeedOrder, isCallCenter, isOffPremiseOrder]);

  const isPaymentTerminal = flowTypeValue === 'paymentTerminal';
  const [isTipsConfirm, setIsTipsConfirm] = useState(false);
  const [isAdvanceTipsConfirm, setIsAdvanceTipsConfirm] = useState(false);
  const [selectedPayment, setSelectedPayment] = useState('');
  const [giftBalance, setGiftBalance] = useState(false);
  const [charityAmount, setCharityAmount] = useState(0);
  const [viewDetailsOpen, setViewDetailsOpen] = useState(false);
  const [externalId, setExternalId] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [totalVisible, setTotalVisible] = useState({
    amount: true,
    percent: false,
  });
  const [smsEmailPrintObject, setsmsEmailPrintObject] = useState({
    smsReceiptStatus: false,
    emailReceiptStatus: false,
    printReceiptStatus: false,
    NoReceipt: false,
  });
  const [phoneNumberMaxLength, setPhoneNumberMaxLength] = useState(
    getObjectValue(() => COUNTRY_CODE[props.auth.country].maxLength, 15)
  );
  const [active, setActive] = useState('');
  const [confirmPopup, setConfirmPopup] = useState(false);
  const [tipAmount, setTipAmount] = useState(0);
  const [paymentAmount, setPaymentAmount] = useState(
    Number(tableData?.unpaidAmount).toFixed(2)
  );
  const [isReceipt, setIsReceipt] = useState({});
  const [keyboardValue, setKeyboardValue] = useState('');
  const [isSwipe, setIsSwipe] = useState(false);
  const [checkboxactive, setCheckboxactives] = useState(false);
  const [giftCardNumber, setGiftCardNumber] = useState();
  const [textToPayModelOpen, setTextToPayModelOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [countryCode, setCountryCode] = useState(defaultCountryCode);
  const [successMessage, setSuccesMessage] = useState('');
  const [isCashPaymentCheck, setIsCashPaymentCheck] = useState(false);
  const [confirmCashPayment, setConfirmCashPayment] = useState(false);
  const [tipsMessage, setTipsMessage] = useState('');
  const [cancelOrderConfirm, setCancelOrderConfirm] = useState(false);
  const [hideCancelIcon, setHideCancelIcon] = useState(
    lockPaymentScreen ? false : true
  );
  const [pointEarnings, setPointEarnings] = useState(0);
  const [isCustomTipModelOpen, setCustomTipModelOpen] = useState(false);
  const [isConfirmSplit, setIsConfirmSplit] = useState(false);
  const [directToCashConfirm, setDirectToCashCOnfirmation] = useState(false);
  const [btnPrimary, setBtnPrimary] = useState({
    isAmount: {
      background: serverAppTheme?.selected,
      color: '#000',
    },
    isPercent: {
      background: 'transparent',
      color: serverAppTheme?.primary_text,
    },
  });
  const headerImg = props?.auth?.imageUrl;
  const [giftCardPaymentReceipt, setGiftCardPaymentReceipt] = useState(false);
  const [otherAmountOrPersent, setOtherAmountOrPersent] = useState(true);
  const [creditCardAmount, setCreditCardAmount] = useState(
    String(Number(props.seat?.paymentCheck?.paymentAmount || 0).toFixed(2)) ||
    '0'
  );
  const [paymentConfirmation, setPaymentConfirmation] = useState({
    isPartiallyPaid: false,
    isPaymentPartiallyComplete: false,
    isPaymentComplete: false,
    isPaymentFailed: false,
    isTipPartiallyPaid: false,
  });
  const employeeCheckInRef = useRef();
  const [isOtherPaymentOptionClick, setIsOtherPaymentOptionClick] = useState(
    false
  );
  const [showTicketDetails, setShowTicketDetails] = useState(false);
  const cashMode = getObjectValue(
    () => props.deviceInfo.deviceGroup.startMode,
    0
  );
  const [availableSeats, setAvailableSeats] = useState([]);
  const [paymentcheckTicketsModal, setPaymentcheckTicketsModal] = useState(
    false
  );
  const [newOfferPopUp, setNewOfferPopUp] = useState(false);

  const ingenicoUseSaleMethod = useMemo(() => getObjectValue(() => props.auth.ingenicoUseSaleMethod, false), [])
  const cardReaderType = useMemo(() => getObjectValue(() => props.auth?.cardReaderType, null), null);

  const paymentTypeForIngenicoUseSale = (ingenicoUseSaleMethod && [1, 2].includes(cardReaderType));
  const eventMethodType = paymentTypeForIngenicoUseSale ? 'processCreditSale' : 'processPayment';


  // useLayoutEffect(() => {
  //   if (isCounter && urlSearchParams('type') === 'creditCard') {
  //     const cardReaderType = props.auth?.cardReaderType
  //     if (
  //       getObjectValue(
  //         () =>
  //           [3, 5, 6, 8, 7, 9].includes(cardReaderType),
  //         false
  //       )
  //     ) {
  //       returnCreditCardMethod();
  //     } else if (
  //       getObjectValue(() => cardReaderType === 1) &&
  //       !supportsTips
  //     ) {
  //       returnCreditCardMethod();
  //     } else if (
  //       supportsTips &&
  //       !getObjectValue(
  //         () =>
  //           [3, 5, 6, 8, 7, 9].includes(cardReaderType),
  //         false
  //       )
  //     ) {
  //       isTipsRequiredCheck('creditCard');
  //     }
  //   }
  // }, []);
  useLayoutEffect(() => {
    if (urlSearchParams('loyalty') == 'no') {
      if (urlSearchParams('offer') != 'yes') {
        const isTipPresent =
          getObjectValue(
            () =>
              JSON.parse(window.sessionStorage.getItem('seat'))?.paymentCheck
                ?.tip,
            false
          ) !== null;
        if (tipInfo && !isTipPresent) {
          if (props?.deviceInfo?.deviceGroup?.brandTipId) {
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
              }?ticketSplitTypeId=${urlSearchParams(
                'ticketSplitTypeId'
              )}&splitValue=${urlSearchParams(
                'splitValue'
              )}&screenType=4&type=${urlSearchParams('type')}`,
              { replace: true }
            );
            setPaymentType(4);
          } else {
            setPaymentType(23);
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
              }?ticketSplitTypeId=${urlSearchParams(
                'ticketSplitTypeId'
              )}&splitValue=${urlSearchParams(
                'splitValue'
              )}&screenType=23&type=${urlSearchParams('type')}`,
              { replace: true }
            );
          }
        } else {
          if (props.isCreditCardPayment) {
            setPaymentType(23);
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
              }?ticketSplitTypeId=${urlSearchParams(
                'ticketSplitTypeId'
              )}&splitValue=${urlSearchParams(
                'splitValue'
              )}&screenType=23&type=${urlSearchParams('type')}`,
              { replace: true }
            );
          } else {
            if (tipInfo) {
              if (props?.deviceInfo?.deviceGroup?.brandTipId) {
                props.navigate(
                  `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                  }?ticketSplitTypeId=${urlSearchParams(
                    'ticketSplitTypeId'
                  )}&splitValue=${urlSearchParams(
                    'splitValue'
                  )}&screenType=4&type=${urlSearchParams('type')}`,
                  { replace: true }
                );
                setPaymentType(4);
              }
            } else {
              setPaymentType(31);
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=31&type=${urlSearchParams('type')}`,
                { replace: true }
              );
            }
          }
        }
      } else {
        setPaymentType(31);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=31&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      }
    } else if (urlSearchParams('type') == 'splitType') {
      setPaymentType(urlSearchParams('screenType'));
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
        }?ticketSplitTypeId=${urlSearchParams(
          'ticketSplitTypeId'
        )}&splitValue=${urlSearchParams(
          'splitValue'
        )}&screenType=${urlSearchParams('screenType')}&type=${urlSearchParams(
          'type'
        )}`,
        { replace: true }
      );
    }
  }, []);

  useEffect(() => {
    const arr = [];
    props?.seat?.seats?.map(e => {
      if (e.open && e.loyalty !== null) {
        arr.push(e.loyalty);
      }
    });
    setLoyaltyList(arr);
  }, [props?.seat?.seats]);

  useEffect(() => {
    if (urlSearchParams('preAuth')) {
      setHideCancelIcon(true);
    }
    if (urlSearchParams('unlock')) {
      if (lockPaymentScreen) {
        setHideCancelIcon(false);
      }
    }
    if (window.ReactNativeWebView) {
      try {
        EventEmitter.printData(
          res => {
            printListener(res);
          },
          err => {
            props.setErrorPopUp({
              res: err,
            });
          }
        );
      } catch (e) {
        console.log('catch', e);
      }
    }
    return () => {
      if (window.ReactNativeWebView) {
        EventEmitter.removeListeners('printData', () => { });
      }
    };
  }, []);

  useEffect(() => {
    return () => {
      if (props?.isTipOnlyEnabled) {
        props?.setIsTipOnlyEnabled(false);
      }
    };
  }, []);

  useEffect(() => {
    if ([4].includes(paymentType)) {
      let activeTip = '';
      if (
        (props.seat?.paymentCheck?.tip &&
          props.seat?.paymentCheck?.tipType === 3) ||
        props.seat?.paymentCheck?.tipType === 4
      ) {
        active === 'resetTip' ? (activeTip = '') : (activeTip = 'otherAmount');
      } else if (props.seat?.paymentCheck?.tip && active !== 'resetTip') {
        activeTip = props.seat?.paymentCheck?.tip?.tipTypeValue;
      } else {
        if (hasAutoGratuity) {
          if (isAutoGratuityPresent) {
            activeTip = props.auth?.autoGratuityTipInfo?.disablePresetTip
              ? ''
              : getObjectValue(
                () => autoGratuityStoreTips.find(item => item.isDefault).key,
                ''
              );
          }
        } else {
          activeTip = tipInfo?.disablePresetTip
            ? ''
            : getObjectValue(
              () => storeTips.find(item => item.isDefault).key,
              ''
            );
        }
      }
      setActive(activeTip);
      if (hasAutoGratuity) {
        const totalAmount = 0;
        activeTip !== 'otherAmount' &&
          setTipAmount(
            props?.auth?.autoGratuityTipInfo?.ruleType === 1
              ? ((totalAmount * activeTip) / 100).toFixed(2)
              : +(activeTip || 0).toFixed(2)
          );
      } else {
        const totalAmount = getTotalAmountForTip();
        activeTip !== 'otherAmount' && !props?.isTipOnlyEnabled &&
          setTipAmount(
            props?.auth?.tipInfo?.ruleType === 1
              ? ((totalAmount * activeTip) / 100).toFixed(2)
              : +(activeTip || 0).toFixed(2)
          );
      }
    }
  }, [paymentType]);

  useEffect(() => {
    if (
      Number(urlSearchParams('screenType')) === 3 &&
      props.deviceInfo?.deviceGroup?.paymentTypes?.preAuth
    ) {
      setPaymentType(3);
    }
    if (urlSearchParams('externalCreditCard')) {
      setExternalId(true);
      setKeyboardValue('');
      setCustomTipModelOpen(true);
      setActive(LABEL().CUSTOM_AMOUNT);
    }
  }, []);

  useEffect(() => {
    if (urlSearchParams('paidBy') === 'loyalty') {
      setSuccesMessage(`${LABEL().PAYMENT_COMPLETED}`);
    }
    setPaymentType(Number(urlSearchParams('screenType')));
    setTableData({
      ...props.paymentCheck,
    });
    setPaymentAmount(
      isTableTop ? props.seat.unpaidAmount : props.paymentCheck?.unpaidAmount
    );
  }, [props.paymentCheck, props.seat]);

  useLayoutEffect(() => {
    const loyaltyOfferState = getLoyaltyOfferState();
    const offset =
      loyaltyOfferState === 1 ? 19 :
        loyaltyOfferState === 2 ? 57 :
          0;
    setLoyaltyOffset(offset);

    const updateHeights = () => {
      if (billingRef.current && paymentRef.current) {
        const billingHeightValue = billingRef.current.offsetHeight || 0;
        const paymentHeightValue = paymentRef.current.offsetHeight || 0;
        if (billingHeightValue > 0 && paymentHeightValue > 0) {
          setBillingHeight(billingHeightValue);
          setPaymentHeight(paymentHeightValue);
          return;
        }
      } else {
        setTimeout(updateHeights, 1000); // fallback retry
        return;
      }
    };

    updateHeights();
  }, [props?.seat?.paymentCheck?.tickets, tableData]);

  const getLoyaltyOfferState = () => {
    const loyalty = tableData?.paymentCheck?.loyalty ?? null;
    const offers = tableData?.paymentCheck?.offers ?? null;

    if (
      (Array.isArray(offers) && offers.length > 1) ||
      (loyalty && Array.isArray(offers) && offers.length > 0)
    ) {
      return 2; // two offers || both loyalty and offers
    } else if (loyalty || (Array.isArray(offers) && offers.length === 1)) {
      return 1; // only loyalty || one offer
    } else {
      return 0; // neither
    }
  }
  const loyaltyState = getLoyaltyOfferState();

  const tickets = useMemo(() => {
    try {
      const seatData = window.sessionStorage.getItem('seat');
      return seatData ? JSON.parse(seatData) : null;
    } catch (e) {
      return null;
    }
  }, []);

  const handleNoReceipt = () => {
    setsmsEmailPrintObject(prev => ({
      ...prev,
      NoReceipt: !smsEmailPrintObject.NoReceipt,
      printReceiptStatus: !smsEmailPrintObject.printReceiptStatus,
      emailReceiptStatus: !smsEmailPrintObject.emailReceiptStatus,
      smsReceiptStatus: !smsEmailPrintObject.smsReceiptStatus,
    }));
  };

  const handleTipOnlyClose = () => {
    setVoidCancel(true);
  };

  const popupModal = useMemo(() => {
    const speedOrderModal = {
      margin: 'auto',
      backgroundColor: serverAppTheme?.popUp_bg,
      borderRadius: "16px",
      border: serverAppTheme?.popupBorder,
      boxShadow: serverAppTheme?.popUp_box_shadow,
      width: '486px',
      minHeight: '216px',
      padding: '1.5rem'
    }
    const messageStyle = { color: serverAppTheme?.primary_text }
    const noButton = {
      border: serverAppTheme?.cancleBtn_Border,
      background: serverAppTheme?.OFF_Premise_Btn,
      color: serverAppTheme?.cancleBtn_font
    }

    return { speedOrderModal, messageStyle, noButton }
  }, [serverAppTheme])

  const handleCancelOrderConfirm = () => {
      const dataToSend = {
        employeeId: Number(props?.userInfo?.id),
        storeId: props?.deviceInfo?.storeId,
        checkHeaderId: props?.seat?.id,
        deviceId: props?.deviceInfo?.deviceId,
      };
      props
        .checkVoid(dataToSend)
        .then(res => {
          setVoidCancel(false);
          props.navigate(`${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`, {
            replace: true,
          });
          if (props?.isTipOnlyEnabled) props?.setIsTipOnlyEnabled(false);
          if (props?.isOfflineVoid) props?.setOfflineVoid(false);
          // props.updateChecksAfterResponse(res).then(() => {
              props.navigate(`${APP_CONFIG.BASE_URL}/${flowType()}/checks`, {
                replace: true,
              });
          // });
        })
        .catch(e => {
          props.setNotification({
            type: 'danger',
            message: e.message,
          });
        });
    // } else {
    //   setPaymentType(4);
    //   props.navigate(
    //     `${APP_CONFIG.BASE_URL}/receipt/${props?.seat?.paymentCheck?.id
    //     }?ticketSplitTypeId=1&splitValue=1&screenType=4&type=payType`,
    //     { replace: true }
    //   );
    // }
  };

  const handlePaymentForDriveThru = (res) => {
    if (res?.paymentCheck?.paymentAmount > 0) {
      setPaymentConfirmation(prevState => ({
        ...prevState,
        isPartiallyPaid: true,
        isPaymentComplete: false,
      }));
      setPaymentType(33);
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
        }?ticketSplitTypeId=${urlSearchParams(
          'ticketSplitTypeId'
        )}&splitValue=${urlSearchParams(
          'splitValue'
        )}&screenType=33&type=${urlSearchParams('type')}`,
        { replace: true }
      );
    } else {
      props.navigate(`${APP_CONFIG.BASE_URL}/serverApp/checks?login=true`);
    }
  }

  const paymentFn = paymentTypeForIngenicoUseSale ? props.paymentNewPaymentCreditSale : props.paymentNewPaymentComplete;

  const handleGiftCardPayment = () => {
    let dataToSend = {
      storeId: props?.deviceInfo?.storeId,
      deviceId: props?.deviceInfo?.deviceId,
      employeeId: props?.userInfo?.id,
      checkHeaderId: tableData?.id,
      employeeCard: getObjectValue(
        () =>
          JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard,
        null
      ),
      paymentCheck: props?.seat?.paymentCheck,
      paymentChecks: props?.seat?.paymentChecks,
    };
    props
      ?.paymentNewInitialization(dataToSend)
      .then(val => {
        const giftCards = val?.paymentCheck?.giftCards || [];
        const giftCardTicketIds = giftCards.map(gc => gc.ticketId);
        const payLoad = {
          storeId: props?.deviceInfo?.storeId,
          deviceId: props?.deviceInfo?.deviceId,
          employeeId: props?.userInfo?.id,
          employeeCard: props?.userInfo?.employeeCard,
          checkHeaderId: tableData?.id,
          paymentCheck: {
            ...val?.paymentCheck,
            giftCardTicketIds: giftCardTicketIds,
            giftCards: giftCards,
          },
          paymentChecks: val?.paymentChecks,
          creditCard: null,
          giftCardTicketIds: giftCardTicketIds,
          giftCards: giftCards
        };
        paymentFn(payLoad)
          .then(res => {
            props.clearSelectedOffers();
            props.setSeat({
              ...props.seat,
              paymentCheck: res.paymentCheck,
              paymentChecks: res.paymentChecks,
            });
            props.setPaymentCheck({
              ...props.paymentCheck,
              paymentCheck: res.paymentCheck,
            });
            if (isDriveThru || isCallCenter || isCounter) {
              handlePaymentForDriveThru(res);
            }
            else {

              if (res.control?.partialPayment) {
                setPaymentConfirmation(prevState => ({
                  ...prevState,
                  isPaymentPartiallyComplete: true,
                  isPaymentFailed: false,
                }));
              } else if (res?.paymentCheck?.paymentAmount > 0) {
                setPaymentConfirmation(prevState => ({
                  ...prevState,
                  isPartiallyPaid: true,
                  isPaymentComplete:
                    res?.paymentCheck?.paymentAmount > 0 ? false : true,
                  isPaymentFailed: false,
                }));
              } else {
                setPaymentConfirmation(prevState => ({
                  ...prevState,
                  isPaymentComplete:
                    res?.paymentCheck?.paymentAmount > 0 ? false : true,
                  isPaymentFailed: false,
                }));
              }
              setPaymentType(33);
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=33&type=${urlSearchParams('type')}`,
                { replace: true }
              );
            }
          })
          .catch(err => {
            props.setErrorPopUp({
              res: err.message,
            });
          });
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };
  const creditRetryBtn = () => {
    setPaymentType(31);
    props.history?.replace({
      pathname: `${APP_CONFIG.BASE_URL}/receipt/${props.seat.id
        }?ticketSplitTypeId=${urlSearchParams(
          'ticketSplitTypeId'
        )}&splitValue=${urlSearchParams(
          'splitValue'
        )}&screenType=31&type=${urlSearchParams('type')}`,
    });
  };

  const handleRouteCross = () => {
    if (
      urlSearchParams('screenType') === '12' &&
      urlSearchParams('type') === 'giftCardPay'
    ) {
      setPayModeType(CREDIT_CARD);
      setPaymentType(32);
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.checkHeaderId
        }?ticketSplitTypeId=${Number(
          urlSearchParams('ticketSplitTypeId')
        )}&splitValue=${urlSearchParams(
          'splitValue'
        )}&screenType=32&type=payType`,
        { replace: true }
      );
    } else if (
      urlSearchParams('screenType') === '16' &&
      (urlSearchParams('type') === 'payType' ||
        urlSearchParams('type') === 'splitType' ||
        urlSearchParams('type') === 'giftCardPay'
      )
    ) {
      setPayModeType(DEFAULT);
      setPaymentType(32);
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.checkHeaderId
        }?ticketSplitTypeId=${Number(
          urlSearchParams('ticketSplitTypeId')
        )}&splitValue=${urlSearchParams(
          'splitValue'
        )}&screenType=32&type=${urlSearchParams('type')}`,
        { replace: true }
      );
    } else if (
      ['31', '32', '33'].includes(urlSearchParams('screenType')) &&
      props?.seat?.paymentCheck?.tickets?.length > 0
    ) {
      if (props.deviceInfo?.deviceGroup?.brandSurveyId) {
        setPaymentcheckTicketsModal(true);
      } else {
        setPaymentType(22);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=22&type=${urlSearchParams('type')}&flow=reverse`,
          { replace: true }
        );
      }
    } else {
      props?.seat?.sourceType === 7
        ? props.navigate(`${APP_CONFIG.BASE_URL}/orders`)
        : (isDriveThru || isCounter || isCallCenter || isTogo) ? props.navigate(`${APP_CONFIG.BASE_URL}/orders`) : props.navigate(`${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`, {
          replace: true,
        });
      window.sessionStorage.removeItem('loyaltyData');
      props.handleLoyaltyInfo({ phoneNumber: null, email: null, type: null });
    }
  };

  const TipAmountOnTipValue = () => {
    let tipType = props.seat?.paymentCheck?.tipType;

    if (tipType && (tipType === 3 || tipType === 4)) {
      setTipAmount(props.seat?.paymentCheck?.tipAmount);
      setPaymentType(4);
    } else {
      setPaymentType(4);
    }
  };

  useEffect(() => {
    if (props.isPrintSuccess) {
      setPrintSuccess(true);
    }
  }, [props.isPrintSuccess, closePrint]);
  useEffect(() => {
    if (props?.seat?.paymentCheck?.paymentAmount !== undefined) {
      setCreditCardAmount(
        String(Number(props?.seat?.paymentCheck?.paymentAmount || 0).toFixed(2)) || '0'
      );
    }
  }, [props?.seat?.id, props?.seat?.paymentCheck?.id, props?.seat?.paymentCheck?.paymentAmount]);

  const GiftCardCouponClear = () => {
    let dataToSendForGiftCard = {
      deviceId: props.deviceInfo?.deviceId,
      employeeId: Number(props?.userInfo?.id),
      employeeCard: props.userInfo?.employeeCard,
      checkHeaderId: tableData?.id,
      storeId: props.deviceInfo?.storeId,
    };
    let dataToSendForDeleteOffer = {
      deviceId: props.deviceInfo?.deviceId,
      employeeId: Number(props.userInfo?.id),
      employeeCard: props.userInfo?.employeeCard,
      checkHeaderId: tableData?.id,
      storeId: props.deviceInfo?.storeId,
    };
    let dataToSendLoyaltyDelet = {
      deviceId: props.deviceInfo?.deviceId,
      employeeId: props.userInfo?.id,
      storeId: props.deviceInfo?.storeId,
      checkHeaderId: props.paymentCheck?.id,
    };
    if (
      props.seat?.paymentCheck?.offer &&
      (props.seat?.paymentCheck?.giftCard || props.seat?.paymentCheck?.giftCards?.length > 0) &&
      props.seat?.paymentCheck?.loyalty
    ) {
      dataToSendForGiftCard = {
        ...dataToSendForGiftCard,
        giftCard: props.seat?.paymentCheck?.giftCard || props.seat?.paymentCheck?.giftCards?.[0],
        paymentCheck: props?.seat?.paymentCheck,
        paymentChecks: props?.seat?.paymentChecks,
      };
      props
        .giftCardDeleteBalance(dataToSendForGiftCard)
        .then(res => {
          props.setSeat({
            ...props.seat,
            paymentCheck: res.paymentCheck,
            paymentChecks: res.paymentChecks,
          });
          dataToSendForDeleteOffer = {
            ...dataToSendForDeleteOffer,
            offer: res?.paymentCheck?.offer,
            paymentCheck: res.paymentCheck,
            paymentChecks: res.paymentChecks,
          };
          props
            .handleDeleteOffer(dataToSendForDeleteOffer)
            .then(res => {
              props.setSeat({
                ...props.seat,
                paymentCheck: res.paymentCheck,
                paymentChecks: res.paymentChecks,
              });
              dataToSendLoyaltyDelet = {
                ...dataToSendLoyaltyDelet,
                totalAmount: res.paymentCheck.totalAmount,
                unpaidAmount: res.paymentCheck.unpaidAmount,
                paidAmount: res.paymentCheck.paidAmount,
                paymentCheck: res.paymentCheck,
                paymentChecks: res.paymentChecks,
                offer: res?.paymentCheck?.offer || {},
                loyalty: res?.paymentCheck?.loyalty,
              };
              props.deleteLoyalty('', dataToSendLoyaltyDelet);
              tipInfo && TipAmountOnTipValue();
              setPaymentType(
                hasAutoGratuity
                  ? isAutoGratuityPresent
                    ? 4
                    : 28
                  : tipInfo
                    ? 4
                    : 28
              );
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams('splitValue')}&screenType=${hasAutoGratuity
                  ? isAutoGratuityPresent
                    ? 4
                    : 28
                  : tipInfo
                    ? 4
                    : 28
                }&type=${urlSearchParams('type')}`,
                { replace: true }
              );
            })
            .catch(error => {
              props.setErrorPopUp({
                res: error.message,
              });
            });
        })
        .catch(error => {
          props.setErrorPopUp({
            res: error.message,
          });
        });
    } else if (
      props.seat?.paymentCheck?.offer &&
      (props.seat?.paymentCheck?.giftCard || props.seat?.paymentCheck?.giftCards?.length > 0) &&
      !props.seat?.paymentCheck?.loyalty
    ) {
      dataToSendForGiftCard = {
        ...dataToSendForGiftCard,
        giftCard: props.seat?.paymentCheck?.giftCard || props.seat?.paymentCheck?.giftCards?.[0],
        paymentCheck: props?.seat?.paymentCheck,
        paymentChecks: props?.seat?.paymentChecks,
      };
      props
        .giftCardDeleteBalance(dataToSendForGiftCard)
        .then(res => {
          props.setSeat({
            ...props.seat,
            paymentCheck: res.paymentCheck,
            paymentChecks: res.paymentChecks,
          });
          dataToSendForDeleteOffer = {
            ...dataToSendForDeleteOffer,
            offer: res?.paymentCheck?.offer,
            paymentCheck: res.paymentCheck,
            paymentChecks: res.paymentChecks,
          };
          props
            .handleDeleteOffer(dataToSendForDeleteOffer)
            .then(res => {
              props.setSeat({
                ...props.seat,
                paymentCheck: res.paymentCheck,
                paymentChecks: res.paymentChecks,
              });
              tipInfo && TipAmountOnTipValue();
              setPaymentType(
                hasAutoGratuity
                  ? isAutoGratuityPresent
                    ? 4
                    : 28
                  : tipInfo
                    ? 4
                    : 28
              );
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams('splitValue')}&screenType=${hasAutoGratuity
                  ? isAutoGratuityPresent
                    ? 4
                    : 28
                  : tipInfo
                    ? 4
                    : 28
                }&type=${urlSearchParams('type')}`,
                { replace: true }
              );
            })
            .catch(error => {
              props.setErrorPopUp({
                res: error.message,
              });
            });
        })
        .catch(error => {
          props.setErrorPopUp({
            res: error.message,
          });
        });
    } else if (
      props?.seat?.paymentCheck?.loyalty &&
      (props.seat?.paymentCheck?.giftCard || props.seat?.paymentCheck?.giftCards?.length > 0) &&
      !props.seat?.paymentCheck?.offer
    ) {
      dataToSendForGiftCard = {
        ...dataToSendForGiftCard,
        giftCard: props.seat?.paymentCheck?.giftCard || props.seat?.paymentCheck?.giftCards?.[0],
        paymentCheck: props?.seat?.paymentCheck,
        paymentChecks: props?.seat?.paymentChecks,
      };
      props
        .giftCardDeleteBalance(dataToSendForGiftCard)
        .then(res => {
          props.setSeat({
            ...props.seat,
            paymentCheck: res.paymentCheck,
            paymentChecks: res.paymentChecks,
          });
          dataToSendLoyaltyDelet = {
            ...dataToSendLoyaltyDelet,
            totalAmount: res.paymentCheck.totalAmount,
            unpaidAmount: res.paymentCheck.unpaidAmount,
            paidAmount: res.paymentCheck.paidAmount,
            paymentCheck: res.paymentCheck,
            paymentChecks: res.paymentChecks,
            loyalty: res?.paymentCheck?.loyalty,
          };
          props.deleteLoyalty('', dataToSendLoyaltyDelet);
          tipInfo && TipAmountOnTipValue();
          setPaymentType(
            hasAutoGratuity
              ? isAutoGratuityPresent
                ? 4
                : 28
              : tipInfo
                ? 4
                : 28
          );
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams('splitValue')}&screenType=${hasAutoGratuity
              ? isAutoGratuityPresent
                ? 4
                : 28
              : tipInfo
                ? 4
                : 28
            }&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        })
        .catch(error => {
          props.setErrorPopUp({
            res: error.message,
          });
        });
    } else if (
      props?.seat?.paymentCheck?.loyalty &&
      props?.seat?.paymentCheck?.offer
    ) {
      dataToSendForDeleteOffer = {
        ...dataToSendForDeleteOffer,
        offer: props?.seat?.paymentCheck?.offer,
        paymentCheck: props?.seat?.paymentCheck,
        paymentChecks: props?.seat?.paymentChecks,
      };
      props
        .handleDeleteOffer(dataToSendForDeleteOffer)
        .then(res => {
          props.setSeat({
            ...props.seat,
            paymentCheck: res.paymentCheck,
            paymentChecks: res.paymentChecks,
          });
          dataToSendLoyaltyDelet = {
            ...dataToSendLoyaltyDelet,
            totalAmount: res.paymentCheck.totalAmount,
            unpaidAmount: res.paymentCheck.unpaidAmount,
            paidAmount: res.paymentCheck.paidAmount,
            paymentCheck: res.paymentCheck,
            paymentChecks: res.paymentChecks,
            loyalty: res?.paymentCheck?.loyalty,
          };
          props.deleteLoyalty('', dataToSendLoyaltyDelet);
          tipInfo && TipAmountOnTipValue();
          setPaymentType(
            hasAutoGratuity
              ? isAutoGratuityPresent
                ? 4
                : 28
              : tipInfo
                ? 4
                : 28
          );
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams('splitValue')}&screenType=${hasAutoGratuity
              ? isAutoGratuityPresent
                ? 4
                : 28
              : tipInfo
                ? 4
                : 28
            }&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        })
        .catch(error => {
          props.setErrorPopUp({
            res: error.message,
          });
        });
    } else if (
      props?.seat?.paymentCheck?.loyalty &&
      !props?.seat?.paymentCheck?.offer
    ) {
      dataToSendLoyaltyDelet = {
        ...dataToSendLoyaltyDelet,
        totalAmount: props?.seat?.paymentCheck.totalAmount,
        unpaidAmount: props?.seat?.paymentCheck.unpaidAmount,
        paidAmount: props?.seat?.paymentCheck.paidAmount,
        paymentCheck: props?.seat?.paymentCheck,
        paymentChecks: props?.seat?.paymentChecks,
        loyalty: props?.seat?.paymentCheck?.loyalty,
      };
      props.deleteLoyalty('', dataToSendLoyaltyDelet);
      tipInfo && TipAmountOnTipValue();
      setPaymentType(
        hasAutoGratuity ? (isAutoGratuityPresent ? 4 : 28) : tipInfo ? 4 : 28
      );
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
        }?ticketSplitTypeId=${urlSearchParams(
          'ticketSplitTypeId'
        )}&splitValue=${urlSearchParams('splitValue')}&screenType=${hasAutoGratuity ? (isAutoGratuityPresent ? 4 : 28) : tipInfo ? 4 : 28
        }&type=${urlSearchParams('type')}`,
        { replace: true }
      );
    } else if (
      !props?.seat?.paymentCheck?.loyalty &&
      props?.seat?.paymentCheck?.offer
    ) {
      dataToSendForDeleteOffer = {
        ...dataToSendForDeleteOffer,
        offer: props?.seat?.paymentCheck?.offer,
        paymentCheck: props?.seat?.paymentCheck,
        paymentChecks: props?.seat?.paymentChecks,
      };
      props
        .handleDeleteOffer(dataToSendForDeleteOffer)
        .then(res => {
          props.setSeat({
            ...props.seat,
            paymentCheck: res.paymentCheck,
            paymentChecks: res.paymentChecks,
          });
          tipInfo && TipAmountOnTipValue();
          setPaymentType(
            hasAutoGratuity
              ? isAutoGratuityPresent
                ? 4
                : 28
              : tipInfo
                ? 4
                : 28
          );
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams('splitValue')}&screenType=${hasAutoGratuity
              ? isAutoGratuityPresent
                ? 4
                : 28
              : tipInfo
                ? 4
                : 28
            }&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        })
        .catch(error => {
          props.setErrorPopUp({
            res: error.message,
          });
        });
    } else if (props?.seat?.paymentCheck?.giftCard || props?.seat?.paymentCheck?.giftCards?.length > 0) {
      dataToSendForGiftCard = {
        ...dataToSendForGiftCard,
        giftCard: props.seat?.paymentCheck?.giftCard || props.seat?.paymentCheck?.giftCards?.[0],
        paymentCheck: props?.seat?.paymentCheck,
        paymentChecks: props?.seat?.paymentChecks,
      };
      props
        .giftCardDeleteBalance(dataToSendForGiftCard)
        .then(res => {
          props.setSeat({
            ...props.seat,
            paymentCheck: res.paymentCheck,
            paymentChecks: res.paymentChecks,
          });
          tipInfo && TipAmountOnTipValue();
          setPaymentType(
            hasAutoGratuity
              ? isAutoGratuityPresent
                ? 4
                : 28
              : tipInfo
                ? 4
                : 28
          );
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams('splitValue')}&screenType=${hasAutoGratuity
              ? isAutoGratuityPresent
                ? 4
                : 28
              : tipInfo
                ? 4
                : 28
            }&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        })
        .catch(error => {
          props.setErrorPopUp({
            res: error.message,
          });
        });
    } else {
      tipInfo && TipAmountOnTipValue();
      setPaymentType(
        hasAutoGratuity ? (isAutoGratuityPresent ? 4 : 28) : tipInfo ? 4 : 28
      );
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
        }?ticketSplitTypeId=${urlSearchParams(
          'ticketSplitTypeId'
        )}&splitValue=${urlSearchParams('splitValue')}&screenType=${hasAutoGratuity ? (isAutoGratuityPresent ? 4 : 28) : tipInfo ? 4 : 28
        }&type=${urlSearchParams('type')}`,
        { replace: true }
      );
    }
  };
  const tipClearBackNav = () => {
    if (props.seat?.paymentCheck?.tip) {
      const payload = {
        deviceId: props.deviceInfo.deviceId,
        employeeId: Number(props.userInfo.id),
        employeeCard: props.userInfo.employeeCard,
        checkHeaderId: tableData?.id,
        storeId: props.deviceInfo.storeId,
        paymentCheck: props?.seat?.paymentCheck,
        paymentChecks: props?.seat?.paymentChecks,
        tip: props.seat?.paymentCheck?.tip,
      };
      props.tipClear(payload).then(res => {
        props.setSeat({
          ...props.seat,
          paymentCheck: res.paymentCheck,
          paymentChecks: res.paymentChecks,
        });
        props.setPaymentCheck({
          ...props.paymentCheck,
          paymentCheck: res.paymentCheck,
          paymentChecks: res.paymentChecks,
        });
        setTotalVisible({
          amount: true,
          percent: false,
        });
        setBtnPrimary({
          isAmount: {
            background: serverAppTheme?.selected,
            color: '#000',
          },
          isPercent: {
            background: 'transparent',
            color: serverAppTheme?.primary_text,
          },
        });
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${tableData.id
          }?ticketSplitTypeId=${Number(
            urlSearchParams('ticketSplitTypeId')
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=28&type=${urlSearchParams('type')}`,
          { replace: true }
        );
        setPaymentType(28);
      });
    } else {
      setTotalVisible({
        amount: true,
        percent: false,
      });
      setBtnPrimary({
        isAmount: {
          background: serverAppTheme?.selected,
          color: '#000',
        },
        isPercent: {
          background: 'transparent',
          color: serverAppTheme?.primary_text,
        },
      });
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${tableData.id
        }?ticketSplitTypeId=${Number(
          urlSearchParams('ticketSplitTypeId')
        )}&splitValue=${urlSearchParams(
          'splitValue'
        )}&screenType=28&type=${urlSearchParams('type')}`,
        { replace: true }
      );
    }
  };
  const handleOrientationOnBackNav = () => {
    if (window.ReactNativeWebView && (isServerApp || isTableTop)) {
      EventEmitter.changeOrientation({
        orientation: 'landscape',
      });
    }
  };
  const handleBackButton = () => {
    let temp = { isShow: false, url: () => { } };
    if (props.speedOrderStatus) {
      return temp;
    }
    if ([4, 9, 10, 12, 16, 28, 31, 32].includes(paymentType)) {
      switch (urlSearchParams('type')) {
        case 'payType':
          if ([4, 28].includes(paymentType)) {
            if ([28].includes(paymentType)) {
              temp = {
                isShow: true,
                url: () => {
                  setPaymentType(1);
                  props.navigate(
                    `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                    }?ticketSplitTypeId=1&splitValue=${urlSearchParams(
                      'splitValue'
                    )}&screenType=1`,
                    { replace: true }
                  );
                },
              };
              break;
            } else {
              temp = {
                isShow: true,
                url: () => {
                  setGiftBalance(0);
                  window.sessionStorage.removeItem('tipAmt');
                  setTipAmount(0);
                  setPaymentType(28);
                  tipClearBackNav();
                },
              };
              break;
            }
          } else {
            const hasGiftCards = [31].includes(paymentType)
              ? (props.seat?.paymentCheck?.giftCards?.length > 0 || props.seat?.paymentCheck?.giftCard)
              : false;
            temp = {
              isShow: !hasGiftCards,
              url: () => {
                setTipAmount(0);
                GiftCardCouponClear();
                props.handleLoyaltyInfo({
                  phoneNumber: null,
                  email: null,
                  type: null,
                });
              },
            };
            break;
          }
        case 'splitType':
          if (
            urlSearchParams('ticketSplitTypeId') === '1' ||
            urlSearchParams('ticketSplitTypeId') === '2' ||
            urlSearchParams('ticketSplitTypeId') === '3' ||
            urlSearchParams('ticketSplitTypeId') === '4'
          ) {
            if (
              urlSearchParams('ticketSplitTypeId') === '2' &&
              ![4, 31, 23, 32].includes(paymentType)
            ) {
              temp = {
                isShow: true,
                url: () => {
                  handleOrientationOnBackNav();
                  setPaymentType(29);
                  props.navigate(
                    `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                    }?ticketSplitTypeId=${urlSearchParams(
                      'ticketSplitTypeId'
                    )}&splitValue=${urlSearchParams(
                      'splitValue'
                    )}&screenType=29&type=${urlSearchParams('type')}`,
                    { replace: true }
                  );
                },
              };
              break;
            } else if (
              urlSearchParams('ticketSplitTypeId') === '3' &&
              ![4, 31, 23, 32, 9].includes(paymentType)
            ) {
              temp = {
                isShow: true,
                url: () => {
                  handleOrientationOnBackNav();
                  setPaymentType(9);
                  props.navigate(
                    `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                    }?ticketSplitTypeId=${urlSearchParams(
                      'ticketSplitTypeId'
                    )}&splitValue=${urlSearchParams(
                      'splitValue'
                    )}&screenType=9&type=${urlSearchParams('type')}`,
                    { replace: true }
                  );
                },
              };
              break;
            } else if (
              urlSearchParams('ticketSplitTypeId') === '4' &&
              ![4, 31, 23, 32].includes(paymentType)
            ) {
              temp = {
                isShow: true,
                url: () => {
                  handleOrientationOnBackNav();
                  setPaymentType(30);
                  props.navigate(
                    `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                    }?ticketSplitTypeId=${urlSearchParams(
                      'ticketSplitTypeId'
                    )}&splitValue=${urlSearchParams(
                      'splitValue'
                    )}&screenType=30&type=${urlSearchParams('type')}`,
                    { replace: true }
                  );
                },
              };
              break;
            } else if (
              (urlSearchParams('ticketSplitTypeId') === '2' ||
                urlSearchParams('ticketSplitTypeId') === '3' ||
                urlSearchParams('ticketSplitTypeId') === '4') &&
              [4, 31, 23, 32, 9].includes(paymentType)
            ) {
              if (urlSearchParams('screenType') === '4') {
                if (
                  getObjectValue(
                    () => props.auth?.loyaltyInfo?.supportsLoyalty,
                    false
                  )
                ) {
                  temp = {
                    isShow: true,
                    url: () => {
                      props.navigate(
                        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck?.id
                        }?ticketSplitTypeId=${urlSearchParams(
                          'ticketSplitTypeId'
                        )}&splitValue=${urlSearchParams(
                          'splitValue'
                        )}&screenType=28&type=${urlSearchParams('type')}`,
                        { replace: true }
                      );
                      window.sessionStorage.removeItem('tipAmt');
                      setPaymentType(28);
                      setTipAmount(0);
                      tipClearBackNav();
                    },
                  };
                  break;
                } else {
                  temp = {
                    isShow: true,
                    url: () => {
                      setGiftBalance(0);
                      window.sessionStorage.removeItem('tipAmt');
                      setTipAmount(0);
                      setPaymentType(28);
                      tipClearBackNav();
                    },
                  };
                  break;
                }
              } else if (urlSearchParams('screenType') === '31' || urlSearchParams('screenType') === '32') {
                // Hide back button if gift cards are applied for screenType 31
                const hasGiftCards = urlSearchParams('screenType') === '31'
                  ? (props.seat?.paymentCheck?.giftCards?.length > 0 || props.seat?.paymentCheck?.giftCard)
                  : false;
                temp = {
                  isShow: !hasGiftCards,
                  url: () => {
                    setTipAmount(0);
                    GiftCardCouponClear();
                  },
                };
                break;
              } else if (urlSearchParams('screenType') === '23') {
                const handleAsyncUrl = async () => {
                  try {
                    await handleCreditCardDeleteBalance(); // Wait for the API call to complete
                    props.toggleOtherPaymentOption();
                    props.navigate(
                      `${APP_CONFIG.BASE_URL}/receipt/${tableData.id
                      }?ticketSplitTypeId=${Number(
                        urlSearchParams('ticketSplitTypeId')
                      )}&splitValue=${urlSearchParams(
                        'splitValue'
                      )}&screenType=31&type=${urlSearchParams('type')}`,
                      { replace: true }
                    );
                    setPaymentType(31);
                  } catch (error) {
                    // Handle error
                  }
                };
                temp = {
                  isShow: true,
                  url: handleAsyncUrl(),
                };
                break;
              } else if (urlSearchParams('screenType') === '9') {
                temp = {
                  isShow: true,
                  url: () => {
                    const previousSeatObj = JSON.parse(
                      window.sessionStorage.getItem('seat')
                    );
                    const isClearSplitEnable =
                      previousSeatObj?.control?.enableClearSplits;
                    if (isClearSplitEnable) {
                      onClearSplit();
                    } else {
                      setPaymentType(1);
                      props.navigate(
                        `${APP_CONFIG.BASE_URL}/receipt/${tableData.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`,
                        { replace: true }
                      );
                    }
                  },
                };
                break;
              }
            } else {
              if (urlSearchParams('screenType') === '4') {
                if (
                  getObjectValue(
                    () => props.auth?.loyaltyInfo?.supportsLoyalty,
                    false
                  )
                ) {
                  temp = {
                    isShow: true,
                    url: () => {
                      props.setPaymentFlowType(2);
                      window.sessionStorage.removeItem('tipAmt');
                      setTipAmount(0);
                      tipClearBackNav();
                    },
                  };
                  break;
                } else {
                  temp = {
                    isShow: true,
                    url: () => {
                      setGiftBalance(0);
                      window.sessionStorage.removeItem('tipAmt');
                      setTipAmount(0);
                      setPaymentType(28);
                      tipClearBackNav();
                    },
                  };
                  break;
                }
              } else if (urlSearchParams('screenType') === '31' || urlSearchParams('screenType') === '32') {
                // Hide back button if gift cards are applied for screenType 31
                const hasGiftCards = urlSearchParams('screenType') === '31'
                  ? (props.seat?.paymentCheck?.giftCards?.length > 0 || props.seat?.paymentCheck?.giftCard)
                  : false;
                if (tipInfo) {
                  temp = {
                    isShow: !hasGiftCards,
                    url: () => {
                      setTipAmount(0);
                      GiftCardCouponClear();
                      setPaymentType(4);
                      props.navigate(
                        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                        }?ticketSplitTypeId=${urlSearchParams(
                          'ticketSplitTypeId'
                        )}&splitValue=${urlSearchParams(
                          'splitValue'
                        )}&screenType=4&type=${urlSearchParams('type')}`,
                        { replace: true }
                      );
                    },
                  };
                  break;
                } else if (
                  getObjectValue(
                    () => props.auth?.loyaltyInfo?.supportsLoyalty,
                    false
                  )
                ) {
                  temp = {
                    isShow: !hasGiftCards,
                    url: () => {
                      props.setPaymentFlowType(2);
                      window.sessionStorage.removeItem('tipAmt');
                      setTipAmount(0);
                      tipClearBackNav();
                    },
                  };
                  break;
                } else {
                  temp = {
                    isShow: !hasGiftCards,
                    url: () => {
                      setPaymentType(28);
                      props.navigate(
                        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                        }?ticketSplitTypeId=${urlSearchParams(
                          'ticketSplitTypeId'
                        )}&splitValue=${urlSearchParams(
                          'splitValue'
                        )}&screenType=28&type=${urlSearchParams('type')}`,
                        { replace: true }
                      );
                    },
                  };
                  break;
                }
              } else if (urlSearchParams('screenType') === '23') {
                if ([23].includes(paymentType)) {
                  const handleAsyncUrl = async () => {
                    try {
                      await handleCreditCardDeleteBalance(); // Wait for the API call to complete
                      props.toggleOtherPaymentOption();
                      props.navigate(
                        `${APP_CONFIG.BASE_URL}/receipt/${tableData.id
                        }?ticketSplitTypeId=${Number(
                          urlSearchParams('ticketSplitTypeId')
                        )}&splitValue=${urlSearchParams(
                          'splitValue'
                        )}&screenType=31&type=${urlSearchParams('type')}`,
                        { replace: true }
                      );
                      setPaymentType(31);
                    } catch (error) { }
                  };
                  temp = {
                    isShow: true,
                    url: handleAsyncUrl(),
                  };
                  break;
                }
              }
            }
          }
          break;
        case 'cash': {
          temp = {
            isShow: true,
            url: () => {
              setPaymentType(1);
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${tableData?.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`,
                { replace: true }
              );
            },
          };
          break;
        }
        case 'payAnAmount':
        case 'split': {
          switch (urlSearchParams('source')) {
            case 'stageSplit':
              temp = {
                isShow: true,
                url: () => {
                  window.sessionStorage.removeItem('tipAmt');
                  props.navigate(
                    `${APP_CONFIG.BASE_URL}/stage/${tableData.id}`,
                    { replace: true }
                  );
                },
              };
              break;
            default:
              temp = {
                isShow: true,
                url: () => {
                  setPaymentType(1);
                  props.navigate(
                    `${APP_CONFIG.BASE_URL}/receipt/${tableData.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`,
                    { replace: true }
                  );
                },
              };
              break;
          }
        }
        default:
          break;
      }
    }
    return temp;
  };

  const getTotalAmountForTip = () => {
    const splitVal = urlSearchParams('splitValue');
    const ticketSplitTypeId = urlSearchParams('ticketSplitTypeId');
    let Amount = getObjectValue(() => tableData?.subTotalAmount, 0);
    let v = 0;
    if (splitVal > 1) {
      tableData?.items.forEach(i => {
        if (!props.menuItemsHashTable[i.menuItemId]?.excludeFromTip) {
          v = v + i.price / Number(splitVal || 1).toFixed(2);
        }
      });
      Amount = v;
    } else {
      tableData?.items?.forEach(i => {
        if (props.menuItemsHashTable[i.menuItemId]?.excludeFromTip) {
          if (ticketSplitTypeId === '2') {
            let price = (i.price / (tableData?.itemAmount || 1)) * Amount;
            v += price;
          } else if (!props?.isOfflineVoid) {
            v += i.price;
          }
        }
      });
      Amount = Amount - v;
    }

    if (props?.auth?.tipInfo?.suggestedTipExcludesDiscount === false) {
      Amount += tableData?.discountAmount;
      if (Amount < 0) {
        Amount = 0;
      }
    }
    if (
      getObjectValue(() => props.auth.tipInfo.suggestedTipIncludesTax, false)
    ) {
      Amount += tableData?.taxAmount;
      if (Amount < 0) {
        Amount = 0;
      }
    }
    if (externalId && urlSearchParams('type') === 'stage') {
      Amount += tableData?.taxAmount;
    }
    if (urlSearchParams('externalCreditCard')) {
      Amount += tableData?.taxAmount;
    }
    return Amount > 0 ? Amount.toFixed(2) : 0;
  };

  const SeatIds = () => {
    return tableData.seats.reduce((a, v) => {
      if (v.open) a.push(v.id);
      return a;
    }, []);
  };

  const handlePrint = () => {
    let giftCardPayent = safeJsonParse(window.sessionStorage.getItem('giftCardpayment'), false);
    let dataToSend = {
      deviceId: props.deviceInfo?.deviceId,
      employeeId: Number(props.userInfo?.id),
      storeId: props.deviceInfo?.storeId,
      paymentCheck: props.seat?.paymentCheck,
      checkHeaderId: props?.seat?.checkHeaderId || props?.seat?.id,
      ticketId:
        props?.seat?.paymentCheck?.cashTicketId ||
        props?.seat?.paymentCheck?.creditCardTicketId ||
        props?.seat?.paymentCheck?.giftCardTicketIds?.[0] ||
        props?.seat?.paymentCheck?.giftCardTicketId,
      receipt: {
        emailAddress: null,
        countryCode,
        phoneNumber: null,
        ticketId:
          props?.seat?.paymentCheck?.cashTicketId ||
          props?.seat?.paymentCheck?.creditCardTicketId ||
          props?.seat?.paymentCheck?.giftCardTicketIds?.[0] ||
          props?.seat?.paymentCheck?.giftCardTicketId,
      },
    };
    if (giftCardPayent) {
      dataToSend.cardIds = props.seat?.cards?.map(s => s.id);
    }
    props
      .receiptPrint(dataToSend, giftCardPayent)
      .then(res => {
        setGiftCardPaymentReceipt(true);
        setGiftCardReceiptModal({ isOpen: false, show: false });
        if (!res?.printerAgentBased) {
          if (window.ReactNativeWebView) {
            if (res?.printJobs?.length > 0) {
              const dataToSend = {
                check: null,
                checkHeaderId: 0,
                control: null,
                loyalty: null,
                paymentCheck: null,
                paymentChecks: null,
                bytes: res?.printJobs[0]?.bytes,
                printJobs: [],
                printerIpAddress: res?.printJobs[0]?.printerIpAddress,
                printerName: res?.printJobs[0]?.printerName,
                printerPort: res?.printJobs[0]?.printerPort,
              };
              EventEmitter.print(dataToSend);
            } else {
              const dataToSend = {
                check: null,
                checkHeaderId: 0,
                control: null,
                loyalty: null,
                paymentCheck: null,
                paymentChecks: null,
                bytes: res?.bytes,
                printJobs: [],
                printerIpAddress: res?.printerIpAddress,
                printerName: res?.printerName,
                printerPort: res?.printerPort,
              };
              EventEmitter.print(dataToSend);
            }
          }
        }
        props.setPrintNotification(res);
        if (isPaymentTerminal || isServerApp) {
          if (lockPaymentScreen) {
            setHideCancelIcon(false);
          }
        } else {
          setPaymentType(6);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=6&type=${urlSearchParams('type')}`,
            { replace: true }
          );
          if (lockPaymentScreen) {
            setHideCancelIcon(false);
          }
        }
        // else {
        //   props.navigate(`${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`, {
        //     replace: true,
        //   });
        //   if (lockPaymentScreen) {
        //     setHideCancelIcon(false);
        //   }
        // }
        if (!giftCardPayent) {
          setsmsEmailPrintObject(prev => ({
            ...prev,
            printReceiptStatus: !smsEmailPrintObject.printReceiptStatus,
          }));
        }
      })
      .catch(err => {
        setGiftCardReceiptModal({ isOpen: false, show: true });
        setGiftCardPaymentReceipt(false);
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };
  const getTipAmountForPayButton = authInfo => {
    let calculatedTipAmount = tableData.subTotalAmount;
    const unPaidAmountForTip = props.seat?.paymentCheck?.unpaidAmount;
    const tipAmount = props.seat?.paymentCheck?.totalAmount;

    if (authInfo?.suggestedTipExcludesDiscount === false) {
      calculatedTipAmount += tableData?.discountAmount;
      if (calculatedTipAmount < 0) {
        calculatedTipAmount = 0;
      }
    }
    if (authInfo?.suggestedTipIncludesTax === true) {
      calculatedTipAmount += tableData?.taxAmount;
      if (calculatedTipAmount < 0) {
        calculatedTipAmount = 0;
      }
    }

    if (
      unPaidAmountForTip > 0 &&
      unPaidAmountForTip != tableData?.totalAmount
    ) {
      calculatedTipAmount = (
        (Number(unPaidAmountForTip) / Number(tableData?.totalAmount)) *
        Number(tipAmount)
      )?.toFixed(2);
    }
    return Number(calculatedTipAmount);
  };
  const handleTipCalculation = (item, tips, totalAmount) => {
    const ruleType = props.auth?.tipInfo?.ruleType || 1;
    const selectedTip = tips.find(tip => item === tip.key);

    let tipAmount = 0,
      paymentAmount = 0;
    if (selectedTip) {
      tipAmount =
        ruleType === 1
          ? ((totalAmount * selectedTip?.key) / 100).toFixed(2)
          : +selectedTip.key?.toFixed(2);
      paymentAmount = (Number(tipAmount) + Number(totalAmount)).toFixed(2);
    } else {
      tipAmount =
        ruleType === 1
          ? ((totalAmount * tips[1].key) / 100).toFixed(2)
          : +tips[1].key.toFixed(2);
      paymentAmount = Number(tableData?.unpaidAmount).toFixed(2);
    }

    return { tipAmount, paymentAmount };
  };
  const handleTip = item => {
    const totalAmount = getTipAmountForPayButton(
      hasAutoGratuity ? props?.auth?.autoGratuityTipInfo : props?.auth?.tipInfo
    );
    setActive(item);
    const { tipAmount, paymentAmount } = handleTipCalculation(
      item,
      hasAutoGratuity ? autoGratuityStoreTips : storeTips,
      totalAmount
    );
    setTipAmount(tipAmount);
    setPaymentAmount(paymentAmount);
    if (
      item === `${LABEL().CUSTOM_AMOUNT}` ||
      item === `${LABEL().CUSTOM_PERCENT}`
    ) {
      setCustomTipModelOpen(true);
    }
  };

  const handleBackButtonClick = () => {
    const previousSeatObj = JSON.parse(window.sessionStorage.getItem('seat'));
    previousSeatObj.splits = [];
    previousSeatObj.paymentStages = [];
    props.setSeat(previousSeatObj);
    const redirect = () => {
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.seat?.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`,
        { replace: true }
      );
      setPaymentType(1);
    };
    redirect();
  };

  const handleSplitLyltSubmit = (data) => {
    if (data === 0) {
      if (window.ReactNativeWebView) {
        if (!isLandScape) {
          EventEmitter.changeOrientation({
            orientation: 'portrait',
          });
        } else {
          EventEmitter.changeOrientation({
            orientation: 'landscape',
          });
        }
      }
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
        }?ticketSplitTypeId=${Number(
          urlSearchParams('ticketSplitTypeId')
        )}&splitValue=${urlSearchParams(
          'splitValue'
        )}&screenType=28&type=payType`,
        { replace: true }
      );
    } else {
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.seat.id
        }?ticketSplitTypeId=${urlSearchParams(
          'ticketSplitTypeId'
        )}&splitValue=1&screenType=28&type=splitType`,
        { replace: true }
      );
    }
    setPaymentType(28);
    setNewOfferPopUp(false);
  };

  const handleSplitCancel = () => {
    props.navigate(`${APP_CONFIG.BASE_URL}/serverApp/checks`, {
      replace: true,
    });
    setNewOfferPopUp(false);
  }

  const handleSplitPayment = (dataToSend, isStagePaymentSubmit, isCross) => {
    props
      .paymentSplitCheck(dataToSend)
      .then(res => {
        const syncedCheck = res?.check || data;
        let updatedData = {
          ...syncedCheck,
          control: res?.control,
          checkHeaderId: res?.checkHeaderId,
          storeId: res?.storeId,
          giftCard: res?.giftCard,
          offer: res?.offer,
          paymentCheck: res?.paymentCheck,
          paymentChecks: res?.paymentChecks,
          availableLoyaltyOffers: res?.availableLoyaltyOffers,
          check: res?.check,
        };
        props.setSeat(updatedData);
        props.setPaymentCheck(updatedData);
        if (isStagePaymentSubmit) {
          if (isCross) {
            props.navigate(`${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`);
          } else {
            if (Object.keys(res?.availableLoyaltyOffers).length === 0) {
              handleSplitLyltSubmit(res?.paymentChecks[0]?.splitType);
            } else {
              setNewOfferPopUp(true);
            }
          }
        }
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };
  const handleStagePaymentSubmit = ({
    payload,
    isSplitEvenly,
    isSplitBySelectedSeat,
    isCross,
  }) => {
    if (
      props.seat.paymentStages.length === 0 &&
      !isSplitEvenly &&
      !isSplitBySelectedSeat
    ) {
      props.setErrorPopUp({
        res: CUSTOM_MESSAGES().NO_STAGE_MSG,
      });
    } else if (
      props.seat.unpaidAmount === 0 &&
      !isSplitEvenly &&
      !isSplitBySelectedSeat
    ) {
      props.setErrorPopUp({
        res: CUSTOM_MESSAGES().NO_ITEM_MSG,
      });
    } else {
      const isStagePaymentSubmit = true;
      handleSplitPayment(payload, isStagePaymentSubmit, isCross);
    }
  };
  useEffect(() => {
    const occupiedSeats = reqSeatIds(props?.seat?.splits);
    setAvailableSeats(occupiedSeats?.flat());
  }, [props.seat]);
  const reqSeatIds = array => {
    return array.map(e => {
      return e?.seats?.map(d => {
        return d.seatId;
      });
    });
  };
  const seatId = array => {
    return array.map(e => {
      return e.id;
    });
  };
  const occupySeats = [...availableSeats];
  let dutchSplitsData = [];
  const goingDutch = availSeats => {
    let seats = JSON.parse(window.sessionStorage.getItem('seat'))?.seats;
    let seat = JSON.parse(window.sessionStorage.getItem('seat'));
    const remainingSeatsToDutch = differenceWith(
      seatId(seats?.filter(e => e.open)),
      availSeats,
      isEqual
    );
    occupySeats.push(remainingSeatsToDutch[0]);
    const { splits } = JSON.parse(window.sessionStorage.getItem('seat'));
    const filteredSplits = splits?.filter(el => el.splitType !== 0);
    window.sessionStorage.setItem(
      'seat',
      JSON.stringify({ ...seat, splits: filteredSplits })
    );
    const dataObj = {
      id: generateRandomString(8),
      name: '',
      number: splits?.length || 0,
      status: 0,
      seats: [{ seatId: remainingSeatsToDutch[0] }],
    };
    dutchSplitsData.push(dataObj);
    return (
      remainingSeatsToDutch.length > 0 &&
      props.updateWithPaymentStages([dataObj]).then(() => {
        return remainingSeatsToDutch.length > 0 && goingDutch(occupySeats);
      })
    );
  };
  const handleSplitBySeat = () => {
    goingDutch(availableSeats);
    setPaymentType(29);
    props.navigate(
      `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
      }?ticketSplitTypeId=2&splitValue=${urlSearchParams(
        'splitValue'
      )}&screenType=29&type=splitType`,
      { replace: true }
    );
  };
  const handleStageSelection = data => {
    setSplitTableData({
      ...splitTableData,
      paymentStages: seatItemHashTable,
      splits: seatItemHashTable,
    });
    if (selectedStage !== data.id) {
      setSelectedStage(data.id);
    } else {
      setSelectedStage('');
    }
  };

  useEffect(() => {
    if (
      tableData?.splits &&
      Object.values(tableData.splits).length > 0 &&
      !selectedStage
    ) {
      const firstValidSplit = Object.values(tableData.splits).find(
        split => Number(split.status) === 0
      );
      if (firstValidSplit) {
        setSelectedStage(firstValidSplit.id);
      }
    }
  }, [tableData?.splits]);

  const handleItemSelection = data => {
    setSplitTableData({
      ...splitTableData,
      paymentStages: seatItemHashTable,
      splits: seatItemHashTable,
    });
    if ([selectedItem].some(e => e.id !== data.id)) {
      setSelectedItem(data);
    } else {
      setSelectedItem({});
    }
  };
  const handleCheckAllItems = isCheck => {
    let updatedCheck = splitTableData.splits[selectedStage]?.items?.map(el => ({
      ...el,
      isCheck,
    }));
    splitTableData.splits[selectedStage].items = updatedCheck;
    setSplitTableData({
      ...splitTableData,
    });
  };

  const handleCheckItems = (data, isCheck, index) => {
    splitTableData.splits[selectedStage].items[index] = {
      ...data,
      isCheck,
    };
    setSplitTableData({
      ...splitTableData,
    });
    setSelectedItem({});
  };

  const handleStageMove = data => {
    if (data === splitSeat || data === splitSelectedSeat) {
      setSeatMove(data);
    }

    setMoveModalOpen(true);
  };

  const handleCardSelection = data => {
    if (
      selectedSeats.indexOf(data) === -1 &&
      selectedSeats.includes('allStages')
    ) {
      setSelectedSeats([data]);
    } else if (
      selectedSeats.indexOf(data) === -1 &&
      !selectedSeats.includes('allStages')
    ) {
      setSelectedSeats(selectedSeats.concat(data));
    } else {
      setSelectedSeats(selectedSeats.filter(x => x !== data));
    }
    if (data === 'allStages') {
      selectedSeats.indexOf(data) === -1
        ? setSelectedSeats(['allStages'])
        : setSelectedSeats([]);
    }
  };
  const handleMove = () => {
    setMoveModalOpen(false);
    submitMove();
    setSelectedSeats([]);
  };

  const handleCancel = () => {
    setMoveModalOpen(false);
    setSelectedSeats([]);
  };

  const getSelectedStageSeatIds = () => {
    return selectedSeats.reduce((a, v) => {
      if (v.seats.length > 0) {
        a.push(...v.seats.map(e => e.seatId));
      }
      return a;
    }, []);
  };

  const getCheckItemSeats = () => {
    return splitTableData.splits[selectedStage].items.reduce((a, v) => {
      if (v?.isCheck && !v?.discount && !v?.service) {
        a.push({
          checkItemId: v.id,
        });
      }
      return a;
    }, []);
  };

  const discountItemId = () => {
    const discountElement = splitTableData?.splits[
      selectedStage
    ]?.items?.reduce((a, v) => {
      if (v.isCheck && v.discount) {
        a.push({
          checkDiscountId: v.id,
        });
      }
      return a;
    }, []);

    if (selectedItem?.discount) {
      return [{ checkDiscountId: selectedItem?.id }];
    } else if (discountElement?.length > 0) {
      return discountElement;
    } else {
      return [];
    }
  };

  const serviceItemId = () => {
    const serviceElement = splitTableData?.splits[selectedStage]?.items?.reduce(
      (a, v) => {
        if (v.isCheck && v.service) {
          a.push({
            checkServiceChargeId: v.id,
          });
        }
        return a;
      },
      []
    );

    if (selectedItem?.service) {
      return [{ checkServiceChargeId: selectedItem?.id }];
    } else if (serviceElement?.length > 0) {
      return serviceElement;
    } else {
      return [];
    }
  };

  const checkItemSeat = () => {
    if (selectedItem.service || selectedItem.discount) {
      return [];
    }
    return splitTableData.splits[selectedStage].items.filter(e => e.isCheck)
      .length > 0
      ? getCheckItemSeats()
      : [{ checkItemId: selectedItem.id }];
  };

  const submitMove = () => {
    if (
      props?.seat?.splits?.some(el => String(el?.id)?.indexOf('id_') !== -1)
    ) {
      createSplitApiCall(moveApiCall);
    } else {
      moveApiCall();
    }
  };

  const moveApiCall = (val, cb, control) => {
    const datatosend = {
      storeId: props?.deviceInfo?.storeId,
      deviceId: props?.deviceInfo?.deviceId,
      employeeId: props?.userInfo?.id,
      checkHeaderId: props?.seat?.id,
      employeeCard: props?.userInfo?.employeeCard,
      seatIds: selectedSeats.includes('allStages')
        ? []
        : getSelectedStageSeatIds(),
      checkItemSeats: checkItemSeat(),
      checkDiscountSeats: discountItemId(),
      checkServiceChargeSeats: serviceItemId(),
      stationId: props.seat?.stationId,
    };

    props
      .moveChecks(datatosend)
      .then(res => {
        const updatedData = {
          ...res,
          control: control || props.seat?.control || {},
        };
        props.updateChecksAfterResponse(updatedData);
        props.setSeat(updatedData);
        setSelectedItem([]);

        props.showSuccessCheckMark();
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const getEditedTableName = splitId => {
    const splitsArr = tableData?.splits || [];
    const seatData = splitsArr && Object.values(splitsArr);

    const requiredSplit = seatData?.find(el => el.id === splitId);

    return requiredSplit?.name || null;
  };

  const createSplitApiCall = (cb = () => { }, val) => {
    let splitId = 2;
    let splitsToSend = [];
    const splits = ['29', '30'].includes(urlSearchParams('screenType'))
      ? props.seat?.splits || []
      : val?.splits || [];
    const splitFromSession = JSON.parse(window.sessionStorage.getItem('seat'))
      ?.splits;
    if (urlSearchParams('screenType') === '30') {
      splitsToSend = splits
        ?.filter(el => el.splitType !== 0)
        ?.map(el => {
          const seatsToSend = el?.seats?.map(val => val.seatId);
          const checkSplitId = String(el?.id)?.includes('id') ? null : el?.id;
          return {
            checkSplitId: checkSplitId,
            name: getEditedTableName(el?.id),
            seatIds: seatsToSend,
            checkLoyaltyId:
              loyaltyList?.length <= 1 ? loyaltyList[0]?.id : selectedLoyalty?.id,
          };
        });
    } else if (urlSearchParams('screenType') === '29') {
      splitId = 1;
      splitsToSend = splitFromSession
        ?.filter(el => el.splitType !== 0)
        ?.map(el => {
          const seatsToSend = [el?.seats[0]?.seatId];
          const checkSplitId = String(el?.id)?.includes('id') ? null : el?.id;
          return {
            checkSplitId: checkSplitId,
            name: getEditedTableName(el?.id),
            seatIds: seatsToSend,
            checkLoyaltyId:
              loyaltyList?.length <= 1 ? loyaltyList[0]?.id : selectedLoyalty?.id,
          };
        });
    }

    const payload = {
      storeId: props.deviceInfo?.storeId,
      deviceId: props.deviceInfo?.deviceId,
      employeeId: props.seat?.employeeId,
      employeeCard: null,
      checkHeaderId: props.seat?.id,
      splitType: splitId,
      splits: splitsToSend,
    };
    props
      .paymentSplitCheck(payload)
      .then(res => {
        const syncedCheck = res?.check || data;
        let updatedData = {
          ...syncedCheck,
          control: res?.control,
          checkHeaderId: res?.checkHeaderId,
          storeId: res?.storeId,
          giftCard: res?.giftCard,
          offer: res?.offer,
          paymentCheck: res?.paymentCheck,
          paymentChecks: res?.paymentChecks,
        };
        props.setSeat(updatedData);

        if (cb instanceof Function) {
          cb(val && val, () => { }, res?.control);

          if (urlSearchParams('ticketSplitTypeId') === '2') {
            props.showSuccessCheckMark();
          }
        } else {
          props.showSuccessCheckMark();
        }
      })
      .catch(err => {
        props.setErrorPopUp({
          errorMsg: err.message,
        });
      });
  };

  const onChangeTipPersent = (checkboxactive, value) => {
    if (checkboxactive && value != 0) {
      const totalAmountForTip = getTotalAmountForTip();
      const totalAmount = getTipAmount(totalAmountForTip);
      const tipamt = ((totalAmount * Number(value)) / 100).toFixed(2);
      const payAmt = (Number(tipamt) + Number(totalAmount)).toFixed(2);
      const toamount = (tableData?.unpaidAmount + Number(tipamt)).toFixed(2);
      if (Number(toamount.slice(-2)) > 0) {
        const newNumber = parseInt(toamount) + 1;
        const newTotal =
          Number(newNumber) -
          Number(tableData?.unpaidAmount).toFixed(2) -
          Number(tipamt);
        const newTipAMount = Number(tipamt) + Number(newTotal.toFixed(2));
        setTipAmount(newTipAMount);
        setPaymentAmount(payAmt);
        return;
      }
      setTipAmount(tipamt);
      setPaymentAmount(payAmt);
    } else {
      const totalAmountForTip = getTotalAmountForTip();
      const totalAmount = getTipAmount(totalAmountForTip);
      const tipamt = (totalAmount * Number(value)) / 100;
      const payAmt = (Number(tipamt) + Number(totalAmount)).toFixed(2);
      setTipAmount(tipamt);
      setPaymentAmount(payAmt);
    }
  };

  const onChangeTipAmount = (checkboxactive, value) => {
    if (checkboxactive && value != 0) {
      const totalAmountForTip = getTotalAmountForTip();
      const totalAmount = getTipAmount(totalAmountForTip);
      const tipamt = Number(value).toFixed(2);
      const payAmt = (Number(value) + Number(totalAmount)).toFixed(2);
      const toamount = (tableData.unpaidAmount + Number(tipamt)).toFixed(2);
      if (Number(toamount.slice(-2)) > 0) {
        const newNumber = parseInt(toamount) + 1;
        const newTotal =
          Number(newNumber) -
          Number(tableData.unpaidAmount).toFixed(2) -
          Number(tipamt);
        const newTipAMount = Number(tipamt) + Number(newTotal.toFixed(2));
        setTipAmount(newTipAMount);
        setPaymentAmount(payAmt);
        return;
      }
      setTipAmount(tipamt);
      setPaymentAmount(payAmt);
    } else {
      const totalAmount = getTotalAmountForTip();
      const tipamt = Number(value).toFixed(2);
      const payAmt = (Number(value) + Number(totalAmount)).toFixed(2);
      setTipAmount(tipamt);
      setPaymentAmount(payAmt);
    }
  };

  const charityAmountCal = () => {
    const cielValue = Math.ceil(
      tableData &&
      (
        tableData.totalAmount -
        tableData.paidAmount +
        Number(tipAmount)
      ).toFixed(2)
    );
    const tableVal =
      tableData &&
      (
        tableData.totalAmount -
        tableData.paidAmount +
        Number(tipAmount)
      ).toFixed(2);
    return (cielValue - tableVal).toFixed(2);
  };

  const handleCharity = (item, value) => {
    const charityKey = charityList.map(e => e.displayKey);
    if (charityKey.includes(item) && item.includes('.00')) {
      setCharityAmount(Number(item.split(`${LABEL().CURRENCY_SYMBOL}`)[1]));
    } else if (charityKey.includes(item) && item.includes(LABEL().ROUND_UP)) {
      setCharityAmount(charityAmountCal());
    } else if (
      charityKey.includes(item) &&
      item.includes(LABEL().CUSTOM) &&
      value &&
      value.length > 0 &&
      Number(value) > 0
    ) {
      setCharityAmount(value);
    } else {
      setCharityAmount(0);
    }
  };

  const handleButtonClick = (item, value) => {
    setActive(item);
    switch (paymentType) {
      case 4:
        handleTip(item);
        break;
      case 13:
        handleCharity(item, value);
        break;
      default:
        break;
    }
  };

  const handleButtonClickOtherAmount = (item, value) => {
    setTipAmount(0);
    props.seat.paymentCheck &&
      (props.seat.paymentCheck.tipType === 3 ||
        props.seat.paymentCheck.tipType === 4) &&
      setTipAmount(props.seat.paymentCheck.tipAmount);
    setPaymentType(4);
  };

  const renderModifier = modifiersObj =>
    (modifiersObj || []).map(modifier => (
      <div
        style={{ color: '#A8C5FB' }}
        key={modifier.modifierId}
        className="fs-14 fw-500 pl-2"
      >
        {modifier.quantity > 1 && (
          <span className={cn('badge badge-warning ml-1 va-tt')}>
            {modifier.quantity} &times;
          </span>
        )}
        {modifier.modifierName}
        {modifier.price ? (
          <small className="text-muted od-text-muted ml-1">
            {LABEL().CURRENCY_SYMBOL}
            {Number(modifier.price).toFixed(2)}
          </small>
        ) : (
          ''
        )}
        {(modifier.note || modifier.comment) && (
          <div style={{ color: serverAppTheme?.notes }} className="pl-2">
            {modifier.note || modifier.comment}
          </div>
        )}
        {modifier.modifiers &&
          modifier.modifiers.length > 0 &&
          renderModifier(modifier.modifiers)}
      </div>
    ));
  const renderModifierView = (modifiersObj, nest) =>
    (modifiersObj || []).map(modifier => (
      <>
        <div
          key={modifier.modifierId}
          className={cn(
            modifier.price > 0 ? 'fs_14 fw-500 row mx-0 col-12 p-0' : 'd-none'
          )}
        >
          {modifier.quantity >= 1 ? (
            <div
              className={cn(
                'p-0 text-left',
                [1].includes(paymentType) ? 'col-1' : 'col-2'
              )}
              style={{ color: serverAppTheme?.primary_text }}
            >
              {' '}
              <div className={cn('va-tt fs_14 text-center')}>
                {modifier.quantity}
              </div>
            </div>
          ) : (
            <div className="p-0 text-left col-2 px-1"></div>
          )}
          <div
            className={cn(
              [1].includes(paymentType)
                ? 'col-7 p-0 text-left fs_14'
                : 'col-6 p-0 text-left fs_14'
            )}
            style={{ color: serverAppTheme?.primary_text }}
          >
            {modifier.modifierName}
            {modifier.price ? (<span className={cn('col-4 text-left fs_14 px-3')}
              style={{
                color: serverAppTheme?.primary_text,
              }}>
              {LABEL().CURRENCY_SYMBOL}
              {modifier.price.toFixed(2)}
            </span>) : (<span
              className={cn('col-4 text-left fs_14 px-3'
              )}
              style={{
                paddingRight: '0.7rem',
                color: serverAppTheme?.primary_text,
              }}
            >
              {' '}
              $0.00{' '}
            </span>)}
          </div>
          {(modifier.note || modifier.comment) && (
            <div
              className={cn(
                'col-12 row mx-0 pr-0 fs-12',
                [28, 31].includes(paymentType) &&
                  ['payType', 'splitType'].includes(urlSearchParams('type'))
                  ? 'pl-64'
                  : 'pl-30'
              )}
            >
              <span className="col-1">
                <NotesIcon />
              </span>
              <span
                className={cn(
                  'pl-0 col-11 pr-0 fs-14',
                  [28].includes(paymentType) &&
                    urlSearchParams('type') === 'payType'
                    ? 'pl-2'
                    : 'pl-0'
                )}
                style={{ color: '#000' }}
              >
                {modifier.note || modifier.comment}
              </span>
            </div>
          )}
        </div>
        <div>
          {modifier.modifiers && modifier.modifiers.length > 0 && (
            <div>{renderModifierView(modifier.modifiers, true)}</div>
          )}
        </div>
      </>
    ));

  const handleRoute = () => {
    setTipAmount(0);
    setKeyboardValue('');
    setActive('');
    setSuccesMessage('');
    window.sessionStorage.removeItem('loyaltyData');
    window.sessionStorage.removeItem('giftCardReceiptData');
    const authResponse = getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('authResponse')),
      0
    );
    const discount = getObjectValue(
      () => authResponse.checkHeader.discountAmount,
      0
    );
    const serviceCharge = getObjectValue(
      () => authResponse.checkHeader.serviceChargeAmount,
      0
    );
    const subtotalAmount = getObjectValue(
      () => authResponse.checkHeader.itemAmount,
      0
    );
    const taxAmount = getObjectValue(
      () => authResponse.checkHeader.taxAmount,
      0
    );
    const unpaidTips = getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('tipAmt')).unpaidTips,
      0
    );
    const paidTips = getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('tipAmt')).paidTips,
      0
    );
    if (urlSearchParams('ticketSplitTypeId') === '1') {
      if (
        isPaymentTerminal &&
        urlSearchParams('type') === 'stage' &&
        authResponse.checkHeader.paymentStages.filter(d => d.status === 0)
          .length > 0
      ) {
        props.updateSeatInfo(authResponse.checkHeader).then(() => {
          props.clearAuthResponse();
          window.sessionStorage.removeItem('tipAmt');
          if (authResponse.checkHeader.unpaidAmount === 0) {
            props.navigate(`${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`, {
              replace: true,
            });
          } else {
            props.navigate(
              `${APP_CONFIG.BASE_URL}/stagepayment/${tableData.id}`,
              { replace: true }
            );
          }
        });
      } else if (
        urlSearchParams('type') === 'stage' &&
        authResponse.checkHeader.paymentStages.filter(d => d.status === 0)
          .length > 0 &&
        Number(props.seat.stageData.totalAmount).toFixed(2) ===
        Number(authResponse.ticket?.totalAmount).toFixed(2)
      ) {
        props.updateSeatInfo(authResponse.checkHeader).then(() => {
          props.clearAuthResponse();
          window.sessionStorage.removeItem('tipAmt');
          if (authResponse.checkHeader.unpaidAmount === 0) {
            props.navigate(`${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`, {
              replace: true,
            });
          } else {
            props.navigate(
              `${APP_CONFIG.BASE_URL}/stagepayment/${tableData.id}`,
              { replace: true }
            );
          }
        });
      } else if (
        urlSearchParams('type') === 'stage' &&
        Number(props.seat.stageData.totalAmount).toFixed(2) >
        Number(authResponse.ticket?.totalAmount).toFixed(2)
      ) {
        props.setPaymentCheck({
          ...props.seat,
          unpaidTips,
          paidTips,
          paidAmount: props.paymentCheck.totalAmount,
          seats: props.paymentCheck.seats,
          items: props.paymentCheck.items,
          subTotalAmount: props?.seat?.stageData?.subTotalAmount,
          totalAmount: +(
            props.seat.totalAmount - authResponse.ticket?.totalAmount
          ),
        });
        props.updateSeatInfo({
          ...props.seat,
          totalAmount: +(
            props.seat.totalAmount - authResponse.ticket?.totalAmount
          ),
        });
        props.clearAuthResponse();
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${authResponse.checkHeader.id}?ticketSplitTypeId=1&splitValue=1&screenType=2&type=stage`,
          { replace: true }
        );
      } else if (
        urlSearchParams('type') === 'stage' &&
        Number(authResponse.checkHeader.paidAmount) <
        Number(authResponse.checkHeader.totalAmount)
      ) {
        props.setPaymentCheck({
          ...authResponse.checkHeader,
          subtotalAmount,
          unpaidTips,
          paidTips,
        });
        props.updateSeatInfo({ ...authResponse.checkHeader }).then(() => {
          props.clearAuthResponse();
          window.sessionStorage.removeItem('tipAmt');
          if (authResponse.checkHeader.unpaidAmount === 0) {
            props.navigate(`${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`, {
              replace: true,
            });
          } else {
            props.navigate(
              `${APP_CONFIG.BASE_URL}/stagepayment/${tableData.id}`,
              { replace: true }
            );
          }
        });
      } else if (
        Number(authResponse.checkHeader.paidAmount) <
        Number(authResponse.checkHeader.totalAmount)
      ) {
        props.setPaymentCheck({
          ...authResponse.checkHeader,
          subtotalAmount,
          unpaidTips,
          paidTips,
        });
        props.updateSeatInfo({ ...authResponse.checkHeader }).then(() => {
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${authResponse.checkHeader.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`,
            { replace: true }
          );
        });
      } else {
        window.sessionStorage.removeItem('tipAmt');
        window.sessionStorage.removeItem('payAmt');
        props.updateSeatInfo({ ...authResponse.checkHeader });
        props.navigate(`${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`, {
          replace: true,
        });
      }
    } else if (urlSearchParams('ticketSplitTypeId') === '4') {
      props.navigate(`${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`, {
        replace: true,
      });
    } else if (urlSearchParams('ticketSplitTypeId') === '2') {
      props.setPaymentCheck({
        ...authResponse.checkHeader,
        subtotalAmount,
        unpaidTips,
        paidTips,
        totalAmount:
          countryCode === '44'
            ? Number(subtotalAmount + serviceCharge - discount)
            : Number(subtotalAmount + taxAmount + serviceCharge - discount),
        paidAmount: authResponse.checkHeader.paidAmount,
      });
      props
        .updateSeatInfo({
          ...authResponse.checkHeader,
          totalAmount:
            countryCode === '44'
              ? Number(subtotalAmount + serviceCharge - discount)
              : Number(subtotalAmount + taxAmount + serviceCharge - discount),
        })
        .then(() => {
          if (
            Number(authResponse.checkHeader.paidAmount) <
            Number(authResponse.checkHeader.totalAmount)
          ) {
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${authResponse.checkHeader.id}?ticketSplitTypeId=2&splitValue=1&screenType=1`,
              { replace: true }
            );
          } else {
            props.navigate(`${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`, {
              replace: true,
            });
          }
        });
    } else if (urlSearchParams('ticketSplitTypeId') === '3') {
      props.setPaymentCheck({
        ...authResponse.checkHeader,
        subtotalAmount,
        unpaidTips,
        paidTips,
        totalAmount:
          countryCode === '44'
            ? Number(subtotalAmount + serviceCharge - discount)
            : Number(subtotalAmount + taxAmount + serviceCharge - discount),
        paidAmount: authResponse.checkHeader.paidAmount,
        taxPaid: authResponse.ticket.taxAmount,
      });
      props
        .updateSeatInfo({
          ...authResponse.checkHeader,
          totalAmount:
            countryCode === '44'
              ? Number(subtotalAmount + serviceCharge - discount)
              : Number(subtotalAmount + taxAmount + serviceCharge - discount),
        })
        .then(() => {
          if (
            Number(authResponse.checkHeader.paidAmount) <
            Number(authResponse.checkHeader.totalAmount)
          ) {
            if (
              getObjectValue(
                () => props.auth?.loyaltyInfo?.supportsLoyalty,
                false
              ) &&
              !props.auth?.loyaltyInfo?.supportsCoupon
            ) {
              props.setPaymentFlowType(3);
            }
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${authResponse.checkHeader.id}?ticketSplitTypeId=3&splitValue=${authResponse.checkHeader.tickets[0].splitValue}&screenType=1`,
              { replace: true }
            );
          } else {
            props.navigate(`${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`, {
              replace: true,
            });
          }
        });
    } else {
      props.navigate(`${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`, {
        replace: true,
      });
    }
  };

  const onOtherPaymentOptionClick = () => {
    setCreditCardAmount(
      String(Number(props.seat?.paymentCheck?.paymentAmount || 0).toFixed(2)) ||
      '0'
    );
    setPaymentConfirmation(prevState => ({
      ...prevState,
      isPaymentFailed: false,
    }));
    props.toggleOtherPaymentOption();
    setIsCashPaymentCheck(true);
    props.openEmployeeCheck();
    setIsOtherPaymentOptionClick(true);
    props?.seat?.paymentCheck?.creditCard && handleCreditCardDeleteBalance();
  };

  const getSurveyResponse = () => {
    const payload = {
      storeId: props.deviceInfo?.storeId || null,
      deviceId: props.deviceInfo?.deviceId || null,
      employeeId: props.userInfo?.id || null,
      checkHeaderId: tableData.id || null,
      paymentCheck: props.seat?.paymentCheck,
    };
    props
      .getPaymentNewSurvey(payload)
      .then(res => {
        if (
          (props?.deviceInfo?.deviceGroup?.brandSurveyId && isTableTop) ||
          isServerApp ||
          isPaymentTerminal
        ) {
          setPaymentType(11);
          if (lockPaymentScreen) {
            setHideCancelIcon(false);
          }
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=11&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        } else if (isServerApp || isPaymentTerminal) {
          setPaymentType(22);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=22&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        } else {
          setPaymentType(5);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=5&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        }
      })
      .catch(err => {
        if (isServerApp || isPaymentTerminal) {
          setPaymentType(22);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=22&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        } else {
          setPaymentType(5);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=5&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        }
      });
  };

  const handleCashPayment = data => {
    const paymentCheckData =
      JSON.parse(window.sessionStorage.getItem('paymentCheck')) || {};
    let payload = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: tableData.id,
      cash: data,
      paymentCheck: props.seat?.paymentCheck,
      paymentChecks: props.seat?.paymentChecks,
    };
    props
      .paymentByCash(payload)
      .then(res => {
        setPayModeType(CASH);
        props.setSeat({
          ...props.seat,
          paymentCheck: res?.paymentCheck,
          paymentChecks: res?.paymentChecks,
        });
        setCreditCardAmount(
          String(
            Number(props.seat?.paymentCheck?.paymentAmount || 0).toFixed(2)
          ) || '0'
        );
        setPaymentType(32);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${paymentCheckData.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=32&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };
  const handleCashClearBalance = (type, payType) => {
    let payload = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: tableData.id,
      cash: props?.seat.paymentCheck?.cash,
      paymentCheck: props.seat.paymentCheck,
      paymentChecks: props.seat.paymentChecks,
    };
    props
      .cashClearBalance(payload)
      .then(res => {
        props.setSeat({
          ...props.seat,
          paymentCheck: res.paymentCheck,
          paymentChecks: res.paymentChecks,
        });
        if (payType === GIFT_CARD) {
          setPaymentType(12);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.seat.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=12&type=giftCardPay`,
            { replace: true }
          );
        } else if (payType === CASH) {
          if (
            props?.deviceInfo?.deviceGroup?.serverAppSettings?.powerPaymentOnly
          ) {
            if (tipInfo) {
              setPaymentType(4);
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props?.seat?.paymentCheck?.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=4&type=${urlSearchParams('type')}`,
                { replace: true }
              );
            } else {
              setPaymentType(28);
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props?.seat?.paymentCheck?.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=28&type=${urlSearchParams('type')}`,
                { replace: true }
              );
            }
          } else if (isDriveThru || isCounter || isCallCenter || speedOrderMode){
            props.navigate(`${APP_CONFIG.BASE_URL}/orders`, { replace: true })
          }
           else {
            setPaymentType(31);
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${props?.seat?.paymentCheck?.id
              }?ticketSplitTypeId=${urlSearchParams(
                'ticketSplitTypeId'
              )}&splitValue=${urlSearchParams(
                'splitValue'
              )}&screenType=31&type=${urlSearchParams('type')}`,
              { replace: true }
            );
          }
        }
        setPayModeType(DEFAULT);
        setIsAmountEdit({ isOpen: false, isError: false, isFirstClick: true });
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };
  const handleCashCompletePayment = () => {
    let dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: tableData.id,
      employeeCard: getObjectValue(
        () =>
          JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard,
        null
      ),
      cash: props?.seat.paymentCheck?.cash,
      paymentCheck: props.seat.paymentCheck,
      paymentChecks: props.seat.paymentChecks,
    };
    props
      .paymentNewInitialization(dataToSend)
      .then(val => {
        let payload = {
          storeId: props.deviceInfo.storeId,
          deviceId: props.deviceInfo.deviceId,
          employeeId: props.userInfo.id,
          employeeCard: props.userInfo.employeeCard,
          checkHeaderId: tableData.id,
          cash: props?.seat.paymentCheck?.cash,
          paymentCheck: val.paymentCheck,
          paymentChecks: props?.seat.paymentChecks,
          creditCard: null,
        };
        paymentFn(payload)
          .then(res => {
            props.clearSelectedOffers();
            props.setSeat({
              ...props.seat,
              paymentCheck: res.paymentCheck,
              paymentChecks: res.paymentChecks,
            });
            props.setPaymentCheck({
              ...props.paymentCheck,
              paymentCheck: res.paymentCheck,
            });
            if (isDriveThru || isCounter || isCallCenter) {
              handlePaymentForDriveThru(res);
            }
            else {
              if (res.control?.partialPayment) {
                setPaymentConfirmation(prevState => ({
                  ...prevState,
                  isPaymentPartiallyComplete: true,
                }));
              } else if (res?.paymentCheck?.paymentAmount > 0) {
                setPaymentConfirmation(prevState => ({
                  ...prevState,
                  isPartiallyPaid: true,
                  isPaymentComplete: res?.paymentCheck?.paymentAmount <= 0,
                }));
              } else {
                setPaymentConfirmation(prevState => ({
                  ...prevState,
                  isPaymentComplete: res?.paymentCheck?.paymentAmount <= 0,
                }));
              }
              setPaymentType(33);
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=33&type=${urlSearchParams('type')}`,
                { replace: true }
              );
            }
          })
          .catch(err => {
            props.setErrorPopUp({
              res: err.message,
            });
          });
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };
  const handlePayAtCounterPayment = () => {
    const payload = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo?.id,
      employeeCard: props.userInfo?.employeeCard,
      checkHeaderId: tableData.id,
      cash: props?.seat.paymentCheck?.cash,
      paymentCheck: props?.seat?.paymentCheck,
      paymentChecks: props?.seat.paymentChecks,
      creditCard: null,
    };
    props
      .paymentNewPaymentAtCounter(payload)
      .then(res => {
        props.clearSelectedOffers();
        props.setSeat({
          ...props.seat,
          paymentCheck: res.paymentCheck,
          paymentChecks: res.paymentChecks,
        });
        props.setPaymentCheck({
          ...props.paymentCheck,
          paymentCheck: res.paymentCheck,
        });

        const seat = JSON.parse(window.sessionStorage.getItem('seat'));

      })
      .then(res => {
        props.updateChecksAfterResponse(res);
        return props.showSuccessCheckMark();
      })
      .then(() => {
        props.navigate(`${APP_CONFIG.BASE_URL}/serverApp/checks?login=true`);
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message
        });
      });
  };
  const handleSendAndPayCallCenter = (type) => {
    const payload = {
      storeId: props?.deviceInfo?.storeId,
      deviceId: props?.deviceInfo?.deviceId,
      employeeId: props?.userInfo?.id,
      employeeCard: props?.userInfo?.employeeCard,
      checkHeaderId: tableData?.id,
      cash: props?.seat?.paymentCheck?.cash,
      paymentCheck: props?.seat?.paymentCheck,
      paymentChecks: props?.seat?.paymentChecks,
      creditCard: null,
      // ...(type === 'textToPay' && { textToPay: true }),
      ...(type === 'textToPay'
        ? { textToPay: true }
        : ['payLater', 'orderAtRes'].includes(type)
          ? { textToPay: false }
          : {}
      ),

    };
    props
      .paymentNewPaymentAtCounter(payload)
      .then(res => {
        props.clearSelectedOffers();
        props.setSeat({
          ...props.seat,
          paymentCheck: res.paymentCheck,
          paymentChecks: res.paymentChecks,
        });
        props.setPaymentCheck({
          ...props.paymentCheck,
          paymentCheck: res.paymentCheck,
        });
      }).then(res => {
        props.updateChecksAfterResponse(res);
        props.navigate(`${APP_CONFIG.BASE_URL}/receipt/ticketSplitTypeId=1&splitValue=1&screenType=20&type=payType`, { replace: true });
      }).catch(err => {
        props.setErrorPopUp({
          res: err.message
        });
      });
  }

  const processSaleInit = async saleResponse => {
    const startPaymentFlow = () => {
      const Amount = +(
        saleResponse.paymentCheck?.creditCard?.paymentAmount * 100
      );
      const TipAmount = 0;
      const data = {
        type: eventMethodType,
        data: {
          merchantInvoiceId: saleResponse.ticket?.id?.toString(),
          employeeId: saleResponse.ticket?.employeeId?.toString(),
          latitude: '0',
          longitude: '0',
          notes: '',
          referenceId:
            saleResponse.ticket?.id.toString() ||
            saleResponse.ticket?.referenceId,
          amount: `${Number(Amount)?.toFixed()}`,
          tipAmount: `${Number(TipAmount)?.toFixed()}`,
        },
      };
      setPaymentType(3);
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
        }?ticketSplitTypeId=${urlSearchParams(
          'ticketSplitTypeId'
        )}&splitValue=${urlSearchParams(
          'splitValue'
        )}&screenType=3&type=${urlSearchParams('type')}`,
        { replace: true }
      );
      setHideCancelIcon(true);
      window.sessionStorage.setItem('processSaleData', JSON.stringify(data));
      EventEmitter.sendMessage(
        data,
        res => {
          console.log(res);
        },
        err => {
          console.log("Event Error", err.message);
          props.setErrorPopUp({res: err.message});
        }
      );
    };

    setCardReaderConnectionState({
      isLoading: true,
      message: LABEL().CARD_READER_CHECKING_CONNECTION,
    });

    try {
      const cardReaderResult = await ensureCardReaderConnection({
        maxReconnectAttempts: 2,
         skipConnectionCheck: Boolean(props.deviceInfo?.deviceGroup?.serverAppSettings?.disablePayment) || props.deviceInfo?.deviceGroup?.paymentTypes?.creditCard === false,
        onProgress: message => {
          console.log('ensureCardReaderConnection - onProgress:', message);
          setCardReaderConnectionState({
            isLoading: true,
            message,
          });
        },
      });

      if (cardReaderResult.ok) {
        console.log(
          'ensureCardReaderConnection - succeeded:',
          cardReaderResult.message || cardReaderResult
        );
        startPaymentFlow();
        return;
      }

      console.error(
        'ensureCardReaderConnection - failed:',
        cardReaderResult.errorMessage,
        cardReaderResult.error
      );
      props.setErrorPopUp({
        res: LABEL().CARD_READER_PAY_PREVENTION_ERROR,
        fullWidth: true,
      });
    } finally {
      setCardReaderConnectionState({
        isLoading: false,
        message: '',
      });
    }
  };

  const giftcardReceiptEnabled = props?.seat?.paymentCheck?.cards?.filter(card => card?.type !== 1)?.length > 0;

  const paymentProcess = () => {
    window.sessionStorage.setItem(
      'giftCardpayment',
      giftcardReceiptEnabled
    );
    setPayModeType(DEFAULT);
    if (lockPaymentScreen) {
      setHideCancelIcon(false);
    }
    if (paymentConfirmation.isPaymentComplete) {
      if (
        paymentConfirmation.isPaymentComplete &&
        props?.seat?.paymentCheck?.tickets[
          props?.seat?.paymentCheck?.tickets?.length - 1
        ]?.paymentTypeName === 'Cash' &&
        !JSON.parse(window.sessionStorage.getItem('giftCardpayment'))
      ) {
        setPaymentType(22);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=22&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      } else if (!skipSurvey) {
        if (JSON.parse(window.sessionStorage.getItem('giftCardpayment'))) {
          setPaymentType(27);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=27&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        } else {
          getSurveyResponse();
        }
      } else if (JSON.parse(window.sessionStorage.getItem('giftCardpayment'))) {
        setPaymentType(27);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=27&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      } else if (isServerApp || isPaymentTerminal) {
        setPaymentType(22);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=22&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      }
    } else if (
      paymentConfirmation.isPaymentPartiallyComplete ||
      paymentConfirmation.isPartiallyPaid
    ) {
      if (props.isOtherPaymentOption) {
        setPaymentConfirmation(prevState => ({
          ...prevState,
          isPaymentPartiallyComplete: false,
          isPartiallyPaid: false,
          isTipPartiallyPaid: false,
        }));
        setPaymentType(32);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props?.seat?.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=1&screenType=32&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      } else {
        setPaymentConfirmation(prevState => ({
          ...prevState,
          isPaymentPartiallyComplete: false,
          isPartiallyPaid: false,
        }));
        setPaymentType(31);
        window.sessionStorage.removeItem('tipAmt');
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=31&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      }
    } else if (paymentConfirmation.isPaymentFailed) {
      const udpatedSeatObj = props.seat;
      if (udpatedSeatObj?.paymentCheck?.creditCard?.paymentAmount != null) {
        udpatedSeatObj.paymentCheck.creditCard = null;
        props.setSeat(udpatedSeatObj);
      }
      window.sessionStorage.removeItem('tipAmt');
      if (isDriveThru || isCounter || isCallCenter) {
        setPaymentType(32);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props?.seat?.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=1&screenType=32&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      } else {
        setPaymentType(31);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=31&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      }
    } else {
      if (!skipSurvey) {
        getSurveyResponse();
      } else if (isServerApp) {
        setPaymentType(22);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=22&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      }
    }
  };
  const completeProcessSale = (response, tip, messages, val) => {
    if (supportsTips) {
      const tips = { totalTips: tipAmount, unpaidTips: tipAmount, paidTips: 0 };
      window.sessionStorage.setItem('tipAmt', JSON.stringify(tips));
    }
    const aAmt = (response.authorizedAmount / 100)?.toFixed(2);
    const tipAmt =
      supportsTips &&
        getObjectValue(
          () =>
            props.auth?.cardReaderType === 3 ||
            props.auth?.cardReaderType === 4 ||
            props.auth?.cardReaderType === 5 ||
            props.auth?.cardReaderType === 6 ||
            props.auth?.cardReaderType === 8 ||
            props.auth?.cardReaderType === 7 ||
            props.auth?.cardReaderType === 9,
          false
        )
        ? Number(tip)?.toFixed(2)
        : getObjectValue(
          () =>
            Number(
              JSON.parse(window.sessionStorage.getItem('tipAmt')).unpaidTips
            )?.toFixed(2),
          0
        );
    let data = {
      name: isCounter
        ? window.sessionStorage.getItem('counterName') || null
        : props.speedOrderName
          ? props.speedOrderName
          : null,
      phoneNumber: window.sessionStorage.getItem('counterPhone') || null,
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: tableData.id,
      employeeCard: getObjectValue(
        () =>
          JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard,
        null,
      ),
      creditCard: {
        orderPay: isOrderPayMode,
        speedOrder: isCounter || props.speedOrderStatus || props.tipAmount,
        isPreAuth: false,
        cardholderName: response.cardholderName,
        redactedCardNumber: response.redactedCardNumber,
        cardExpirationDate: response.cardExpirationDate,
        cardType: response.cardType,
        uniqueCardIdentifier: response.uniqueCardIdentifier,
        transactionId: response.transactionId,
        clientTransactionId: response.clientTransactionId,
        authorizedAmount: aAmt,
        authorizationCode: response.authCode,
        transactionGUID: '557d2469-65f9-4eff-92c3-e9cc21068a20',
        customerDisplay: 'APPROVAL',
        requiresPin: false,
        requiresSignature: true,
        sequenceNumber: '821',
        transactionApproved: true,
        message: '',
      },
      paymentCheck: val ? val.paymentCheck : props.seat.paymentCheck,
      paymentChecks: val ? val.paymentChecks : props.seat.paymentChecks,
      eventName: eventMethodType
    };
    paymentFn(data)
      .then(res => {
        props.clearSelectedOffers();
        props.setSeat({
          ...props.seat,
          control: res.control,
          paymentCheck: res.paymentCheck,
          paymentChecks: res.paymentChecks,
        });
        if (isDriveThru || isCounter || isCallCenter) {
          handlePaymentForDriveThru(res);
        } else {
          if (lockPaymentScreen) {
            setHideCancelIcon(false);
          }
          if (res.control?.partialPayment) {
            setPaymentConfirmation(prevState => ({
              ...prevState,
              isPaymentPartiallyComplete: true,
            }));
          } else if (
            res?.paymentCheck?.paymentAmount > 0 &&
            !res?.control?.partialTip
          ) {
            setPaymentConfirmation(prevState => ({
              ...prevState,
              isPartiallyPaid: true,
              isPaymentComplete: res?.paymentCheck?.paymentAmount <= 0,
            }));
          } else if (res?.control?.partialTip) {
            setPaymentConfirmation(prevState => ({
              ...prevState,
              isTipPartiallyPaid: true,
            }));
          } else {
            setPaymentConfirmation(prevState => ({
              ...prevState,
              isPaymentComplete: res?.paymentCheck?.paymentAmount <= 0,
            }));
          }
          setPointEarnings(res?.estimatedPoints?.value);
          setTipAmount(tipAmt);
          if (isServerApp) {
            const ingenicoLogData = {
              source: 'ingenico',
              requestBody: window.sessionStorage.getItem('processSaleData'),
              responseBody: JSON.stringify(response),
              messages,
            };
            try {
              props
                .ingenicoLog(ingenicoLogData)
                .then(() => {
                  window.sessionStorage.removeItem('processSaleData');
                })
                .catch(() => {
                  window.sessionStorage.removeItem('processSaleData');
                });
            } catch (e) {
              console.log(e);
            }
          }
          setPaymentType(33);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=33&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        }
      })
      .catch(err => {
        if (lockPaymentScreen) {
          setHideCancelIcon(false);
        }
        setPaymentConfirmation(prevState => ({
          ...prevState,
          isPaymentFailed: true,
          errorMsg: err.message,
        }));

        let data = {
          storeId: props?.deviceInfo?.storeId,
          deviceId: props?.deviceInfo?.deviceId,
          employeeId: props?.userInfo?.id,
          checkHeaderId: tableData?.id,
          employeeCard: getObjectValue(
            () =>
              JSON.parse(window.sessionStorage.getItem('userInfo'))
                .employeeCard,
            null
          ),
          creditCard: {
            orderPay: isOrderPayMode,
            speedOrder: isCounter || props.speedOrderStatus || props.tipAmount,
            isPreAuth: false,
            transactionId: response.transactionId,
            clientTransactionId: response.clientTransactionId,
            transactionGUID: '557d2469-65f9-4eff-92c3-e9cc21068a20',
            customerDisplay: 'REJECTED',
            sequenceNumber: '821',
            transactionApproved: false,
            message: 'Card declined',
          },
          paymentCheck: props.seat.paymentCheck,
          paymentChecks: props.seat.paymentChecks,
        };
        props.paymentNewPaymentError(data).then(res => {
          setPaymentConfirmation(prevState => ({
            ...prevState,
            isPaymentFailed: true,
          }));
          props.setSeat({
            ...props.seat,
            paymentCheck: res.paymentCheck,
            paymentChecks: res.paymentChecks,
          });
          if (isServerApp) {
            const ingenicoLogData = {
              source: 'ingenico',
              requestBody: window.sessionStorage.getItem('processSaleData'),
              responseBody: JSON.stringify(response),
              messages,
            };
            try {
              props
                .ingenicoLog(ingenicoLogData)
                .then(() => {
                  window.sessionStorage.removeItem('processSaleData');
                })
                .catch(() => {
                  window.sessionStorage.removeItem('processSaleData');
                });
            } catch (e) {
              console.log(e);
            }
          }
          setPaymentType(33);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=33&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        });
        setTipsMessage('');
      });
  };
  const oldCompleteProcessSale = (response, tip, messages, log) => {
    if (supportsTips) {
      const tips = { totalTips: tipAmount, unpaidTips: tipAmount, paidTips: 0 };
      window.sessionStorage.setItem('tipAmt', JSON.stringify(tips));
    }
    const aAmt = (response.authorizedAmount / 100).toFixed(2);
    const authResponse = getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('authResponse')),
      0
    );
    //tip amount for payment
    const tipAmt =
      supportsTips &&
        getObjectValue(
          () =>
            props.auth?.cardReaderType === 3 ||
            props.auth?.cardReaderType === 4 ||
            props.auth?.cardReaderType === 5 ||
            props.auth?.cardReaderType === 6 ||
            props.auth?.cardReaderType === 8 ||
            props.auth?.cardReaderType === 7 ||
            props.auth?.cardReaderType === 9,
          false
        )
        ? Number(tip).toFixed(2)
        : getObjectValue(
          () =>
            Number(
              JSON.parse(window.sessionStorage.getItem('tipAmt')).unpaidTips
            ).toFixed(2),
          0
        );
    const loyaltyData = getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('loyaltyData')),
      {}
    );
    const dataToSend = {
      ...response,
      message: '',
      name: isCounter
        ? window.sessionStorage.getItem('counterName') || null
        : props.speedOrderName
          ? props.speedOrderName
          : null,
      phoneNumber: window.sessionStorage.getItem('counterPhone') || null,
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: tableData.id,
      ticketId: authResponse.ticket?.id,
      subtotalAmount: getObjectValue(
        () =>
          authResponse.ticket?.subtotalAmount ||
          authResponse.ticket?.subTotalAmount,
        0
      ),
      taxAmount: authResponse.ticket?.taxAmount,
      authAmount: aAmt,
      tipAmount: tipAmt,
      cardHolderName: response.cardholderName,
      redactedCardNumber: response.redactedCardNumber,
      cardExpirationDate: response.cardExpirationDate,
      cardType: response.cardType,
      uniqueCardIdentifier: response.uniqueCardIdentifier,
      transactionId: response.transactionId,
      clientTransactionId: response.clientTransactionId,
      authorizationCode: response.authCode,
      paymentStageId: getObjectValue(
        () => props.paymentCheck.paymentStageId,
        null
      ),
      employeeCard: getObjectValue(
        () =>
          JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard,
        null
      ),
      isPreAuth: false,
      partialAuth: false,
      serviceChargeAmount: getObjectValue(
        () => authResponse.ticket?.serviceChargeAmount,
        0
      ),
      discountAmount: getObjectValue(
        () => authResponse.ticket?.discountAmount,
        0
      ),
      orderPay: isOrderPayMode,
      speedOrder: isCounter
        ? isCounter
        : props.speedOrderStatus
          ? props.speedOrderStatus
          : props.tipAmount,
      accountNumber: loyaltyData?.accountNumber
        ? loyaltyData?.accountNumber
        : '',
      offerId: loyaltyData?.offerId ? loyaltyData?.offerId : '',
      isCoupon: loyaltyData?.isCoupon ? loyaltyData?.isCoupon : false,
    };
    let totalValue =
      dataToSend.subtotalAmount +
      dataToSend.taxAmount +
      Number(dataToSend.tipAmount) -
      dataToSend.discountAmount;
    if (urlSearchParams('preAuth')) {
      dataToSend.preAuth = true;
      dataToSend.tokenReferenceNumber = response.tokenReferenceNumber;
      dataToSend.phoneNumber = '';
      dataToSend.countryCode = '';
      dataToSend.authAmount = 0;
      props.clearAuthResponse();
    }
    props
      .paymentSale(dataToSend, urlSearchParams('preAuth'))
      .then(res => {
        window.sessionStorage.removeItem('counterName');
        window.sessionStorage.setItem(
          'cards',
          JSON.stringify(res.checkHeader.cards)
        );
        props.setPaymentCheck(res.checkHeader);
        if (urlSearchParams('preAuth')) {
          props.setSeat(res.checkHeader);
          const seatval = props.seat;
          seatval.tickets = res.checkHeader?.tickets;
          if (lockPaymentScreen) {
            setHideCancelIcon(false);
          }
          if (isServerApp) {
            const ingenicoLogData = {
              source: 'ingenico',
              requestBody: window.sessionStorage.getItem(
                'processCreditTokenize'
              ),
              responseBody: JSON.stringify(response),
              messages,
            };
            try {
              props
                .ingenicoLog(ingenicoLogData)
                .then(() => {
                  window.sessionStorage.removeItem('processCreditTokenize');
                })
                .catch(() => {
                  window.sessionStorage.removeItem('processCreditTokenize');
                });
            } catch (e) {
              console.log(e);
            }
          }
          if (props.speedOrderStatus || props.sendModeStatus) {
            props.navigate({
              pathname: `${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`,
            });
          } else {
            props.navigate(`${APP_CONFIG.BASE_URL}/orders`, { replace: true });
          }
        } else {
          if (lockPaymentScreen) {
            setHideCancelIcon(false);
          }
          setPointEarnings(res?.estimatedPoints?.value);
          window.sessionStorage.setItem('authResponse', JSON.stringify(res));
          setTipAmount(tipAmt);
          if (isServerApp) {
            const ingenicoLogData = {
              source: 'ingenico',
              requestBody: window.sessionStorage.getItem('processSaleData'),
              responseBody: JSON.stringify(response),
              messages,
            };
            try {
              props
                .ingenicoLog(ingenicoLogData)
                .then(() => {
                  window.sessionStorage.removeItem('processSaleData');
                })
                .catch(() => {
                  window.sessionStorage.removeItem('processSaleData');
                });
            } catch (e) {
              console.log(e);
            }
          }
          // if (
          //   isCounter &&
          //   props?.deviceInfo?.deviceGroup?.serverAppSettings
          //     ?.autoPrintOrderNumberTicket
          // ) {
          //   props
          //     .orderTicketPrint({
          //       deviceId: props.deviceInfo.deviceId,
          //       employeeId: Number(props.userInfo.id),
          //       storeId: props.deviceInfo.storeId,
          //       ticketId: res?.ticket?.id,
          //     })
          //     .then(resp => {
          //       if (window.ReactNativeWebView) {
          //         EventEmitter.print(resp);
          //       }
          //       props.setPrintNotification(resp);
          //       props.navigate(
          //         `${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`,
          //         { replace: true }
          //       );
          //       if (lockPaymentScreen) {
          //         setHideCancelIcon(false);
          //       }
          //     })
          //     .catch(err => {
          //       props.setNotification({
          //         type: 'danger',
          //         message: err.message,
          //       });
          //     });
          // }
          setPaymentAmount(
            Number(window.sessionStorage.getItem('payAmt')).toFixed(2)
          );
          window.sessionStorage.removeItem('tipAmt');
          window.sessionStorage.removeItem('payAmt');
          if (
            false &&
            props.syncData?.totalAmount &&
            props?.syncData?.totalAmount.toFixed(2) !==
            res?.checkHeader?.totalAmount.toFixed(2)
          ) {
            setPaymentType(25);
            if (lockPaymentScreen) {
              setHideCancelIcon(false);
            }
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
              }?ticketSplitTypeId=${urlSearchParams(
                'ticketSplitTypeId'
              )}&splitValue=${urlSearchParams(
                'splitValue'
              )}&screenType=25&type=${urlSearchParams('type')}`,
              { replace: true }
            );
          } else if (
            false &&
            totalValue.toFixed(2) != Number(res.ticket.ticketAmount).toFixed(2)
          ) {
            setPaymentType(26);
            if (lockPaymentScreen) {
              setHideCancelIcon(false);
            }
            setPartialPayment({
              totalAmount: totalValue.toFixed(2),
              ticketAmount: Number(res.ticket.ticketAmount).toFixed(2),
              balanceAmount: (
                totalValue.toFixed(2) -
                Number(res.ticket.ticketAmount).toFixed(2)
              ).toFixed(2),
            });
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
              }?ticketSplitTypeId=${urlSearchParams(
                'ticketSplitTypeId'
              )}&splitValue=${urlSearchParams(
                'splitValue'
              )}&screenType=26&type=${urlSearchParams('type')}`,
              { replace: true }
            );
          } else {
            if (!window.sessionStorage.getItem('giftCardpayment')) {
              if (
                supportsSurvey &&
                !skipSurvey &&
                // !isCounter &&
                !urlSearchParams('preAuth')
              ) {
                getSurveyResponse();
              } else if (isServerApp || isPaymentTerminal) {
                setPaymentType(22);
                props.navigate({
                  pathname: `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                    }?ticketSplitTypeId=${urlSearchParams(
                      'ticketSplitTypeId'
                    )}&splitValue=${urlSearchParams(
                      'splitValue'
                    )}&screenType=22&type=${urlSearchParams('type')}`,
                });
              } else {
                setPaymentType(5);
                props.navigate({
                  pathname: `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                    }?ticketSplitTypeId=${urlSearchParams(
                      'ticketSplitTypeId'
                    )}&splitValue=${urlSearchParams(
                      'splitValue'
                    )}&screenType=5&type=${urlSearchParams('type')}`,
                });
              }
              if (lockPaymentScreen) {
                setHideCancelIcon(false);
              }
            } else {
              setPaymentType(27);
              if (lockPaymentScreen) {
                setHideCancelIcon(false);
              }
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=27&type=${urlSearchParams('type')}`,
                { replace: true }
              );
            }
          }
        }
      })
      .catch(err => {
        if (lockPaymentScreen) {
          setHideCancelIcon(false);
        }
        if (urlSearchParams('preAuth')) {
          if (isServerApp) {
            const ingenicoLogData = {
              source: 'ingenico',
              requestBody: window.sessionStorage.getItem(
                'processCreditTokenize'
              ),
              responseBody: JSON.stringify(response),
              messages,
            };
            try {
              props
                .ingenicoLog(ingenicoLogData)
                .then(() => {
                  window.sessionStorage.removeItem('processCreditTokenize');
                })
                .catch(() => {
                  window.sessionStorage.removeItem('processCreditTokenize');
                });
            } catch (e) {
              console.log(e);
            }
          }
        }
        setTipsMessage('');
        if (urlSearchParams('preAuth')) {
          props.navigate(`${APP_CONFIG.BASE_URL}/orders`, { replace: true });
          return;
        }
        props
          .paymentAuthError({ ...dataToSend, message: err.message })
          .then(() => {
            setErrorMessage(err.message);
            setPaymentType(8);
            if (lockPaymentScreen) {
              setHideCancelIcon(false);
            }
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
              }?ticketSplitTypeId=${urlSearchParams(
                'ticketSplitTypeId'
              )}&splitValue=${urlSearchParams(
                'splitValue'
              )}&screenType=8&type=${urlSearchParams('type')}&unlock=true`,
              { replace: true }
            );
          });
      });
  };
  const handleProcessCreditError = (errMsg, messages, preAuthVal) => {
    const authResponse = getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('authResponse')),
      0
    );
    const tipAmt = getObjectValue(
      () =>
        Number(
          JSON.parse(window.sessionStorage.getItem('tipAmt')).unpaidTips
        ).toFixed(2),
      0
    );
    const loyaltyData = getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('loyaltyData')),
      {}
    );
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: tableData.id,
      employeeCard: getObjectValue(
        () =>
          JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard,
        null
      ),
      creditCard: {
        message: errMsg,
        storeId: props.deviceInfo.storeId,
        deviceId: props.deviceInfo.deviceId,
        employeeId: props.userInfo.id,
        checkHeaderId: tableData.id,
        ticketId: authResponse.ticket?.id,
        subtotalAmount: getObjectValue(
          () =>
            authResponse?.ticket?.subtotalAmount ||
            authResponse?.ticket?.subTotalAmount,
          0
        ),
        taxAmount: authResponse.ticket?.taxAmount,
        authAmount: 0,
        tipAmount: tipAmt,
        cardHolderName: null,
        redactedCardNumber: null,
        cardExpirationDate: null,
        cardType: null,
        uniqueCardIdentifier: null,
        transactionId: null,
        clientTransactionId: null,
        authorizationCode: null,
        paymentStageId: getObjectValue(
          () => props.paymentCheck.paymentStageId,
          null
        ),
        employeeCard: getObjectValue(
          () =>
            JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard,
          null
        ),
        isPreAuth: false,
        partialAuth: false,
        serviceChargeAmount: getObjectValue(
          () => authResponse.ticket?.serviceChargeAmount,
          0
        ),
        discountAmount: getObjectValue(
          () => authResponse.ticket?.discountAmount,
          0
        ),
        accountNumber: loyaltyData?.accountNumber
          ? loyaltyData?.accountNumber
          : '',
        offerId: loyaltyData?.offerId ? loyaltyData?.offerId : '',
        isCoupon: loyaltyData?.isCoupon ? loyaltyData?.isCoupon : false,
        name: window.sessionStorage.getItem('counterName') || null,
        phoneNumber: window.sessionStorage.getItem('counterPhone') || null
      },
      paymentCheck: props.seat?.paymentCheck,
    };
    setErrorMessage(errMsg);
    props
      .paymentNewPaymentError(dataToSend)
      .then((res) => {
        props.setSeat({
          ...props.seat,
          paymentCheck: res.paymentCheck,
        })
        if (isServerApp) {
          const ingenicoLogData = {
            source: 'ingenico',
            requestBody: window.sessionStorage.getItem('processSaleData'),
            responseBody: JSON.stringify(errMsg),
            messages,
          };
          setPaymentType(preAuthVal ? 19 : 8);
          if (lockPaymentScreen) {
            setHideCancelIcon(false);
          }
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams('splitValue')}&screenType=${preAuthVal ? 19 : 8
            }&type=${urlSearchParams('type')}&unlock=true`,
            { replace: true }
          );
          try {
            props
              .ingenicoLog(ingenicoLogData)
              .then(() => {
                window.sessionStorage.removeItem('processSaleData');
              })
              .catch(() => {
                window.sessionStorage.removeItem('processSaleData');
              });
          } catch (e) {
            console.log(e);
          }
        }
        if (isTableTop) {
          setPaymentType(8);
        }
        if (isOrderPayMode) {
          setCancelOrderConfirm(true);
        }
      })
      .catch(() => {
        setPaymentType(preAuthVal ? 19 : 8);
        if (lockPaymentScreen) {
          setHideCancelIcon(false);
        }
        setPaymentConfirmation(prevState => ({
          ...prevState,
          isPaymentFailed: true,
        }));
        if (isServerApp || isPaymentTerminal) {
          const ingenicoLogData = {
            source: 'ingenico',
            requestBody: window.sessionStorage.getItem('processSaleData'),
            responseBody: JSON.stringify(errMsg),
            messages,
          };
          try {
            props
              .ingenicoLog(ingenicoLogData)
              .then(() => {
                window.sessionStorage.removeItem('processSaleData');
              })
              .catch(() => {
                window.sessionStorage.removeItem('processSaleData');
              });
          } catch (e) {
            console.log(e);
          }
        }
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams('splitValue')}&screenType=${preAuthVal ? 19 : 8
          }&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      });
  };

  const handlePaymentInit = () => {
    props.navigate(
      `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
      }?ticketSplitTypeId=${urlSearchParams(
        'ticketSplitTypeId'
      )}&splitValue=${urlSearchParams('splitValue')}&screenType=15`,
      { replace: true }
    );
    props.setPaymentCheck(props.paymentCheck);
  };

  const ingenicoIPP350Payment = (saleResponse, tip, showMessage) => {
    const Amount = +(
      saleResponse?.paymentCheck?.creditCard?.paymentAmount * 100
    );
    const TipAmount = 0;
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      checkHeaderId: tableData.id,
      ticketId: saleResponse.ticket?.id.toString(),
      totalAmount: Amount.toFixed(2),
      tipAmount: (TipAmount * 100).toFixed(2),
    };
    props
      .newIngenicoPayment(dataToSend)
      .then(response => {
        if (showMessage) {
          setTipsMessage(CUSTOM_MESSAGES().PAYMENT_SALE_MESSAGE);
        }
        completeProcessSale(response, tip, '', saleResponse);
      })
      .catch(error => {
        setTipsMessage('');
        handleProcessCreditError(error.message);
      });
  };

  //New Pyament flow for Credit card

  const handleNewCreditCard = res => {
    let dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: tableData.id,
      employeeCard: getObjectValue(
        () =>
          JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard,
        null
      ),
      creditCard: {},
      paymentCheck: res?.paymentCheck,
      paymentChecks: res?.paymentChecks,
    };
    props
      .paymentNewInitialization(dataToSend)
      .then(val => {
        props
          .setSeat({
            ...props.seat,
            paymentCheck: val.paymentCheck,
            paymentChecks: val.paymentChecks,
          })
          .then(() => {
            props.setAuthResponse(val).then(() => {
              if (
                window.ReactNativeWebView &&
                getObjectValue(
                  () =>
                    props.auth?.cardReaderType !== 3 &&
                    props.auth?.cardReaderType !== 4 &&
                    props.auth?.cardReaderType !== 5 &&
                    props.auth?.cardReaderType !== 6 &&
                    props.auth?.cardReaderType !== 8 &&
                    props.auth?.cardReaderType !== 7 &&
                    props.auth?.cardReaderType !== 9,
                  false
                )
              ) {
                EventEmitter.removeListeners('processPayment', () => { });
                EventEmitter.removeListeners('processCreditSale', () => { });
                processSaleInit(val);
              } else if (
                getObjectValue(
                  () =>
                    props.auth?.cardReaderType === 3 ||
                    props.auth?.cardReaderType === 4 ||
                    props.auth?.cardReaderType === 5 ||
                    props.auth?.cardReaderType === 6 ||
                    props.auth?.cardReaderType === 8 ||
                    props.auth?.cardReaderType === 7 ||
                    props.auth?.cardReaderType === 9,
                  false
                )
              ) {
                // if (supportsTips && isCounter) {
                //   const tipPercentages = [];
                //   props.auth.tipInfo.tips.forEach(item => {
                //     if (props.auth.tipInfo.ruleType === 1) {
                //       tipPercentages.push(item.value * 100);
                //     } else {
                //       tipPercentages.push(item.value);
                //     }
                //   });
                //   const dataTosend = {
                //     storeId: props.deviceInfo.storeId,
                //     deviceId: props.deviceInfo.deviceId,
                //     checkHeaderId: tableData?.id || null,
                //     totalAmount: (dataToSend.totalAmount * 100).toFixed(2),
                //     ticketId: val.ticket?.id.toString(),
                //     tipAmount: 0,
                //     tipPercentages,
                //   };
                //   setTipsMessage(CUSTOM_MESSAGES().TIPS_MESSAGE);
                //   props
                //     .getNewTips(dataTosend)
                //     .then(res => {
                //       ingenicoIPP350Payment(val, res.tipAmount / 100, true);
                //     })
                //     .catch(err => {
                //       setTipsMessage('');
                //       props.setErrorPopUp({
                //         res: err.message,
                //       });
                //       setPaymentType(8);
                //     });
                // } else {
                //   ingenicoIPP350Payment(val, tipAmount, false);
                // }
                ingenicoIPP350Payment(val, tipAmount, false);
              }
            })
          })
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const handleCreditCard = () => {
    const payCheck = isTableTop
      ? JSON.parse(window.sessionStorage.getItem('paymentCheck'))
      : tableData;
    const subTotalAmount = Number(payCheck.subTotalAmount).toFixed(2);
    const taxAmount = Number(payCheck.taxAmount).toFixed(2);
    const loyaltyData = getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('loyaltyData')),
      {}
    );
    const dataToSend = {
      phoneNumber: window.sessionStorage.getItem('counterPhone') || null,
      name: isCounter
        ? window.sessionStorage.getItem('counterName') || null
        : props.speedOrderName
          ? props.speedOrderName
          : null,
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: payCheck.id,
      ticketSplitTypeId: Number(urlSearchParams('ticketSplitTypeId')),
      splitValue: Number(urlSearchParams('splitValue')),
      paymentStageId: getObjectValue(
        () => props.paymentCheck.paymentStageId,
        null
      ),
      subTotalAmount,
      taxAmount,
      totalAmount: Number(payCheck.totalAmount).toFixed(2),
      unpaidAmount: Number(payCheck.unpaidAmount).toFixed(2),
      seatIds: SeatIds(),
      serviceChargeAmount: Number(payCheck.serviceChargeAmount).toFixed(2),
      discountAmount: Number(payCheck.discountAmount).toFixed(2),
      orderPay: isOrderPayMode,
      speedOrder: isCounter || props.speedOrderStatus || props.sendModeStatus,
      employeeCard: getObjectValue(
        () =>
          JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard,
        null
      ),
      accountNumber: loyaltyData?.accountNumber
        ? loyaltyData?.accountNumber
        : '',
      offerId: loyaltyData?.offerId ? loyaltyData?.offerId : '',
      isCoupon: loyaltyData?.isCoupon ? loyaltyData?.isCoupon : false,
    };
    props
      .paymentInitialization(dataToSend)
      .then(val => {
        props.setAuthResponse(val).then(() => {
          if (
            window.ReactNativeWebView &&
            getObjectValue(
              () =>
                props.auth?.cardReaderType !== 3 &&
                props.auth?.cardReaderType !== 5 &&
                props.auth?.cardReaderType !== 6 &&
                props.auth?.cardReaderType !== 7 &&
                props.auth?.cardReaderType !== 8 &&
                props.auth?.cardReaderType !== 9,
              false
            )
          ) {
            EventEmitter.removeListeners('processPayment', () => { });
            EventEmitter.removeListeners('processCreditSale', () => { });
            processSaleInit(val);
          } else if (
            getObjectValue(
              () =>
                props.auth?.cardReaderType === 3 ||
                props.auth?.cardReaderType === 5 ||
                props.auth?.cardReaderType === 6 ||
                props.auth?.cardReaderType === 8 ||
                props.auth?.cardReaderType === 7 ||
                props.auth?.cardReaderType === 9,
              false
            )
          ) {
            // if (supportsTips && isCounter) {
            //   const tipPercentages = [];
            //   props.auth.tipInfo.tips.forEach(item => {
            //     if (props.auth.tipInfo.ruleType === 1) {
            //       tipPercentages.push(item.value * 100);
            //     } else {
            //       tipPercentages.push(item.value);
            //     }
            //   });
            //   const dataTosend = {
            //     storeId: props.deviceInfo.storeId,
            //     deviceId: props.deviceInfo.deviceId,
            //     checkHeaderId: tableData?.id || null,
            //     totalAmount: (dataToSend.totalAmount * 100).toFixed(2),
            //     ticketId: val.ticket?.id.toString(),
            //     tipAmount: 0,
            //     tipPercentages,
            //   };
            //   setTipsMessage(CUSTOM_MESSAGES().TIPS_MESSAGE);
            //   props
            //     .getTips(dataTosend)
            //     .then(res => {
            //       ingenicoIPP350Payment(val, res.tipAmount / 100, true);
            //     })
            //     .catch(err => {
            //       setTipsMessage('');
            //       props.setErrorPopUp({
            //         res: err.message,
            //       });
            //       setPaymentType(8);
            //     });
            // } else {
            //   ingenicoIPP350Payment(val, tipAmount, false);
            // }
            ingenicoIPP350Payment(val, tipAmount, false);
          }
        });
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const returnCreditCardMethod = () => {
    // if (!isCounter) {
      if (
        getObjectValue(
          () =>
            props.auth?.cardReaderType === 3 ||
            props.auth?.cardReaderType === 5 ||
            props.auth?.cardReaderType === 6 ||
            props.auth?.cardReaderType === 8 ||
            props.auth?.cardReaderType === 7 ||
            props.auth?.cardReaderType === 9,
          false
        )
      ) {
        handlePaymentInit();
      } else {
        if (urlSearchParams('source') === 'stageSplit') {
          setPaymentType(23);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=23&type=${urlSearchParams('type')}&source=stageSplit`,
            { replace: true }
          );
        } else {
          setPaymentType(23);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=23&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        }
      }
    // }
    // else {
    //   return getObjectValue(
    //     () =>
    //       props.auth.cardReaderType === 3 ||
    //       props.auth.cardReaderType === 5 ||
    //       props.auth.cardReaderType === 6 ||
    //       props.auth.cardReaderType === 8 ||
    //       props.auth.cardReaderType === 7 ||
    //       props.auth.cardReaderType === 9,
    //     false
    //   )
    //     ? handlePaymentInit()
    //     : handleCreditCard();
    // }
  };

  const printListener = data => {
    if (data.type === 'error') {
      console.error(data.message);
    } else {
      props.closePrintNotification();
      if (window.location.pathname.includes('receipt')) {
        if (lockPaymentScreen) {
          setHideCancelIcon(false);
        }
      }
    }
  };

  const getBtnName = () => {
    const value = Object.keys(
      getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes, [])
    ).find(v => props.deviceInfo.deviceGroup.paymentTypes[v]);
    switch (value) {
      case 'creditCard':
        return { key: 'creditCard' };
      case 'cash':
        return { key: 'cash' };
      case 'scanToPay':
        return { key: 'scanToPay' };
      default:
        return { key: 'card' };
    }
  };

  const paymentBtn = () => {
    let btnName = { key: 'creditCard' };
    if (
      getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes, false) &&
      Object.keys(
        getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes, [])
      ).filter(v => props.deviceInfo.deviceGroup.paymentTypes[v]).length > 1
    ) {
      btnName = { key: 'all' };
    } else if (
      getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes, false) &&
      Object.keys(
        getObjectValue(() => props.deviceInfo.deviceGroup.paymentTypes, [])
      ).filter(v => props.deviceInfo.deviceGroup.paymentTypes[v]).length === 1
    ) {
      btnName = getBtnName();
    }
    return btnName;
  };

  const handleTipsRouteTo = type => {
    const selectedPaymentType =
      (window.sessionStorage.getItem('preAuth') && 'preAuth') ||
      type ||
      selectedPayment ||
      paymentBtn().key;
    switch (selectedPaymentType) {
      case 'giftCard': {
        setPaymentType(12);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=12&type=${urlSearchParams('type')}`,
          { replace: true }
        );
        break;
      }
      case 'creditCard':
        returnCreditCardMethod();
        break;
      case 'preAuth':
        handlePreAuth();
        break;
      default:
        break;
    }
  };

  const handlePreAuth = () => {
    const authResponse = getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('authResponse')),
      0
    );
    // eslint-disable-next-line no-undef
    const tipAmt =
      supportsTips &&
        getObjectValue(
          () =>
            props.auth?.cardReaderType === 3 ||
            props.auth?.cardReaderType === 5 ||
            props.auth?.cardReaderType === 6 ||
            props.auth?.cardReaderType === 8 ||
            props.auth?.cardReaderType === 7 ||
            props.auth?.cardReaderType === 9,
          false
        )
        ? (Number(tip) / 100).toFixed(2)
        : getObjectValue(
          () =>
            Number(
              JSON.parse(window.sessionStorage.getItem('tipAmt')).unpaidTips
            ).toFixed(2),
          0
        );
    const loyaltyData = getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('loyaltyData')),
      {}
    );
    const preAuthTicketId = window.sessionStorage.getItem('preAuth');
    const dataToSend = {
      message: '',
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: tableData.id,
      subtotalAmount: getObjectValue(() => tableData.subTotalAmount),
      taxAmount: getObjectValue(() => tableData.taxAmount),
      authAmount: 0,
      ticketSplitTypeId: Number(urlSearchParams('ticketSplitTypeId')),
      splitValue: Number(urlSearchParams('splitValue')),
      tipAmount: Number(tipAmt),
      // authorizationCode: "AUTH-1664280449388",
      paymentStageId: getObjectValue(
        () => props.paymentCheck.paymentStageId,
        null
      ),
      employeeCard: getObjectValue(
        () =>
          JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard,
        null
      ),
      isPreAuth: true,
      partialAuth: false,
      serviceChargeAmount: getObjectValue(
        () => authResponse.ticket?.serviceChargeAmount,
        0
      ),
      discountAmount: getObjectValue(
        () => authResponse.ticket?.discountAmount,
        0
      ),
      orderPay: isOrderPayMode,
      speedOrder: isCounter || props.speedOrderStatus || props.sendModeStatus,
      name: props.speedOrderName ? props.speedOrderName : null,
      accountNumber: loyaltyData?.accountNumber
        ? loyaltyData?.accountNumber
        : '',
      offerId: loyaltyData?.offerId ? loyaltyData?.offerId : '',
      isCoupon: loyaltyData?.isCoupon ? loyaltyData?.isCoupon : false,
      preAuthTicketId: Number(preAuthTicketId),
    };
    props
      .preAuthPayment(dataToSend)
      .then(res => {
        props
          .setAuthResponse(res)
          .then(() => {
            if (!skipSurvey) {
              getSurveyResponse();
            } else if (isServerApp || isPaymentTerminal) {
              setPaymentType(22);
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=22&type=${urlSearchParams('type')}`,
                { replace: true }
              );
            } else {
              setPaymentType(5);
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=5&type=${urlSearchParams('type')}`,
                { replace: true }
              );
            }
            window.sessionStorage.removeItem('preAuth');
          })
          .catch(err => {
            window.sessionStorage.removeItem('preAuth');
            setTipsMessage('');
            setTipAmount(0);
            props
              .paymentAuthError({ ...dataToSend, message: err.message })
              .then(() => {
                window.sessionStorage.removeItem('tipAmt');
                setPaymentType(8);
                props.navigate(
                  `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                  }?ticketSplitTypeId=${urlSearchParams(
                    'ticketSplitTypeId'
                  )}&splitValue=${urlSearchParams(
                    'splitValue'
                  )}&screenType=8&type=${urlSearchParams('type')}`,
                  { replace: true }
                );
              });
          });
      })
      .catch(err => {
        window.sessionStorage.removeItem('preAuth');
        setTipsMessage('');
        setTipAmount(0);
        props
          .paymentAuthError({ ...dataToSend, message: err.message })
          .then(() => {
            window.sessionStorage.removeItem('tipAmt');
            setPaymentType(8);
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
              }?ticketSplitTypeId=${urlSearchParams(
                'ticketSplitTypeId'
              )}&splitValue=${urlSearchParams(
                'splitValue'
              )}&screenType=8&type=${urlSearchParams('type')}`,
              { replace: true }
            );
          });
      });
  };

  const applyDonation = () => { };

  const handleTipsSubmit = setPayment => {
    setIsTipsConfirm(false);
    setIsAdvanceTipsConfirm(false);
    const tips = { totalTips: tipAmount, unpaidTips: tipAmount, paidTips: 0 };
    window.sessionStorage.setItem('tipAmt', JSON.stringify(tips));
    window.sessionStorage.setItem(
      'payAmt',
      getObjectValue(
        () =>
          Number(tipAmount) +
          Number(props.authResponse.checkHeader.taxAmount) +
          Number(props.authResponse.checkHeader.subTotalAmount),
        0
      )
    );
    // if (isCounter) {
    //   handleTipsRouteTo();
    // }
    // else {
      let tipAmountTotal = getTotalAmountForTip();
      applyTipForPayment({
        tipTypeValue: otherAmountOrPersent
          ? Number(tipAmount).toFixed(2)
          : Number((Number(tipAmount) / getTipAmount(tipAmountTotal)) * 100),
        tipType: otherAmountOrPersent ? 4 : 3,
      });
    // }
  };

  const handleReceiptPopUpOpen = type => {
    setIsReceipt({ isOpen: true, type });
  };

  const handlePartialGiftPayment = () => {
    if ((isPaymentTerminal || isServerApp)) {
      if (lockPaymentScreen) {
        setHideCancelIcon(false);
      }
    } else {
      setPaymentType(6);
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
        }?ticketSplitTypeId=${urlSearchParams(
          'ticketSplitTypeId'
        )}&splitValue=${urlSearchParams(
          'splitValue'
        )}&screenType=6&type=${urlSearchParams('type')}`,
        { replace: true }
      );
      if (lockPaymentScreen) {
        setHideCancelIcon(false);
      }
    }
    // else {
    //   props.navigate(`${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`, {
    //     replace: true,
    //   });
    //   if (lockPaymentScreen) {
    //     setHideCancelIcon(false);
    //   }
    // }
  };
  const swipeGiftCards = item => {
    if (window.ReactNativeWebView) {
      EventEmitter.changeOrientation({
        orientation: 'portrait',
      });
    }
    props.navigate(
      `${APP_CONFIG.BASE_URL}/giftcard/${props.seat.id}?type=payment&cardId=${item?.id}`,
      { replace: true }
    );
  };

  const isCashPayment = () =>
    props?.seat?.paymentCheck?.tickets?.[
      props?.seat?.paymentCheck?.tickets?.length - 1
    ]?.paymentTypeName === "Cash";

  const navigateToReceipt = (screenType) => {
    setPaymentType(screenType);
    props.navigate(
      `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck?.id
      }?ticketSplitTypeId=${urlSearchParams('ticketSplitTypeId')}
     &splitValue=${urlSearchParams('splitValue')}
     &screenType=${screenType}
     &type=${urlSearchParams('type')}`,
      { replace: true }
    );
  };

  const continueGiftCardPayment = isYesClick => {
    let value = JSON.parse(window.sessionStorage.getItem('seat'))?.paymentCheck
      ?.tickets[0]?.ticketPaymentTypeId;
    if (giftCardPaymentReceipt || !giftCardReceiptModal.show || isYesClick) {
      setGiftCardReceiptModal({ isOpen: false, show: true });
      if (value == 0) {
        setPaymentType(17);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=17&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      } else {
        if (
          !skipSurvey &&
          !urlSearchParams("preAuth")
        ) {
          if (isCashPayment()) {
            navigateToReceipt(22)
          }
          else getSurveyResponse();
        } else if (isServerApp || isPaymentTerminal) {
          navigateToReceipt(22);
        } else {
          setPaymentType(5);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=5&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        }
      }
      window.sessionStorage.removeItem('giftCardpayment');
    } else {
      setGiftCardReceiptModal({ isOpen: true, show: true });
    }
  };

  const handleReceipt = data => {
    let giftCardPayment = safeJsonParse(window.sessionStorage.getItem('giftCardpayment'), false);
    window.sessionStorage.getItem('giftCardpayment') &&
      window.sessionStorage.setItem(
        'giftCardReceiptData',
        JSON.stringify({ emailAddress: data?.email, phoneNumber: data?.phone })
      );
    const { ZipCode, ...restData } = data || {};
    const dataToSend = {
      ...restData,
      storeId: props.deviceInfo?.storeId,
      deviceId: props.deviceInfo?.deviceId,
      employeeId: props.userInfo?.id,
      employeeCard: getObjectValue(
        () =>
          JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard,
        null
      ),
      accountNumber: data?.accountNumber || null,
      phoneNumber: data?.phone || null,
      emailAddress: data?.email || null,
      paymentCheck: props.seat?.paymentCheck,
      checkHeaderId: props?.seat?.checkHeaderId || props?.seat?.id,
      ticketId:
        props?.seat?.paymentCheck?.cashTicketId ||
        props?.seat?.paymentCheck?.creditCardTicketId ||
        props?.seat?.paymentCheck?.giftCardTicketIds?.[0] ||
        props?.seat?.paymentCheck?.giftCardTicketId,
      receipt: {
        emailAddress: data.email || null,
        countryCode,
        phoneNumber: data.phone || null,
        optIn: data.optIn,
        ZipCode: ZipCode || null,
        ticketId:
          props?.seat?.paymentCheck?.cashTicketId ||
          props?.seat?.paymentCheck?.creditCardTicketId ||
          props?.seat?.paymentCheck?.giftCardTicketIds?.[0] ||
          props?.seat?.paymentCheck?.giftCardTicketId,
      },
    };

    if (giftCardPayment) {
      dataToSend.cardIds = props.seat?.cards?.map(s => s.id);
    }
    if (isReceipt.type === 'email') {
      props
        .receiptEmail(dataToSend, giftCardPayment)
        .then(() => {
          setGiftCardPaymentReceipt(true);
          setGiftCardReceiptModal({ isOpen: false, show: false });
          window.sessionStorage.removeItem('counterPhoneNumber');
          // if (isCounter) {
          //   props.navigate(`${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`, {
          //     replace: true,
          //   });
          //   if (lockPaymentScreen) {
          //     setHideCancelIcon(false);
          //   }
          // }
          if (!(isPaymentTerminal || isServerApp)) {
            setPaymentType(6);
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
              }?ticketSplitTypeId=${urlSearchParams(
                'ticketSplitTypeId'
              )}&splitValue=${urlSearchParams(
                'splitValue'
              )}&screenType=6&type=${urlSearchParams('type')}`,
              { replace: true }
            );
            if (lockPaymentScreen) {
              setHideCancelIcon(false);
            }
          }
          setIsReceipt({ isOpen: false, type: '' });
          props.showSuccessCheckMark();
          if (!giftCardPayment) {
            setsmsEmailPrintObject(prev => ({
              ...prev,
              emailReceiptStatus: !smsEmailPrintObject.emailReceiptStatus,
            }));
          }
        })
        .catch(err => {
          setGiftCardReceiptModal({ isOpen: false, show: true });
          setGiftCardPaymentReceipt(false);
          setIsReceipt({ isOpen: false, type: '' });
          props.setErrorPopUp({
            errorMsg: err.message,
          });
        });
    } else {
      props
        .receiptSms(
          dataToSend,
          safeJsonParse(window.sessionStorage.getItem('giftCardpayment'), false)
        )
        .then(() => {
          setGiftCardPaymentReceipt(true);
          window.sessionStorage.removeItem('counterPhoneNumber');
          setIsReceipt({ isOpen: false, type: '' });
          handlePartialGiftPayment();
          props.showSuccessCheckMark();
          if (!giftCardPayment) {
            setsmsEmailPrintObject(prev => ({
              ...prev,
              smsReceiptStatus: !smsEmailPrintObject.smsReceiptStatus,
            }));
          }
        })
        .catch(err => {
          setGiftCardReceiptModal({ isOpen: false, show: true });
          setGiftCardPaymentReceipt(false);
          props.setErrorPopUp({
            errorMsg: err.message,
          });
          setIsReceipt({ isOpen: false, type: '' });
        });
    }
  };

  const processSaleInitCreditTokenize = saleResponse => {
    const data = {
      type: 'processCreditTokenize',
      data: {
        merchantInvoiceId: saleResponse.ticket?.id.toString(),
        employeeId: saleResponse.checkHeader.employeeId.toString(),
        latitude: '0',
        longitude: '0',
        notes: '',
        referenceId:
          saleResponse.ticket?.id.toString() ||
          saleResponse.ticket?.referenceId,
        subtotalAmount: '0',
        taxAmount: '0',
      },
    };
    EventEmitter.sendMessage(
      data,
      res => {
        console.log(res, 'response');
      },
      err => {
        console.log(err, 'response');
      }
    );
    props.navigate(
      `${APP_CONFIG.BASE_URL}/receipt/${props.seat.id}?ticketSplitTypeId=1&splitValue=1&screenType=3&type=payType&preAuth=true`,
      { replace: true }
    );
  };

  const preAuthFunctionCall = () => {
    setHideCancelIcon(true);
    const payCheck = JSON.parse(window.sessionStorage.getItem('seat'));
    const subTotalAmount = 0;
    const taxAmount = 0;
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: payCheck.id,
      ticketSplitTypeId: 1,
      phoneNumber: '',
      countryCode: '',
      splitValue: 1,
      paymentStageId: getObjectValue(
        () => props.paymentCheck.paymentStageId,
        null
      ),
      subTotalAmount,
      taxAmount,
      totalAmount: 0,
      unpaidAmount: 0,
      seatIds: SeatIds(),
      serviceChargeAmount: 0,
      discountAmount: 0,
      orderPay: isOrderPayMode,
      employeeCard: getObjectValue(
        () =>
          JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard,
        null
      ),
      speedOrder: isCounter || props.speedOrderStatus || props.sendModeStatus,
      name: props.speedOrderName ? props.speedOrderName : null,
      preAuth: true,
    };

    props
      .paymentInitialization(dataToSend)
      .then(val => {
        props.setAuthResponse(val).then(() => {
          props.setPaymentCheck(val.checkHeader);
          if (
            window.ReactNativeWebView &&
            getObjectValue(
              () =>
                props.auth?.cardReaderType !== 3 &&
                props.auth?.cardReaderType !== 5 &&
                props.auth?.cardReaderType !== 6,
              false
            )
          ) {
            EventEmitter.removeListeners('processCreditTokenize', () => { });
            processSaleInitCreditTokenize(val);
          }
        });
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const handleRetry = () => {
    setErrorMessage('');
    if (
      (isTableTop) &&
      (paymentBtn().key === 'creditCard') &&
      getObjectValue(
        () =>
          props.auth?.cardReaderType === 3 ||
          props.auth?.cardReaderType === 5 ||
          props.auth?.cardReaderType === 6 ||
          props.auth?.cardReaderType === 8 ||
          props.auth?.cardReaderType === 7 ||
          props.auth?.cardReaderType === 9,
        false
      )
    ) {
      setPaymentType(15);
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
        }?ticketSplitTypeId=${urlSearchParams(
          'ticketSplitTypeId'
        )}&splitValue=${urlSearchParams(
          'splitValue'
        )}&screenType=15&type=${urlSearchParams('type')}`,
        { replace: true }
      );
    }
    // else if (
    //   isCounter &&
    //   getObjectValue(
    //     () =>
    //       props.auth.cardReaderType !== 3 ||
    //       props.auth.cardReaderType !== 5 ||
    //       props.auth.cardReaderType !== 6,
    //     false
    //   )
    // ) {
    //   returnCreditCardMethod();
    // }
    else if (urlSearchParams('preAuth')) {
      preAuthFunctionCall();
    } else {
      setPaymentType(31);
      window.sessionStorage.removeItem('tipAmt');
      setTipAmount(0);
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
        }?ticketSplitTypeId=${urlSearchParams(
          'ticketSplitTypeId'
        )}&splitValue=${urlSearchParams(
          'splitValue'
        )}&screenType=31&type=${urlSearchParams('type')}`,
        { replace: true }
      );
    }
    if (lockPaymentScreen) {
      setHideCancelIcon(false);
    }
    setCancelOrderConfirm(false);
  };

  const stopPopUp = () => {
    switch (active) {
      case LABEL().CUSTOM_AMOUNT:
      case LABEL().CUSTOM_PERCENT:
        setIsTipsConfirm(true);
        break;
      default:
        handleTipsSubmit();
        break;
    }
  };

  // const stopPopUpOtherAmount = () => {
  //   setIsTipsConfirm(true);
  // };

  const getTipAmount = tipAmount => {
    let calculatedTipAmount =
      (Number(tableData?.unpaidAmount) / Number(tableData?.totalAmount)) *
      Number(tipAmount);
    return Number(calculatedTipAmount);
  };

  const applyTipForPayment = data => { 
    const tipObject = {
      tipAmount:
        'tipAmount' in data ? data.tipAmount : Number(tipAmount)?.toFixed(2),
      tipType: data?.tipType,
      tipTypeValue:
        'tipTypeValue' in data
          ? Number(data.tipTypeValue).toFixed(2)
          : Number(active)?.toFixed(2),
      suggestedTipExcludesDiscount: getObjectValue(
        () => props.auth.tipInfo.suggestedTipExcludesDiscount,
        false
      ),
      suggestedTipIncludesTax: getObjectValue(
        () => props.auth.tipInfo.suggestedTipIncludesTax,
        false
      ),
      useTipToRoundUpTotal: checkboxactive,
    };

    const tipOfTipOnlyPay = {
      tipAmount: Number(tipAmount)?.toFixed(2),
      tipType: 4,
      tipTypeValue: Number(tipAmount ?? 0).toFixed(2),
      suggestedTipExcludesDiscount: getObjectValue(
        () => props.auth.tipInfo.suggestedTipExcludesDiscount,
        false
      ),
      suggestedTipIncludesTax: getObjectValue(
        () => props.auth.tipInfo.suggestedTipIncludesTax,
        false
      ),
      useTipToRoundUpTotal: checkboxactive,
    };    
    let dataToSend = {
      storeId: props.seat?.storeId,
      deviceId: props.deviceInfo?.deviceId,
      employeeId: props.userInfo?.id,
      checkHeaderId: props.seat?.checkHeaderId || props.seat?.id,
      tip: props?.isTipOnlyEnabled ? tipOfTipOnlyPay : tipObject,
      paymentCheck: props?.seat?.paymentCheck,
      paymentChecks: props?.seat?.paymentChecks,
    };
    props
      .applyTipForPayment(dataToSend)
      .then(res => {
        if (props?.isTipOnlyEnabled) window.sessionStorage.setItem("otherTipAmount", tipAmount);
        props.setSeat({
          ...props.seat,
          paymentCheck: res.paymentCheck,
          paymentChecks: res.paymentChecks,
        });
        props
          .setPaymentCheck({
            ...props.paymentCheck,
            paymentCheck: res.paymentCheck,
          })
          .then(() => {
            if (
              (props.deviceInfo !== null &&
              props.deviceInfo?.deviceGroup !== null &&
              props.deviceInfo?.deviceGroup?.serverAppSettings?.powerPaymentOnly) || props?.isTipOnlyEnabled
            ) {
              props.toggleOtherPaymentOption();
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${res.paymentCheck.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=32&type=${urlSearchParams('type')}`,
                { replace: true }
              );
              setPaymentType(32);
            } else {
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${res.paymentCheck.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=31&type=${urlSearchParams('type')}`,
                { replace: true }
              );
              setPaymentType(31);
            }
          });
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const validateTipsForCredit = selectedAmount => {
    if (props?.isTipOnlyEnabled) {
      validateTipForTipOnly(selectedAmount);
      return;
    }
    if (
      hasAutoGratuity
        ? props.auth.autoGratuityTipInfo?.requireTipSelection &&
        [''].includes(active) &&
        props.auth.autoGratuityTipInfo.tips?.length > 0
        : supportsTips && [''].includes(active) && isTipRequried
    ) {
      props.setErrorPopUp({
        res: CUSTOM_MESSAGES().ENTER_TIP_MSG,
        noErrorTxt: true,
      });
    } else {
      if (active === 'otherAmount' && [4].includes(paymentType)) {
        props?.deviceInfo?.deviceGroup?.serverAppSettings?.powerPaymentOnly ? setPaymentType(32) : setPaymentType(31);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=31&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      } else {
        applyTipForPayment({
          tipType: hasAutoGratuity
            ? props.auth.autoGratuityTipInfo.ruleType
            : props.auth.tipInfo.ruleType,
          tipAmount: selectedAmount,
        });
      }
    }
  };

  // For only Tip Only Flow
  const validateTipForTipOnly = selectedAmount => {
    if (props?.isTipOnlyEnabled && Number(tipAmount) === 0) {
      props.setErrorPopUp({
        res: CUSTOM_MESSAGES().ENTER_TIP_MSG,
        noErrorTxt: true,
      });
    } else {
      applyTipForPayment({
        tipType: hasAutoGratuity
          ? props.auth.autoGratuityTipInfo.ruleType
          : props.auth.tipInfo.ruleType,
        tipAmount: selectedAmount,
      });
    }
  } 

  const validateTips = data => {
    let tip = tipAmount + '';
    // if (
    //   supportsTips &&
    //   [''].includes(active) &&
    //   (isTipRequried && isCounter ? Number(tipAmount) >= 0 : !tip) &&
    //   data != 'No Tip'
    // ) {
    //   props.setErrorPopUp({
    //     res: CUSTOM_MESSAGES().ENTER_TIP_MSG,
    //   });
    // }
    if (supportsTips) {
      stopPopUp();
    } else {
      handleTipsRouteTo();
    }
  };

  const handleTextToPay = () => {
    const dataToSend = {
      latitude: '0',
      longitude: '0',
      deviceId: props.deviceInfo.deviceId,
      storeId: props.deviceInfo.storeId,
      checkHeaderId: tableData.id,
    };
    props
      .textToPay(dataToSend)
      .then(res => {
        props
          .setAuthResponse({
            ...res,
            checkHeader: {
              ...res.checkHeader,
              paidAmount: res.checkHeader.totalAmount,
              unpaidAmount: 0,
            },
          })
          .then(() => {
            setSuccesMessage(`${LABEL().TEXT_TO_PAY} Sent`);
            setPaymentType(6);
            props.history.replace({
              pathname: `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=6&type=${urlSearchParams('type')}`,
            });
            if (lockPaymentScreen) {
              setHideCancelIcon(false);
            }
          });
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const routeToGiftCard = () => {
    const updatedData = {
      ...props.paymentCheck,
      unpaidTips: 0,
      paidTips: 0,
    };
    props.setPaymentCheck(updatedData).then(() => {
      props.history.replace({
        pathname: `${APP_CONFIG.BASE_URL}/receipt/${updatedData.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=12&type=${urlSearchParams('type')}`,
      });
    });
  };

  const isTipsRequiredCheck = (type, check) => {
    if (tipInfo === null) {
      if (type === 'creditCard') {
        setPaymentType(23);
        setSelectedPayment(type);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=23&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      } else if (type === 'giftCard') {
        setPaymentType(12);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=12&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      }
    } else {
      const unpaidTips = getObjectValue(
        () => JSON.parse(window.sessionStorage.getItem('tipAmt')).unpaidTips,
        tipAmount
      );
      setSelectedPayment(type);
      setTipAmount(Number(unpaidTips).toFixed(2));
      if (
        Number(unpaidTips).toFixed(2) > 0 ||
        (hideSignature && !supportsTips)
      ) {
        switch (type) {
          case 'giftCard':
            routeToGiftCard();
            break;
          case 'creditCard': {
            const updatedData = check
              ? {
                ...check,
                unpaidTips: 0,
                paidTips: 0,
              }
              : {
                ...props.paymentCheck,
                unpaidTips: 0,
                paidTips: 0,
              };
            props.setPaymentCheck(updatedData).then(() => {
              returnCreditCardMethod();
            });
            break;
          }
          case 'preAuth':
            {
              const updatedData = check
                ? {
                  ...check,
                  unpaidTips: 0,
                  paidTips: 0,
                }
                : {
                  ...props.paymentCheck,
                  unpaidTips: 0,
                  paidTips: 0,
                };
              props.setPaymentCheck(updatedData).then(() => {
                handlePreAuth();
              });
            }
            break;
          default:
            break;
        }
      } else if (props?.deviceInfo?.deviceGroup?.brandTipId && isTableTop) {
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=4&type=${urlSearchParams('type')}`,
          { replace: true }
        );
        setPaymentType(4);
      } else if (isServerApp || isPaymentTerminal) {
        if (urlSearchParams('source') === 'stageSplit') {
          setPaymentType(4);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=4&type=${urlSearchParams('type')}&source=stageSplit`,
            { replace: true }
          );
        } else {
          setPaymentType(4);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=4&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        }
      } else {
        setPaymentType(4);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=4&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      }
    }
  };



  const allowCashPaymentWithLogin = () => {
    if (
      (props.userInfo.jobId &&
        props.employeeJobHashTable[props.userInfo.jobId]
          .allowCashWithoutLogin) ||
      isWalkUp
    ) {
      setPaymentType(16);
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
        }?ticketSplitTypeId=${urlSearchParams(
          'ticketSplitTypeId'
        )}&splitValue=${urlSearchParams(
          'splitValue'
        )}&screenType=16&type=${urlSearchParams('type')}`,
        { replace: true }
      );
    } else {
      setIsCashPaymentCheck(true);
    }
  };

  const QrPayRouteFrom = () => {
    setPaymentType(6);
    props.navigate(
      `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
      }?ticketSplitTypeId=${urlSearchParams(
        'ticketSplitTypeId'
      )}&splitValue=${urlSearchParams(
        'splitValue'
      )}&screenType=6&type=${urlSearchParams('type')}`,
      { replace: true }
    );
    setSuccesMessage(CUSTOM_MESSAGES().QR_PAY_COMPLETED_INFO);
  };

  const handleQRpay = () => {
    props.setPaymentCheck({ ...props.paymentCheck }).then(() => {
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id}?ticketSplitTypeId=1&splitValue=1&screenType=14&type=qrScanPay`,
        { replace: true }
      );
    });
  };

  const handleRouteCheck = () => {
    if (urlSearchParams('type') === 'qrScanPay') {
      props.navigate(`${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`, {
        replace: true,
      });
    } else {
      handleRoute();
    }
  };

  const handleDrawerOpen = () => {
    // if (!isCounter) {
      setPaymentType(22);
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
        }?ticketSplitTypeId=${urlSearchParams(
          'ticketSplitTypeId'
        )}&splitValue=${urlSearchParams(
          'splitValue'
        )}&screenType=22&type=${urlSearchParams('type')}`,
        { replace: true }
      );
      if (lockPaymentScreen) {
        setHideCancelIcon(false);
      }
    // }
    // else {
    //   setPaymentType(18);
    //   props.navigate(
    //     `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
    //     }?ticketSplitTypeId=${urlSearchParams(
    //       'ticketSplitTypeId'
    //     )}&splitValue=${urlSearchParams(
    //       'splitValue'
    //     )}&screenType=18&type=${urlSearchParams('type')}`,
    //     { replace: true }
    //   );
    // }
  };
  const handleCheck = (type, data) => {
    switch (type) {
      case 'cash':
        allowCashPaymentWithLogin();
        break;
      case 'creditCard':
        isTipsRequiredCheck('creditCard');
        break;
      case 'externalCreditCard':
        setExternalId(true);
        setKeyboardValue('');
        setCustomTipModelOpen(true);
        setActive(LABEL().CUSTOM_AMOUNT);
        break;
      case 'tips':
        validateTips(data);
        break;
      case 'giftCard':
        isTipsRequiredCheck('giftCard');
        break;
      case 'receipt':
        handlePartialGiftPayment();
        break;
      case 'textToPay':
        handleTextToPay();
        break;
      case 'qrPay':
        handleQRpay();
        break;
      case 'qrPayRoute':
        QrPayRouteFrom();
        break;
      case 'counterCashPay':
        handleCashPayment(data);
        break;
      case 'drawerOpen':
        handleDrawerOpen();
        break;
      case 'print':
        handlePrint();
        break;
      case 'preAuth':
        isTipsRequiredCheck('preAuth');
        break;

      default:
        break;
    }
  };

  const handleDirectToCashConfirmation = () => {
    setDirectToCashCOnfirmation(true);
  };

  const paymentRoute = (key, updatedData, ticketSplitTypeId) => {
    switch (key) {
      case 'creditCard':
        isTipsRequiredCheck(paymentBtn().key, updatedData);
        break;
      case 'cash':
        handleCashPayment();
        break;
      case 'scanToPay':
        break;
      case 'all':
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${updatedData.id}?ticketSplitTypeId=${ticketSplitTypeId}&splitValue=1&screenType=2`,
          { replace: true }
        );
        break;
      default:
        isTipsRequiredCheck(paymentBtn().key, updatedData);
        break;
    }
  };

  const handlePayAnAmount = values => {
    const amount = +values.payAnAmount;
    const unpaidTips = tableData.unpaidTips || 0;
    const checkTotal =
      props.auth.country === 1 || props.auth.country === 2
        ? +(
          props.seat.itemAmount +
          tableData.taxAmount +
          tableData.serviceChargeAmount -
          tableData.discountAmount +
          unpaidTips
        )
        : props.seat.itemAmount +
        tableData.serviceChargeAmount -
        tableData.discountAmount +
        unpaidTips;
    const tips = Number(unpaidTips).toFixed(2);
    const taxAmount = +((amount * props.seat.taxAmount) / checkTotal).toFixed(
      2
    );
    const serviceChargeAmount =
      props.seat.serviceChargeAmount > 0
        ? +((amount * props.seat.serviceChargeAmount) / checkTotal).toFixed(2)
        : 0;
    const discountAmount =
      props.seat.discountAmount > 0
        ? +((amount * props.seat.discountAmount) / checkTotal).toFixed(2)
        : 0;
    const subTotalAmount =
      props.auth.country === 1 || props.auth.country === 2
        ? +(
          amount -
          (taxAmount + serviceChargeAmount) +
          discountAmount -
          tips
        ).toFixed(2)
        : amount - (taxAmount + serviceChargeAmount) + discountAmount - tips;
    const ticketSplitTypeId = values?.isPayFullCheck ? 1 : 2;
    setTipAmount(tips);
    const updatedData = {
      ...props.seat,
      subTotalAmount,
      unpaidAmount: amount,
      taxAmount,
      paidAmount: 0,
      tipAmount: 0,
      totalAmount: +(
        subTotalAmount +
        taxAmount +
        serviceChargeAmount -
        discountAmount
      ),
      serviceChargeAmount,
      discountAmount,
      unpaidTips: 0,
      paidTips: 0,
    };
    props.setPaymentCheck(updatedData).then(() => {
      if (isTableTop) {
        paymentRoute(paymentBtn().key, updatedData, ticketSplitTypeId);
      } else {
        props.history.replace({
          pathname: `${APP_CONFIG.BASE_URL}/receipt/${updatedData.id
            }?ticketSplitTypeId=${Number(urlSearchParams('ticketSplitTypeId')) === 3
              ? 3
              : ticketSplitTypeId
            }&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=2&type=payType`,
        });
      }
    });
    if (props.auth?.loyaltyInfo?.supportsLoyalty) {
      props.setPaymentFlowType(2);
    }
  };

  const onPayFullCheckHandler = () => {
    let dataToSend = {
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: props.seat.checkHeaderId,
      storeId: props.seat.storeId,
      unpaidAmount: props.seat.unpaidAmount,
      totalAmount: props.seat.totalAmount,
      paidAmount: props.seat.paidAmount,
      splitType: 0,
      checkLoyaltyId:
        loyaltyList?.length <= 1 ? loyaltyList[0]?.id : selectedLoyalty?.id,
    };
    props
      .paymentSplitCheck(dataToSend)
      .then(res => {
        const syncedCheck = res?.check || data;
        let updatedData = {
          ...syncedCheck,
          control: res?.control,
          checkHeaderId: res?.checkHeaderId,
          storeId: res?.storeId,
          giftCard: res?.giftCard,
          offer: res?.offer,
          paymentCheck: res?.paymentCheck,
          paymentChecks: res?.paymentChecks,
          availableLoyaltyOffers: res?.availableLoyaltyOffers,
          check: res?.check,
        };
        props.setSeat(updatedData);
        if (window.ReactNativeWebView) {
            if (isLandScape) {
            EventEmitter.changeOrientation({
              orientation: 'landscape',
            });
          } else {
            EventEmitter.changeOrientation({
              orientation: 'portrait',
            });
          }
        }
        props.setPaymentCheck(updatedData).then(() => {
          if (Object.keys(res?.availableLoyaltyOffers).length === 0) {
            handleSplitLyltSubmit(res?.paymentCheck?.splitType);
          } else {
            if (window.ReactNativeWebView) {
              EventEmitter.changeOrientation({
                orientation: 'landscape',
              });
            }
            setNewOfferPopUp(true);
          }
        });
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message || err,
        });
      });
  };
  const handleCreditCardDeleteBalance = async (type, payType) => {
    const dataToSend = {
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: tableData?.id,
      storeId: props.deviceInfo.storeId,
      creditCard: {},
      paymentCheck: props?.seat?.paymentCheck,
      paymentChecks: props?.seat?.paymentChecks,
    };
    try {
      let res = await props.creditCardDeleteBalance(dataToSend);
      props.setSeat({
        ...props.seat,
        paymentCheck: res.paymentCheck,
        paymentChecks: res.paymentChecks,
      });
      if (payType === CASH) {
        setPaymentType(16);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.seat.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=16&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      } else if (payType === GIFT_CARD) {
        setPaymentType(12);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.seat.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=12&type=giftCardPay`,
          { replace: true }
        );
      } else if (payType === CREDIT_CARD) {
        if (
          props?.deviceInfo?.deviceGroup?.serverAppSettings?.powerPaymentOnly
        ) {
          if (tipInfo) {
            setPaymentType(4);
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${props?.seat?.paymentCheck?.id
              }?ticketSplitTypeId=${urlSearchParams(
                'ticketSplitTypeId'
              )}&splitValue=${urlSearchParams(
                'splitValue'
              )}&screenType=4&type=${urlSearchParams('type')}`,
              { replace: true }
            );
          } else {
            setPaymentType(28);
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${props?.seat?.paymentCheck?.id
              }?ticketSplitTypeId=${urlSearchParams(
                'ticketSplitTypeId'
              )}&splitValue=${urlSearchParams(
                'splitValue'
              )}&screenType=28&type=${urlSearchParams('type')}`,
              { replace: true }
            );
          }
        } else if (isDriveThru || isCounter || isCallCenter){
            props.navigate(`${APP_CONFIG.BASE_URL}/orders`, { replace: true })
        } else {
          setPaymentType(31);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props?.seat?.paymentCheck?.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=31&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        }
      }
      setCreditCardAmount(
        String(
          Number(props?.seat?.paymentCheck?.paymentAmount || 0)?.toFixed(2)
        ) || '0'
      );
      setIsAmountEdit({ isOpen: false, isError: false, isFirstClick: true });
      setPayModeType(DEFAULT);
    } catch (err) {
      props.setErrorPopUp({
        res: err.message,
      });
      throw err;
    }
  };

  const handleGiftCardBalanceCheck = data => {
    const dataToSend = {
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      employeeCard: props.userInfo?.employeeCard,
      checkHeaderId: tableData?.id,
      storeId: props.deviceInfo.storeId,
      giftCard: {
        method: data?.method || 'type',
        accountNumber: data?.accountNumber,
        securityCode: data?.securityCode,
        paymentAmount: Number(creditCardAmount) || props?.seat?.paymentCheck?.paymentAmount || 0,
      },
      paymentCheck: props?.seat?.paymentCheck,
      paymentChecks: props?.seat?.paymentChecks,
    };
    props.giftCardBalanceCheck(dataToSend)
      .catch(err => {
        props.setErrorPopUp({
          res: err.message || err,
        });
      });
  };

  const handleGiftCard = data => {

    if (data.fromBalanceScreen) {

      const applyGiftCardData = {
        deviceId: props.deviceInfo.deviceId,
        employeeId: Number(props.userInfo.id),
        employeeCard: props.userInfo?.employeeCard,
        checkHeaderId: tableData?.id,
        storeId: props.deviceInfo.storeId,
        giftCard: {
          method: data.method,
          accountNumber: data?.cardNumber,
          securityCode: data?.securityCode,
          paymentAmount: data?.paymentAmount || props?.giftCardBalanceInfo?.paymentAmount || Number(creditCardAmount) || props?.seat?.paymentCheck?.paymentAmount,
        },
        paymentCheck: props?.seat?.paymentCheck,
        paymentChecks: props?.seat?.paymentChecks,
      };

      props
        .applyGiftCardBalance(applyGiftCardData)
        .then(applyRes => {
          const extractedGiftCards = applyRes?.paymentCheck?.giftCards?.length > 0
            ? applyRes?.paymentCheck?.giftCards
            : (applyRes?.paymentCheck?.giftCard ? [applyRes?.paymentCheck?.giftCard] : []);

          const paymentCheckWithGiftCard = {
            ...applyRes?.paymentCheck,
            giftCards: extractedGiftCards,
          };

          let initDataToSend = {
            storeId: props?.deviceInfo?.storeId,
            deviceId: props?.deviceInfo?.deviceId,
            employeeId: props?.userInfo?.id,
            checkHeaderId: tableData?.id,
            employeeCard: getObjectValue(
              () =>
                JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard,
              null
            ),
            paymentCheck: paymentCheckWithGiftCard,
            paymentChecks: applyRes?.paymentChecks,
          };

          return props.paymentNewInitialization(initDataToSend);
        })
        .then(val => {
          const giftCards = val?.paymentCheck?.giftCards?.length > 0
            ? val?.paymentCheck?.giftCards
            : (val?.paymentCheck?.giftCard ? [val?.paymentCheck?.giftCard] : []);

          const giftCardTicketIds = giftCards.map(gc => gc.ticketId).filter(id => id);

          const payLoad = {
            storeId: props?.deviceInfo?.storeId,
            deviceId: props?.deviceInfo?.deviceId,
            employeeId: props?.userInfo?.id,
            employeeCard: props?.userInfo?.employeeCard,
            checkHeaderId: tableData?.id,
            paymentCheck: {
              ...val?.paymentCheck,
              giftCardTicketIds: giftCardTicketIds,
              giftCards: giftCards,
            },
            paymentChecks: val?.paymentChecks,
            creditCard: null,
            giftCardTicketIds: giftCardTicketIds,
            giftCards: giftCards,
          };

          paymentFn(payLoad)
            .then(res => {

              props.clearSelectedOffers();

              const mergedPaymentCheck = {
                ...res.paymentCheck,
                giftCards: (res.paymentCheck.giftCards?.length > 0)
                  ? res.paymentCheck.giftCards
                  : (res.paymentCheck.giftCard ? [res.paymentCheck.giftCard] : giftCards),
              };

              Promise.all([
                props.setSeat({
                  ...props.seat,
                  paymentCheck: mergedPaymentCheck,
                  paymentChecks: res.paymentChecks,
                }),
                props.setPaymentCheck({
                  ...props.paymentCheck,
                  paymentCheck: mergedPaymentCheck,
                })
              ]).then(() => {
                props.clearGiftCardBalanceInfo();

                if (res?.paymentCheck?.paymentAmount > 0) {
                  setCreditCardAmount(
                    String(Number(res?.paymentCheck?.paymentAmount || 0)?.toFixed(2)) || '0'
                  );
                  setPayModeType(GIFT_CARD);

                  if (urlSearchParams('type') === 'giftCardPay') {
                    setPaymentType(32);
                    props.navigate(
                      `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.checkHeaderId
                      }?ticketSplitTypeId=${Number(
                        urlSearchParams('ticketSplitTypeId')
                      )}&splitValue=${urlSearchParams('splitValue')}&screenType=32&type=giftCardPay`,
                      { replace: true }
                    );
                  } else {
                    setPaymentType(31);
                    props.navigate(
                      `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.checkHeaderId
                      }?ticketSplitTypeId=${Number(
                        urlSearchParams('ticketSplitTypeId')
                      )}&splitValue=${urlSearchParams('splitValue')}&screenType=31&type=${urlSearchParams('ticketSplitTypeId') === '1'
                        ? 'payType'
                        : 'splitType'
                      }`,
                      { replace: true }
                    );
                  }
                } else {

                  if (res.control?.partialPayment) {
                    setPaymentConfirmation(prevState => ({
                      ...prevState,
                      isPaymentPartiallyComplete: true,
                      isPaymentFailed: false,
                    }));
                  } else {

                    setPaymentConfirmation(prevState => ({
                      ...prevState,
                      isPaymentComplete: true,
                      isPaymentFailed: false,
                    }));
                  }


                  if (isDriveThru || isCounter || isCallCenter) {
                    handlePaymentForDriveThru(res);
                  } else {
                    setPaymentType(33);
                    props.navigate(
                      `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                      }?ticketSplitTypeId=${urlSearchParams(
                        'ticketSplitTypeId'
                      )}&splitValue=${urlSearchParams(
                        'splitValue'
                      )}&screenType=33&type=${urlSearchParams('type')}`,
                      { replace: true }
                    );
                  }
                }
              });
            })
            .catch(err => {
              const errorDataToSend = {
                storeId: props?.deviceInfo?.storeId,
                deviceId: props?.deviceInfo?.deviceId,
                employeeId: props?.userInfo?.id,
                employeeCard: props?.userInfo?.employeeCard,
                checkHeaderId: tableData?.id,
                paymentCheck: props.seat?.paymentCheck,
              };

              const clearGiftCardData = {
                deviceId: props.deviceInfo.deviceId,
                employeeId: Number(props.userInfo.id),
                employeeCard: props.userInfo?.employeeCard,
                checkHeaderId: tableData?.id,
                storeId: props.deviceInfo.storeId,
                giftCard: props?.seat?.paymentCheck?.giftCards?.[props?.seat?.paymentCheck?.giftCards?.length - 1] || {},
                paymentCheck: props?.seat?.paymentCheck,
                paymentChecks: props?.seat?.paymentChecks,
              };

              Promise.all([
                props.paymentNewPaymentError(errorDataToSend),
                props.giftCardDeleteBalance(clearGiftCardData)
              ])
                .then(() => {
                  props.clearGiftCardBalanceInfo();
                  if (urlSearchParams('type') === 'giftCardPay') {
                    setPayModeType(GIFT_CARD);
                    setPaymentType(32);
                    props.navigate(
                      `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.checkHeaderId
                      }?ticketSplitTypeId=${Number(
                        urlSearchParams('ticketSplitTypeId')
                      )}&splitValue=${urlSearchParams('splitValue')}&screenType=32&type=giftCardPay`,
                      { replace: true }
                    );
                  } else {
                    setPaymentType(31);
                    props.navigate(
                      `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.checkHeaderId
                      }?ticketSplitTypeId=${Number(
                        urlSearchParams('ticketSplitTypeId')
                      )}&splitValue=${urlSearchParams('splitValue')}&screenType=31&type=${urlSearchParams('ticketSplitTypeId') === '1'
                        ? 'payType'
                        : 'splitType'
                      }`,
                      { replace: true }
                    );
                  }
                })
                .catch((errorEndpointErr) => {
                  props.clearGiftCardBalanceInfo();
                  if (urlSearchParams('type') === 'giftCardPay') {
                    setPayModeType(GIFT_CARD);
                    setPaymentType(32);
                    props.navigate(
                      `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.checkHeaderId
                      }?ticketSplitTypeId=${Number(
                        urlSearchParams('ticketSplitTypeId')
                      )}&splitValue=${urlSearchParams('splitValue')}&screenType=32&type=giftCardPay`,
                      { replace: true }
                    );
                  } else {
                    setPaymentType(31);
                    props.navigate(
                      `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.checkHeaderId
                      }?ticketSplitTypeId=${Number(
                        urlSearchParams('ticketSplitTypeId')
                      )}&splitValue=${urlSearchParams('splitValue')}&screenType=31&type=${urlSearchParams('ticketSplitTypeId') === '1'
                        ? 'payType'
                        : 'splitType'
                      }`,
                      { replace: true }
                    );
                  }
                });

              props.setErrorPopUp({
                res: err.message,
              });
            });
        })
        .catch(err => {
          const errorDataToSend = {
            storeId: props?.deviceInfo?.storeId,
            deviceId: props?.deviceInfo?.deviceId,
            employeeId: props?.userInfo?.id,
            employeeCard: props?.userInfo?.employeeCard,
            checkHeaderId: tableData?.id,
            paymentCheck: props.seat?.paymentCheck,
          };

          const clearGiftCardData = {
            deviceId: props.deviceInfo.deviceId,
            employeeId: Number(props.userInfo.id),
            employeeCard: props.userInfo?.employeeCard,
            checkHeaderId: tableData?.id,
            storeId: props.deviceInfo.storeId,
            giftCard: props?.seat?.paymentCheck?.giftCards?.[props?.seat?.paymentCheck?.giftCards?.length - 1] || {},
            paymentCheck: props?.seat?.paymentCheck,
            paymentChecks: props?.seat?.paymentChecks,
          };

          Promise.all([
            props.paymentNewPaymentError(errorDataToSend),
            props.giftCardDeleteBalance(clearGiftCardData)
          ])
            .then(() => {
              props.clearGiftCardBalanceInfo();
              if (urlSearchParams('type') === 'giftCardPay') {
                setPayModeType(GIFT_CARD);
                setPaymentType(32);
                props.navigate(
                  `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.checkHeaderId
                  }?ticketSplitTypeId=${Number(
                    urlSearchParams('ticketSplitTypeId')
                  )}&splitValue=${urlSearchParams('splitValue')}&screenType=32&type=giftCardPay`,
                  { replace: true }
                );
              } else {
                setPaymentType(31);
                props.navigate(
                  `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.checkHeaderId
                  }?ticketSplitTypeId=${Number(
                    urlSearchParams('ticketSplitTypeId')
                  )}&splitValue=${urlSearchParams('splitValue')}&screenType=31&type=${urlSearchParams('ticketSplitTypeId') === '1'
                    ? 'payType'
                    : 'splitType'
                  }`,
                  { replace: true }
                );
              }
            })
            .catch((initErrorEndpointErr) => {
              props.clearGiftCardBalanceInfo();
              if (urlSearchParams('type') === 'giftCardPay') {
                setPayModeType(GIFT_CARD);
                setPaymentType(32);
                props.navigate(
                  `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.checkHeaderId
                  }?ticketSplitTypeId=${Number(
                    urlSearchParams('ticketSplitTypeId')
                  )}&splitValue=${urlSearchParams('splitValue')}&screenType=32&type=giftCardPay`,
                  { replace: true }
                );
              } else {
                setPaymentType(31);
                props.navigate(
                  `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.checkHeaderId
                  }?ticketSplitTypeId=${Number(
                    urlSearchParams('ticketSplitTypeId')
                  )}&splitValue=${urlSearchParams('splitValue')}&screenType=31&type=${urlSearchParams('ticketSplitTypeId') === '1'
                    ? 'payType'
                    : 'splitType'
                  }`,
                  { replace: true }
                );
              }
            });

          props.setErrorPopUp({
            res: err.message,
          });
        }).finally(() => setGiftCardNumber({}))
    } else {
      const dataToSend = {
        deviceId: props.deviceInfo.deviceId,
        employeeId: Number(props.userInfo.id),
        employeeCard: props.userInfo?.employeeCard,
        checkHeaderId: tableData?.id,
        storeId: props.deviceInfo.storeId,
        giftCard: {
          method: data.method,
          accountNumber: data?.cardNumber,
          securityCode: data?.securityCode,
          paymentAmount:
            data?.paymentAmount || props?.giftCardBalanceInfo?.paymentAmount || Number(creditCardAmount) || props?.seat?.paymentCheck?.paymentAmount,
        },
        paymentCheck: props?.seat?.paymentCheck,
        paymentChecks: props?.seat?.paymentChecks,
      };
      props
        .applyGiftCardBalance(dataToSend)
        .then(res => {
          Promise.all([
            props.setPaymentCheck({
              ...props.paymentCheck,
              paymentCheck: res.paymentCheck,
            }),
            props.setSeat({
              ...props.seat,
              paymentCheck: res.paymentCheck,
              paymentChecks: res.paymentChecks,
            })
          ]).then(() => {
            setCreditCardAmount(
              String(Number(res?.paymentCheck?.paymentAmount || 0)?.toFixed(2)) || '0'
            );
            if (urlSearchParams('type') === 'giftCardPay') {
              setPayModeType(GIFT_CARD);
              setPaymentType(32);
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.checkHeaderId
                }?ticketSplitTypeId=${Number(
                  urlSearchParams('ticketSplitTypeId')
                )}&splitValue=${urlSearchParams('splitValue')}&screenType=32&type=${urlSearchParams('ticketSplitTypeId') === '1'
                  ? 'payType'
                  : 'splitType'
                }`,
                { replace: true }
              );
            } else {
              setPaymentType(31);
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.checkHeaderId
                }?ticketSplitTypeId=${Number(
                  urlSearchParams('ticketSplitTypeId')
                )}&splitValue=${urlSearchParams('splitValue')}&screenType=31&type=${urlSearchParams('ticketSplitTypeId') === '1'
                  ? 'payType'
                  : 'splitType'
                }`,
                { replace: true }
              );
            }
          });
        })
        .catch(err => {
          props.setErrorPopUp({
            res: err.message,
          });
        });
    }
  };

  const handleGiftCardBalanceCall = data => {
    console.log({data});

    const dataToSend = {
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      employeeCard: props.userInfo?.employeeCard,
      checkHeaderId: tableData?.id,
      storeId: props.deviceInfo.storeId,
      giftCard: {
        method: data.method,
        accountNumber: data?.cardNumber?.decryptedTrackData || data?.cardNumber,
        securityCode: data?.securityCode,
        paymentAmount: props?.seat?.paymentCheck?.paymentAmount || 0,
      },
      paymentCheck: props?.seat?.paymentCheck,
      paymentChecks: props?.seat?.paymentChecks,
    };
    props.giftCardBalanceCheck(dataToSend)
      .catch(err => {
        props.setErrorPopUp({
          res: err.message || err,
        });
      });
  };

  const handleGiftCardDeleteBalance = (type, payType) => {
    const existingGiftCard = props?.seat?.paymentCheck?.giftCard ||
    (props?.seat?.paymentCheck?.giftCards && props?.seat?.paymentCheck?.giftCards[0]);

    const giftCardData = existingGiftCard || {
      method: props.giftCard?.method,
      accountNumber: props.giftCard?.cardNumber,
      securityCode: props.giftCard?.securityCode,
    };

    const dataToSend = {
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: tableData?.id,
      storeId: props.deviceInfo.storeId,
      giftCard: giftCardData,
      paymentCheck: props?.seat?.paymentCheck,
      paymentChecks: props?.seat?.paymentChecks,
    };
    props
      .giftCardDeleteBalance(dataToSend)
      .then(res => {
        props.setSeat({
          ...props.seat,
          paymentCheck: res.paymentCheck,
          paymentChecks: res.paymentChecks,
        });
        if (payType === CASH) {
          setPaymentType(16);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.seat.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=16&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        } else if (payType === GIFT_CARD) {
          if (
            props?.deviceInfo?.deviceGroup?.serverAppSettings?.powerPaymentOnly
          ) {
            if (tipInfo) {
              setPaymentType(4);
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props?.seat?.paymentCheck?.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=4&type=${urlSearchParams('type')}`,
                { replace: true }
              );
            } else {
              setPaymentType(28);
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props?.seat?.paymentCheck?.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=28&type=${urlSearchParams('type')}`,
                { replace: true }
              );
            }
          } else if (isDriveThru || isCounter || isCallCenter){
            props.navigate(`${APP_CONFIG.BASE_URL}/orders`, { replace: true })
          } else {
            setPaymentType(31);
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${props?.seat?.paymentCheck?.id
              }?ticketSplitTypeId=${urlSearchParams(
                'ticketSplitTypeId'
              )}&splitValue=${urlSearchParams(
                'splitValue'
              )}&screenType=31&type=${urlSearchParams('type')}`,
              { replace: true }
            );
          }
        }
        setPayModeType(DEFAULT);
        setIsAmountEdit({ isOpen: false, isError: false, isFirstClick: true });
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const giftCardPayment = giftAmount => {
    const checkTotal = Number(tableData.totalAmount) + Number(tipAmount);
    const calTipAmt = giftBalance?.suppressTip
      ? 0
      : +((giftAmount * tipAmount) / checkTotal).toFixed(2);
    const taxAmount = +(
      (giftAmount * tableData.taxAmount) /
      checkTotal
    ).toFixed(2);
    const serviceChargeAmount =
      tableData.serviceChargeAmount > 0
        ? +((giftAmount * tableData.serviceChargeAmount) / checkTotal).toFixed(
          2
        )
        : 0;
    const discountAmount =
      tableData.discountAmount > 0
        ? +((giftAmount * tableData.discountAmount) / checkTotal).toFixed(2)
        : 0;
    const subTotalAmount = +(
      giftAmount -
      (taxAmount + calTipAmt + serviceChargeAmount) +
      discountAmount
    ).toFixed(2);
    const updateCheck = {
      ...tableData,
      subTotalAmount,
      taxAmount,
      tipAmount: calTipAmt,
      totalAmount:
        subTotalAmount + taxAmount + serviceChargeAmount - discountAmount,
      serviceChargeAmount,
      discountAmount,
      paidAmount: 0,
    };
    const loyaltyData = getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('loyaltyData')),
      {}
    );
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: tableData.id,
      employeeCard: getObjectValue(
        () =>
          JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard,
        null
      ),
      ticketSplitTypeId: Number(urlSearchParams('ticketSplitTypeId')),
      splitValue: Number(urlSearchParams('splitValue')),
      paymentStageId: getObjectValue(
        () => props.paymentCheck.paymentStageId,
        null
      ),
      subTotalAmount,
      taxAmount,
      tipAmount: calTipAmt,
      totalAmount: Number(tableData.totalAmount).toFixed(2),
      unpaidAmount: Number(tableData.unpaidAmount).toFixed(2),
      seatIds: SeatIds(),
      serviceChargeAmount,
      discountAmount,
      method: giftCardNumber ? 'swipe' : 'type',
      giftCardNumber: props.giftCard.accountNumber,
      securityCode: props.giftCard.securityCode,
      orderPay: isOrderPayMode,
      speedOrder: isCounter,
      accountNumber: loyaltyData?.accountNumber
        ? loyaltyData?.accountNumber
        : '',
      offerId: loyaltyData?.offerId ? loyaltyData?.offerId : '',
      isCoupon: loyaltyData?.isCoupon ? loyaltyData?.isCoupon : false,
    };
    setTipAmount(calTipAmt);
    props.setPaymentCheck(updateCheck).then(() => {
      props
        .giftCardPaymentInit(dataToSend)
        .then(res => {
          const dataToGiftCardPayment = {
            storeId: props.deviceInfo.storeId,
            deviceId: props.deviceInfo.deviceId,
            employeeId: props.userInfo.id,
            checkHeaderId: tableData?.id,
            ticketId: res.ticket?.id,
            subTotalAmount,
            taxAmount,
            tipAmount: calTipAmt,
            transactionId: res.ticket?.transactionId,
            clientTransactionId: res.ticket?.clientTransactionId,
            authorizationCode: res.ticket?.authorizationCode,
            paymentStageId: getObjectValue(
              () => props.paymentCheck.paymentStageId,
              null
            ),
            employeeCard: getObjectValue(
              () =>
                JSON.parse(window.sessionStorage.getItem('userInfo'))
                  .employeeCard,
              null
            ),
            isPreAuth: false,
            partialAuth: false,
            serviceChargeAmount,
            discountAmount,
            method: giftCardNumber ? 'swipe' : 'type',
            giftCardNumber: props.giftCard?.accountNumber,
            securityCode: props.giftCard.securityCode || '',
            orderPay: isOrderPayMode,
            speedOrder: isCounter,
            accountNumber: loyaltyData?.accountNumber
              ? loyaltyData?.accountNumber
              : '',
            offerId: loyaltyData?.offerId ? loyaltyData?.offerId : '',
            isCoupon: loyaltyData?.isCoupon ? loyaltyData?.isCoupon : '',
          };
          props
            .giftCardPayments(dataToGiftCardPayment)
            .then(response => {
              props.setPaymentCheck(response.checkHeader);
              props.setAuthResponse(response).then(() => {
                setGiftBalance(0);
                setPointEarnings(response.estimatedPoints?.value);
                setTipAmount(calTipAmt);
                const tips = JSON.parse(
                  window.sessionStorage.getItem('tipAmt')
                );
                const updatesTips = {
                  ...tips,
                  unpaidTips:
                    +((tips?.unpaidTips || 0) - calTipAmt) < 0
                      ? 0
                      : +((tips?.unpaidTips || 0) - calTipAmt),
                  paidTips: +((tips?.paidTips || 0) + calTipAmt),
                };
                window.sessionStorage.setItem(
                  'tipAmt',
                  JSON.stringify(updatesTips)
                );
                if (isServerApp || isPaymentTerminal) {
                  setPaymentType(22);
                  props.navigate(
                    `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck?.id
                    }?ticketSplitTypeId=${urlSearchParams(
                      'ticketSplitTypeId'
                    )}&splitValue=${urlSearchParams(
                      'splitValue'
                    )}&screenType=22&type=${urlSearchParams('type')}`,
                    { replace: true }
                  );
                } else {
                  setPaymentType(5);
                  props.navigate(
                    `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck?.id
                    }?ticketSplitTypeId=${urlSearchParams(
                      'ticketSplitTypeId'
                    )}&splitValue=${urlSearchParams(
                      'splitValue'
                    )}&screenType=5&type=${urlSearchParams('type')}`,
                    { replace: true }
                  );
                }
              });
            })
            .catch(err => {
              props.setErrorPopUp({
                res: err.message,
              });
            });
        })
        .catch(err => {
          props.setErrorPopUp({
            res: err.message,
          });
        });
    });
  };

  const handleGiftCancel = type => {
    setGiftBalance(false);
    setTipAmount(0);
    window.sessionStorage.removeItem('tipAmt');
    if (type === 'cancel') {
      props.setPaymentCheck({ ...props.paymentCheck }).then(() => {
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=2&&type=payType`,
          { replace: true }
        );
      });
    } else if (type === true) {
      props.clearGiftCardBalanceInfo();
    }
    setGiftCardNumber({});
  };

  const paymentRouteForSplit = (key, updatedData, count) => {
    switch (key) {
      case 'creditCard':
        isTipsRequiredCheck(paymentBtn().key, updatedData);
        break;
      case 'cash':
        handleCashPayment();
        break;
      case 'scanToPay':
        break;
      default:
        isTipsRequiredCheck(paymentBtn().key, updatedData);
        break;
    }
  };

  const handleSplitEvenly = count => {
    const splitAmount = isTableTop
      ? +(props.seat.totalAmount / count).toFixed(2)
      : +(props.paymentCheck.totalAmount / count).toFixed(2);
    const subTotalAmount = +(
      (splitAmount * props.paymentCheck.itemAmount) /
      props.paymentCheck.totalAmount
    );
    const taxAmount = +(
      (splitAmount * props.paymentCheck.taxAmount) /
      props.paymentCheck.totalAmount
    );
    const serviceCharge =
      props.paymentCheck.serviceChargeAmount > 0
        ? +(
          (splitAmount * props.paymentCheck.serviceChargeAmount) /
          props.paymentCheck.totalAmount
        )
        : 0;
    const discountAmount =
      props.paymentCheck.discountAmount > 0
        ? +(
          (splitAmount * props.paymentCheck.discountAmount) /
          props.paymentCheck.totalAmount
        )
        : 0;
    if (
      props.seat.tickets.length > 0 &&
      [...props.seat.tickets].filter(d => d.ticketStatusId === 1).length > 0 &&
      [...props.seat.tickets].filter(d => d.ticketStatusId === 1).length ===
      getObjectValue(() => props.seat.tickets[0].splitValue - 1, 0)
    ) {
      handlePayAnAmount({
        payAnAmount:
          +(
            subTotalAmount +
            taxAmount +
            serviceCharge -
            discountAmount -
            props.paymentCheck.paidAmount
          ) / count,
      });
    } else {
      const updatedData = {
        ...props.seat,
        subTotalAmount:
          countryCode === '44' ? subTotalAmount - taxAmount : subTotalAmount,
        unpaidAmount:
          countryCode === '44'
            ? subTotalAmount + serviceCharge - discountAmount
            : subTotalAmount + taxAmount + serviceCharge - discountAmount,
        taxAmount,
        paidAmount: 0,
        tipAmount: 0,
        totalAmount:
          countryCode === '44'
            ? subTotalAmount + serviceCharge - discountAmount
            : subTotalAmount + taxAmount + serviceCharge - discountAmount,
        serviceChargeAmount: serviceCharge,
        discountAmount,
      };
      if (isTableTop && paymentBtn().key !== 'all') {
        setTableData(updatedData);
        paymentRouteForSplit(paymentBtn().key, updatedData, count);
      } else {
        props.setPaymentCheck(updatedData).then(() => {
          switch (urlSearchParams('source')) {
            case 'stageSplit':
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${updatedData.id}?ticketSplitTypeId=3&splitValue=${count}&screenType=2&type=payType&source=stageSplit`,
                { replace: true }
              );
              break;
            default:
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${updatedData.id}?ticketSplitTypeId=3&splitValue=${count}&screenType=2&type=payType`,
                { replace: true }
              );
              break;
          }
        });
      }
    }
    if (props.auth?.loyaltyInfo?.supportsLoyalty) {
      props.setPaymentFlowType(2);
    }
  };

  const handleSplitBySelectedSeat = () => {
    setPaymentType(30);
    props.navigate(
      `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
      }?ticketSplitTypeId=4&splitValue=${urlSearchParams(
        'splitValue'
      )}&screenType=30&type=splitType`,
      { replace: true }
    );
  };

  const handleKeyboardValue = data => {
    setKeyboardValue(data);
  };
  const handleConfirmSplit = type => {
    if (type === 'splitEven') {
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${tableData.id}?ticketSplitTypeId=3&splitValue=1&screenType=9&type=split`,
        { replace: true }
      );
      setPaymentType(9);
    } else {
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${tableData.id}?ticketSplitTypeId=2&splitValue=1&screenType=10&type=payAnAmount`,
        { replace: true }
      );
      setPaymentType(10);
    }
  };

  const openConfirmSplitEvenlyModal = () => {
    if (buttonControl?.enableSplitEvenlyChange) {
      setPaymentType(9);
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${tableData.id}?ticketSplitTypeId=3&splitValue=1&screenType=9&type=splitType`,
        { replace: true }
      );
    } else {
      let splitCount = (
        JSON.parse(window.sessionStorage.getItem('seat')).splits || []
      ).length;
      const payload = {
        deviceId: props?.deviceInfo?.deviceId,
        employeeId: props?.seat?.employeeId,
        storeId: props?.deviceInfo?.storeId,
        checkHeaderId: props.seat?.id,
        splitType: 3,
        splitValue: splitCount < 2 ? 2 : splitCount,
      };
      handleStagePaymentSubmit({
        payload: payload,
        isSplitEvenly: true,
        isCross: false,
      });
    }
  };

  const setCheckboxactive = (checkboxactive, value, percent) => {
    if (percent > '0') {
      onChangeTipPersent(checkboxactive, percent);
    } else {
      let newVal = value;
      newVal = newVal.slice(1);
      onChangeTipAmount(checkboxactive, newVal);
    }
  };

  const activateGiftCards = data => {
    let value = false;
    let items = data?.orders[0].items;
    items.forEach(i => {
      if (
        props.menuItemsHashTable[JSON.parse(i.orderJson)?.menuItemId]
          ?.cardType == 2
      ) {
        value = true;
      }
    });
    return value;
  };

  const openConfirmSplitPaymentModal = () => {
    if (
      (isServerApp || isPaymentTerminal) &&
      props.auth?.loyaltyInfo?.supportsLoyalty &&
      props.seat.discountAmount === 0
    ) {
      handleConfirmSplit('payAnAmount');
    } else {
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${tableData.id}?ticketSplitTypeId=2&splitValue=1&screenType=10&type=payAnAmount`,
        { replace: true }
      );
      setPaymentType(10);
    }
  };

  let splitEvently = {
    name: LABEL().LS_SPLIT_EVENLY,
    fontSize: '24px',
    click: () => {
      openConfirmSplitEvenlyModal();
    },
    disabled: !buttonControl?.enableSplitEvenly,
  };
  if (props.sendModeStatus) {
    splitEvently = null;
  }

  const splitPaymentConfirm = () => {
    const dataToSend = {
      storeId: props.deviceInfo?.storeId,
      deviceId: props.deviceInfo?.deviceId,
      employeeId: props.userInfo?.id,
      checkHeaderId: tableData?.id,
      employeeCard: getObjectValue(
        () =>
          JSON.parse(window.sessionStorage.getItem('userInfo')).employeeCard,
        null
      ),
      cash: props?.seat?.paymentCheck?.cash,
      paymentCheck: props.seat?.paymentCheck,
      paymentChecks: props.seat?.paymentChecks,
    };
    props
      .spiltCheckPayment(dataToSend)
      .then(() => {
        setSplitConfirm(false);
        props.navigate(`${APP_CONFIG.BASE_URL}/serverApp/checks`, {
          replace: true,
        });
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const checkPresenterPay = () => {
    if (disablePayment) {
      setSplitConfirm(true);
    } else {
      const loyaltyData = getObjectValue(
        () => JSON.parse(window.sessionStorage.getItem('loyaltyData')),
        {}
      );
      const isTipPresent =
        getObjectValue(
          () =>
            JSON.parse(window.sessionStorage.getItem('seat'))?.paymentCheck
              ?.tip,
          false
        ) !== null;
      const isPowerPaymentMode =
        props?.deviceInfo?.deviceGroup?.serverAppSettings?.powerPaymentOnly ||
        false;
      const isLoyaltyPresent =
        getObjectValue(
          () =>
            JSON.parse(window.sessionStorage.getItem('seat'))?.paymentCheck
              ?.loyalty,
          false
        ) !== null;
      if (hasAutoGratuity ? isAutoGratuityPresent : tipInfo && !isTipPresent) {
        if (
          props?.deviceInfo?.deviceGroup?.brandTipId ||
          (hasAutoGratuity && isAutoGratuityPresent)
        ) {
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck?.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=4&type=${urlSearchParams('type')}`,
            { replace: true }
          );
          setPaymentType(4);
        } else if (
          !props.auth?.loyaltyInfo?.supportsLoyalty &&
          !props?.deviceInfo?.deviceGroup
        ) {
          setPaymentType(31);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck?.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=31&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        }
      } else {
        if (
          loyaltyData &&
          props.auth?.loyaltyInfo?.supportsLoyalty &&
          ![31, 32].includes(paymentType)
        ) {
          props.setPaymentFlowType(2);
        } else {
          if (!isLoyaltyPresent) {
            if (props.auth?.loyaltyInfo?.supportsLoyalty) {
              if (hasAutoGratuity ? isAutoGratuityPresent : tipInfo) {
                props.setPaymentFlowType(2);
              } else {
                if (isPowerPaymentMode) {
                  setPaymentType(32);
                  props.navigate(
                    `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck?.id
                    }?ticketSplitTypeId=${urlSearchParams(
                      'ticketSplitTypeId'
                    )}&splitValue=${urlSearchParams(
                      'splitValue'
                    )}&screenType=32&type=${urlSearchParams('type')}`,
                    { replace: true }
                  );
                } else {
                  setPaymentType(31);
                  props.navigate(
                    `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck?.id
                    }?ticketSplitTypeId=${urlSearchParams(
                      'ticketSplitTypeId'
                    )}&splitValue=${urlSearchParams(
                      'splitValue'
                    )}&screenType=31&type=${urlSearchParams('type')}`,
                    { replace: true }
                  );
                }
              }
            } else if (!isTipPresent) {
              if (props.deviceInfo?.deviceGroup?.brandTipId) {
                props.navigate(
                  `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck?.id
                  }?ticketSplitTypeId=${urlSearchParams(
                    'ticketSplitTypeId'
                  )}&splitValue=${urlSearchParams(
                    'splitValue'
                  )}&screenType=4&type=${urlSearchParams('type')}`,
                  { replace: true }
                );
                setPaymentType(4);
              } else {
                setPaymentType(31);
                props.navigate(
                  `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck?.id
                  }?ticketSplitTypeId=${urlSearchParams(
                    'ticketSplitTypeId'
                  )}&splitValue=${urlSearchParams(
                    'splitValue'
                  )}&screenType=31&type=${urlSearchParams('type')}`,
                  { replace: true }
                );
              }
            } else {
              setPaymentType(23);
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck?.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=23&type=${urlSearchParams('type')}`,
                { replace: true }
              );
            }
          } else if (!isTipPresent) {
            if (props?.deviceInfo?.deviceGroup?.brandTipId) {
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck?.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=4&type=${urlSearchParams('type')}`,
                { replace: true }
              );
              setPaymentType(4);
            }
          } else {
            setPaymentType(23);
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck?.id
              }?ticketSplitTypeId=${urlSearchParams(
                'ticketSplitTypeId'
              )}&splitValue=${urlSearchParams(
                'splitValue'
              )}&screenType=23&type=${urlSearchParams('type')}`,
              { replace: true }
            );
          }
        }
      }
    }
  };

  const onClearSplit = () => {
    let dataToSend = {
      storeId: props.seat.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      checkHeaderId: props.seat.checkHeaderId || props.seat.id,
    };
    const redirect = () => {
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.seat?.id}?ticketSplitTypeId=1&splitValue=1&screenType=1`,
        { replace: true }
      );
      setPaymentType(1);
    };
    return props
      .paymentClearSplit(dataToSend)
      .then(res => {
        const syncedCheck = res?.check || data;
        let updatedData = {
          ...syncedCheck,
          control: res?.control,
          checkHeaderId: res?.checkHeaderId,
          storeId: res?.storeId,
          giftCard: res?.giftCard,
          offer: res?.offer,
          paymentCheck: res?.paymentCheck,
          paymentChecks: res?.paymentChecks,
        };

        props.showSuccessCheckMark().then(() => {
          props.setSeat(updatedData);
          redirect();
        });
      })
      .catch(error => {
        props.setErrorPopUp({ res: error.message });
      });
  };

  const payFullCheck = {
    name:
      props.seat.paidAmount === 0
        ? LABEL().LS_PAY_FULL_CHECK
        : tableData.unpaidTips
          ? LABEL().LS_PAY_BALANCE +
          ' ' +
          LABEL().CURRENCY_SYMBOL +
          (
            Number(tableData.unpaidAmount) + Number(tableData.unpaidTips)
          ).toFixed(2) +
          ''
          : LABEL().LS_PAY_BALANCE +
          ' ' +
          LABEL().CURRENCY_SYMBOL +
          Number(tableData.unpaidAmount).toFixed(2) +
          '',
    click: () => {
      loyaltyList?.length <= 1 ? onPayFullCheckHandler() : setOpenLoyalty(true);
    },
    disabled: !buttonControl?.enablePayFullCheck,
  };
  let payByAmount = {
    name: LABEL().PAY_AN_AMOUNT,
    click: () => {
      openConfirmSplitPaymentModal();
    },
    disabled:
      (isTableTop &&
        (paymentBtn().key === 'cash' || paymentBtn().key === 'scanToPay')) ||
      !isDefaultMode ||
      (props.auth.serverAppFeatures.supportsDeliveryOrders &&
        props.auth.country === 4) ||
      props.paymentCheck.totalAmount === 0 ||
      activateGiftCards(props.seat),
  };
  if (
    props.deviceInfo?.deviceGroup === null ||
    props.deviceInfo?.deviceGroup?.splitTypes?.payAmount === false ||
    Number(urlSearchParams('ticketSplitTypeId')) === 3 ||
    (props.seat.paidAmount > 0 &&
      Number(urlSearchParams('ticketSplitTypeId')) === 1)
  ) {
    payByAmount = null;
  }
  if (props.sendModeStatus) {
    payByAmount = null;
  }
  const getSplitValue = value => {
    let ind = 0;
    value.forEach((item, index) => {
      if (item.paymentStatus !== 'auth' && item.paymentStatus !== 'error') {
        ind = index;
      }
    });
    return ind;
  };

  const splitCheckNum =
    props.seat.paidAmount > 0 &&
      props.seat.tickets &&
      props.seat.tickets.length > 0
      ? props.seat.tickets[getSplitValue(props.seat.tickets)].splitValue - 1
      : 0;

  const successTickets = props?.seat?.tickets.filter(
    ticket => ticket?.paymentStatus == 'success'
  );

  const isSplitAllowed = getObjectValue(
    () =>
      props.seat.paidAmount > 0 &&
      Number(successTickets.length) < Number(splitCheckNum),
    false
  );

  if (isSplitAllowed) {
    splitEvently.name =
      `${LABEL().SPLIT_BY} 1/${props.seat.tickets[0] &&
      props.seat.tickets[0] &&
      props.seat.tickets[getSplitValue(props.seat.tickets)].splitValue}` +
      ' ' +
      LABEL().CURRENCY_SYMBOL +
      (
        Number(tableData.totalAmount) /
        Number(
          props.seat?.tickets[getSplitValue(props.seat.tickets)].splitValue
        )
      ).toFixed(2) +
      '';
    splitEvently.click = () => {
      if (
        props.auth?.loyaltyInfo?.supportsLoyalty ||
        props.auth?.loyaltyInfo?.supportsCoupon
      ) {
        props.setPaymentFlowType(2);
        handleSplitEvenly(
          props.seat.tickets[0] &&
          props.seat.tickets[getSplitValue(props.seat.tickets)] &&
          props.seat.tickets[getSplitValue(props.seat.tickets)].splitValue
        );
      } else {
        handleSplitEvenly(
          props.seat.tickets[0] &&
          props.seat.tickets[getSplitValue(props.seat.tickets)] &&
          props.seat.tickets[getSplitValue(props.seat.tickets)].splitValue
        );
      }
    };
    payByAmount = null;
  } else if (props.seat?.paidAmount > 0) {
    splitEvently.name =
      buttonControl?.enableSplitEvenly &&
        buttonControl?.displayPayRemainingSplits
        ? LABEL().LS_PAY_REMAINING_SPLITS
        : LABEL().LS_SPLIT_EVENLY;
    splitEvently.disabled = !buttonControl?.enableSplitEvenly;
  }
  const splitBySeat = {
    name:
      buttonControl?.displayPayRemainingSplits &&
        buttonControl?.enableSplitBySeats
        ? LABEL().LS_PAY_REMAINING_SEATS
        : LABEL().LS_SPLIT_BY_SEATS,
    click: () => {
      handleSplitBySeat();
    },
    disabled: !buttonControl?.enableSplitBySeats,
  };
  const splitBySelectedSeat = {
    name: buttonControl?.displayPayRemainingSeats
      ? LABEL().LS_PAY_REMAINING_SEATS
      : LABEL().LS_SPLIT_BY_SELECTED_SEATS,
    click: () => handleSplitBySelectedSeat(),
    disabled: !buttonControl?.enableSplitBySelectedSeats,
  };

  const PaymentPageBtn = [
    splitBySeat,
    splitBySelectedSeat,
    countryCode === '1' || countryCode === '44' ? splitEvently : null,
    payFullCheck,
  ];

  const validatePayAnAmount = value => {
    const unpaidTips = tableData.unpaidTips || 0;
    const error = {};
    if (
      Number(value.payAnAmount) === 0 ||
      Number.isNaN(value.payAnAmount) ||
      value.payAnAmount === '.'
    ) {
      error.payAnAmount = 'Enter a amount more than 0 to pay';
    } else if (
      Number(value.payAnAmount) > Number(tableData.unpaidAmount + unpaidTips)
    ) {
      error.payAnAmount = 'Enter amount less than total due amount';
    }
    return error;
  };

  const submitSeatNumber = (val, callBack = () => { }, control) => {
    const seatArray = [];
    if (Array.isArray(val)) {
      val.forEach(e => {
        seatArray.push({
          number: e,
          tableShareType: 0,
        });
      });
    } else {
      seatArray.push({
        number: val,
        tableShareType: 0,
      });
    }

    const cb = () => {
      const dataToSend = {
        storeId: props.deviceInfo.storeId,
        deviceId: props.deviceInfo.deviceId,
        employeeId: Number(props.userInfo.id),
        employeeCard: props.userInfo.employeeCard,
        checkHeaderId: props.seat.id,
        seats: seatArray,
      };

      props
        .occupySeat(dataToSend)
        .then(response => {
          response.control = control || props.seat?.control || {};
          props.updateChecksAfterResponse(response);

          const seatsData = filter(response.seats, seat => seat.open);
          const positionReq = find(
            seatsData,
            seat => seat.position === Number(dataToSend.seats[0].position)
          );

          if (urlSearchParams('ticketSplitTypeId') === '2') {
            response.splits = props.seat?.splits || [];
          }

          const seatReq = {
            ...response,
            seats: sort(response.seats, 'number'),
          };

          props.setPosition(positionReq);
          props.updateSeatInfo(seatReq).then(() => {
            if (urlSearchParams('ticketSplitTypeId') === '2') {
              goingDutch(availableSeats).then(() => {
                let dutchSplits = dutchSplitsData.filter(
                  el => el.seats[0]?.seatId
                );
                response.splits =
                  [...(props.seat?.splits || []), ...dutchSplits] || [];
                if (callBack instanceof Function) {
                  callBack(() => { }, response);
                }
              });
            }
          });

          setEditStageModal({
            isEditStageModalOpen: false,
            isClearModalOpen: false,
            data: {},
          });
          if (
            urlSearchParams('ticketSplitTypeId') === '4' &&
            callBack instanceof Function
          ) {
            callBack(val && val, callBack, control);
          }

          if (
            urlSearchParams('ticketSplitTypeId') === '4' ||
            urlSearchParams('ticketSplitTypeId') !== '2'
          ) {
            props.showSuccessCheckMark();
          }
        })
        .catch(err => {
          props.setErrorPopUp({
            res: err.message,
          });
        });
    };
    addInProcessItemsToCart(cb);
  };

  const handleOccupySeatApiCall = val => {
    if (
      props?.seat?.splits?.some(el => String(el?.id)?.indexOf('id_') !== -1)
    ) {
      if (urlSearchParams('screenType') === '30') {
        createSplitApiCall(submitSeatNumber, val);
      } else if (urlSearchParams('screenType') === '29') {
        submitSeatNumber(val, createSplitApiCall);
      }
    } else {
      submitSeatNumber(val);
    }
  };
  const getFilteredOutModifiersFromParentItem = (CartItems = []) => {
    return CartItems.reduce((a, v) => {
      const obj = { ...v };
      if (v.hasLinkedMenuItem) {
        obj.modifiers = [];
      }
      a.push(obj);
      return a;
    }, []);
  };
  const addInProcessItemsToCart = cb => {
    const inProcessItem = props.cart.filter(e => e.isProcessing);

    const dataToSendToAdd = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: Number(props.userInfo.id),
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: props.seat.id,
      stationId: props.seat.stationId,
      items: inProcessItem,
      orderJson: JSON.stringify([...inProcessItem]),
      longitude: '0',
      latitude: '0',
      geoLocation: '0',
    };
    if (inProcessItem?.length > 0) {
      props.addChecks(dataToSendToAdd, 'add').then(res => {
        props.updateSeatInfo(res);
        const ItemsArray = res.orders[0]?.items || [];
        if (ItemsArray?.length > 0) {
          const CartItems = [];
          ItemsArray.forEach(item => {
            if (item.pending && item.itemType !== 'D') {
              const cartData = {
                ...JSON.parse(JSON.parse(item?.orderJson)?.modifierJson),
                isProcessing: false,
                modifierJson: JSON.parse(item?.orderJson)?.modifierJson,
                id: item.id,
                checkItemId: item.checkItemId,
              };
              CartItems.push(cartData);
            }
          });
          props.replaceCart(CartItems);
          const filteredCart = getFilteredOutModifiersFromParentItem(CartItems);
          if (cb) {
            cb(filteredCart, res);
          }
        }
      });
    } else {
      const filteredCart = getFilteredOutModifiersFromParentItem(props.cart);
      if (cb) {
        cb(filteredCart, props.check);
      }
    }
  };
  const handleClear = (data, cb = () => { }, control) => {
    setEditStageModal({ isClearModalOpen: false, data: {} });
    if (
      props.cart.filter(e => e.seatIds.includes(data?.id) && e.pending).length >
      0
    ) {
      props.setErrorPopUp({
        res: ERROR_MESSAGE.SEND_PENDING_ITEMS,
      });
    } else {
      const dataToSend = {
        storeId: props.deviceInfo.storeId,
        employeeId: Number(props.userInfo.id),
        employeeCard: props.userInfo.employeeCard,
        deviceId: props.deviceInfo.deviceId,
        checkHeaderId: props.seat.id,
        stationId: props.seat.stationId || null,
        seats: [
          {
            seatId: data.id,
          },
        ],
      };
      props
        .seatClear(dataToSend)
        .then(res => {
          res.control = control || props.seat?.control || {};
          props.updateSeatInfo(res);
          const splits = props?.seat?.splits || [];
          res.splits = splits;
          props.setSeat(res);
          props.setPosition({ number: -1, position: -1 });
          setEditStageModal({
            isEditStageModalOpen: false,
            isClearModalOpen: false,
            data: {},
          });
          if (cb instanceof Function) {
            if (urlSearchParams('ticketSplitTypeId') === '4') {
              cb(data && data);
            }
          }
          props.showSuccessCheckMark();
        })
        .catch(err => {
          props.setErrorPopUp({
            res: err.message,
          });
        });
    }
  };

  const handleClearSeatApiCall = val => {
    if (
      props?.seat?.splits?.some(el => String(el?.id)?.indexOf('id_') !== -1)
    ) {
      if (urlSearchParams('screenType') === '30') {
        createSplitApiCall(handleClear, val);
      } else if (urlSearchParams('screenType') === '29') {
        handleClear(val, createSplitApiCall);
      }
    } else {
      handleClear(val);
    }
  };
  const handleSurveySubmit = () => {
    if (isServerApp || isPaymentTerminal) {
      setPaymentType(22);
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
        }?ticketSplitTypeId=${urlSearchParams(
          'ticketSplitTypeId'
        )}&splitValue=${urlSearchParams(
          'splitValue'
        )}&screenType=22&type=${urlSearchParams('type')}`,
        { replace: true }
      );
    } else {
      setPaymentType(5);
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
        }?ticketSplitTypeId=${urlSearchParams(
          'ticketSplitTypeId'
        )}&splitValue=${urlSearchParams(
          'splitValue'
        )}&screenType=5&type=${urlSearchParams('type')}`,
        { replace: true }
      );
    }
  };

  const handleStopMagneticRead = () => {
    EventEmitter.sendMessage(
      { type: 'stopMagCard' },
      () => {
      },
      () => {
      }
    );
    setIsSwipe(false);
    setGiftCardNumber({})
  };

  const activateIngenicoDevice = () => {
    try {
      EventEmitter.scanIngenicoDevice(
        res => {
          // handleGiftCard({
          //   cardNumber: res,
          //   securityCode: null,
          //   method: 'swipe',
          // });
          handleGiftCardBalanceCall({
            cardNumber: res,
            securityCode: null,
            method: 'swipe',
          });
          setGiftCardNumber({...res, method: 'swipe'});
          handleStopMagneticRead();
        },
        () => {
          handleStopMagneticRead();
        }
      );
      EventEmitter.sendMessage(
        { type: 'scanMagCard' },
        () => {
          console.log('success');
        },
        () => {
          console.log('failure');
        }
      );
    } catch (e) {
      console.log('catch', e);
    }
  };

  const openCardPopUp = () => {
    playRingtone(Ringtone);
    setIsSwipe(true);
    activateIngenicoDevice();
  };

  const handleFailureRoute = (err, { }, preAuthVal) => {
    handleProcessCreditError(err.message, {}, preAuthVal);
  };

  const handleCountryCodeChange = event => {
    setPhoneNumberMaxLength(
      getObjectValue(() => COUNTRY_CODE[event.id].maxLength, 15)
    );
    setCountryCode(event.id);
  };
  const handleRouteToCheckListing = () => {
    if (
      urlSearchParams('screenType') === '22' &&
      window.sessionStorage.getItem('loyaltyData')
    ) {
      props.handleLoyaltyInfo({ phoneNumber: null, email: null, type: null });
      window.sessionStorage.removeItem('loyalytData');
    }
    if (props?.isTipOnlyEnabled) props?.setIsTipOnlyEnabled(false);
    props.openEmployeeCheck();
    props.clearSelectedOffers();
  };

  const speedOrderRouteToChecks = () => {
    setCancelOrderConfirm(false);
    const dataToSend = {
      employeeId: Number(props.userInfo.id),
      storeId: props.deviceInfo.storeId,
      checkHeaderId: tableData.id,
      deviceId: props.deviceInfo.deviceId,
    };
    props
      .checkVoid(dataToSend)
      .then(res => {
        props.updateChecksAfterResponse(res);
        props.navigate(`${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`, {
          replace: true,
        });
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const lockCallBack = () => {
    if (isOtherPaymentOptionClick) {
      props.showSuccessCheckMark().then(() => {
        employeeCheckInRef?.current?.otherPaymentOptionCallback();
        setIsCashPaymentCheck(false);
      });
    } else {
      if (isCashPaymentCheck && !directToCashConfirm) {
        if (urlSearchParams('source') === 'stageSplit') {
          setIsCashPaymentCheck(false);
          setPaymentType(16);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=16&type=${urlSearchParams('type')}&source=stageSplit`,
            { replace: true }
          );
        } else {
          setIsCashPaymentCheck(false);
          setPaymentType(16);
          props.navigate(
            `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
            }?ticketSplitTypeId=${urlSearchParams(
              'ticketSplitTypeId'
            )}&splitValue=${urlSearchParams(
              'splitValue'
            )}&screenType=16&type=${urlSearchParams('type')}`,
            { replace: true }
          );
        }
      } else if (directToCashConfirm) {
        handleCashPayment();
      } else {
        props.navigate(`${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`, {
          replace: true,
        });
      }
    }
  };

  const handleRouteToOrders = () => {
    const authResponse = getObjectValue(
      () => JSON.parse(window.sessionStorage.getItem('authResponse')),
      false
    );
    if (authResponse) {
      props.updateSeatInfo(authResponse.checkHeader);
      window.sessionStorage.removeItem('tipAmt');
      window.sessionStorage.removeItem('payAmt');
      props.navigate(`${APP_CONFIG.BASE_URL}/${flowTypeValue}/checks`, {
        replace: true,
      });
    } else {
      props.navigate(`${APP_CONFIG.BASE_URL}/orders`, { replace: true });
    }
  };

  const handelCustomTipModelClose = () => {
    if (urlSearchParams('externalCreditCard')) {
      props.navigate(`${APP_CONFIG.BASE_URL}/orders`, { replace: true });
    } else {
      const activeTip = getObjectValue(
        () => storeTips.find(item => item.isDefault).key,
        ''
      );
      setActive(activeTip);
      setCustomTipModelOpen(false);
    }
  };

  const handleChangePaymentType = () => {
    props.navigate(`${APP_CONFIG.BASE_URL}/orders`, { replace: true });
  };

  const makeGiftCardBalanceZero = () => {
    setGiftBalance(0);
  };

  const returnCustomMessageWithReplace = () => {
    let message = '';
    if (CUSTOM_MESSAGES().EXTERNAL_CREDIT_CARD.includes('subtotal')) {
      if (
        countryCode == 44 &&
        urlSearchParams('type') == 'payType'
      ) {
        message = CUSTOM_MESSAGES().EXTERNAL_CREDIT_CARD.replace(
          'subtotal',
          `${LABEL().CURRENCY_SYMBOL}${(
            Number(getTotalAmountForTip()) + Number(tableData.taxAmount)
          ).toFixed(2)}`
        );
      } else {
        message = CUSTOM_MESSAGES().EXTERNAL_CREDIT_CARD.replace(
          'subtotal',
          `${LABEL().CURRENCY_SYMBOL}${getTotalAmountForTip()}`
        );
      }
    }
    if (CUSTOM_MESSAGES().EXTERNAL_CREDIT_CARD.includes('tips')) {
      message = message.replace(
        'tips',
        `${LABEL().CURRENCY_SYMBOL}${Number(keyboardValue).toFixed(2)}`
      );
    }
    return message;
  };

  const handleRouteRetry = () => {
    props.navigate(
      `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
      }?ticketSplitTypeId=${urlSearchParams(
        'ticketSplitTypeId'
      )}&splitValue=${urlSearchParams(
        'splitValue'
      )}&screenType=8&type=${urlSearchParams('type')}`,
      { replace: true }
    );
    setPaymentType(8);
  };
  // New Payment PayByCard flow
  const handleCreditCardPayment = (amount, value) => {
    window.sessionStorage.setItem(
      'giftCardpayment',
      giftcardReceiptEnabled
    );

    const payload = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: tableData.id,
      creditCard: {
        paymentAmount: amount,
      },
      paymentCheck: props?.seat?.paymentCheck,
      paymentChecks: props?.seat?.paymentChecks,
    };
    props
      .payByCreditCard(payload)
      .then(res => {
        props.setSeat({
          ...props.seat,
          paymentCheck: res.paymentCheck,
          paymentChecks: res.paymentChecks,
        });
        props
          .setPaymentCheck({
            ...props.paymentCheck,
            paymentCheck: res.paymentCheck,
          })
          .then(() => {
            setPaymentConfirmation(prevState => ({
              ...prevState,
              isPaymentFailed: false,
            }));
            handleNewCreditCard(res);
          });
      })
      .catch(err => {
        setErrorPopUp({
          res: err.message,
        });
      });
  };
  const PayByCardBtn = amount => {
    if (!amount) {
      handleCreditCardPayment(
        props?.seat?.paymentCheck?.paymentAmount,
        'employeeCreditCard'
      );
    } else {
      props.setIsCreditCardPayment(true);
      handleCreditCardPayment(amount, 'employeeCreditCard');
    }
  };

  const giftCardScreen = () => {
    window.sessionStorage.setItem(
      'giftCardpayment',
      giftcardReceiptEnabled
    );

    setPaymentType(12);
    props.navigate(
      `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
      }?ticketSplitTypeId=${urlSearchParams(
        'ticketSplitTypeId'
      )}&splitValue=${urlSearchParams(
        'splitValue'
      )}&screenType=12&type=${urlSearchParams('type')}`,
      { replace: true }
    );
  };

  const handleApplyOffer = (data, types) => {
    const isTypes = types || null;
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: tableData.id,
      loyalty: {
        accountNumber: props.auth?.loyaltyInfo?.accountNumber,
      },
      offer: {
        vendorId: null,
        // data?.offerId used to be the string value of the QR Code but has recently been changed to an object with a text property
        // Keeping both options here for backward compatibility
        offerCode: typeof data?.offerId === 'object' ? data.offerId.text : data?.offerId,
        offerAuthCode: null,
        value: null,
        quantity: 1,
        isCoupon: data?.isCoupon,
        method: isTypes,
      },
      // paymentCheck: paymentCheck,
      paymentCheck: props.seat?.paymentCheck,
      paymentChecks: props.seat?.paymentChecks,
    };

    props
      .applyLoyaltyOffer(dataToSend)
      .then(res => {
        props.setSeat({
          ...props.seat,
          paymentCheck: res?.paymentCheck,
          paymentChecks: res?.paymentChecks,
        });
        props
          .setPaymentCheck({
            ...props.paymentCheck,
            paymentCheck: res.paymentCheck,
          })
          .then(() => {
            props.showSuccessCheckMark().then(() => {
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${res.paymentCheck.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=31&type=${urlSearchParams('type')}`,
                { replace: true }
              );
              setPaymentType(31);
            });
          });
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const handleSplitOffer = (offer, checkData, splitId) => {
    let dataToSend = {
      storeId: props?.deviceInfo?.storeId,
      deviceId: props?.deviceInfo?.deviceId,
      employeeId: props?.userInfo?.id,
      employeeCard: props?.userInfo?.employeeCard,
      checkHeaderId: tableData.id,
      loyalty: {
        checkLoyaltyId: checkData?.checkLoyaltyId,
        checkSplitId: splitId,
      },
      offer: {
        vendorId: offer?.vendorId,
        offerCode: offer?.offerCode,
        offerAuthCode: null,
        name: offer?.name,
        value: offer?.value,
        quantity: offer?.quantity,
        isCoupon: offer?.isCoupon ? offer?.isCoupon : false,
        checkSplitId: splitId,
      },
      availableLoyaltyOffers: props?.seat?.availableLoyaltyOffers,
      paymentCheck: props?.seat?.paymentCheck,
      paymentChecks: props?.seat?.paymentChecks,
    };
    props
      .loyaltySplitOffers(dataToSend)
      .then(res => {
        setNewOfferPopUp(true);
        props.setSeat({
          ...props.seat,
          availableLoyaltyOffers: res?.availableLoyaltyOffers,
          paymentCheck: res?.paymentCheck,
          paymentChecks: res?.paymentChecks,
          check: res?.check,
          subTotalAmount: res?.paymentCheck?.subTotalAmount,
          totalAmount: res?.paymentCheck?.totalAmount,
          taxAmount: res?.paymentCheck?.taxAmount,
          itemAmount: res?.paymentCheck?.itemAmount,
        });
        props.setPaymentCheck({
          ...props.paymentCheck,
          paymentCheck: res.paymentCheck,
          subTotalAmount: res?.paymentCheck?.subTotalAmount,
          totalAmount: res?.paymentCheck?.totalAmount,
          taxAmount: res?.paymentCheck?.taxAmount,
          itemAmount: res?.paymentCheck?.itemAmount,
        });
        setTableData({
          ...res.paymentCheck,
        });
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  }

  //loyalty new Payment flow
  useLayoutEffect(() => {
    if (urlSearchParams('loyalty') == 'no') {
      if (urlSearchParams('offer') != 'yes') {
        const isTipPresent =
          getObjectValue(
            () =>
              JSON.parse(window.sessionStorage.getItem('seat'))?.paymentCheck
                ?.tip,
            false
          ) !== null;
        if (
          hasAutoGratuity ? isAutoGratuityPresent : tipInfo && !isTipPresent
        ) {
          if (
            hasAutoGratuity ? isAutoGratuityPresent : !isTipPresent
          ) {
            if (props?.deviceInfo?.deviceGroup?.brandTipId) {
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=4&type=${urlSearchParams('type')}`,
                { replace: true }
              );
              setPaymentType(4);
            }
          } else {
            setPaymentType(23);
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
              }?ticketSplitTypeId=${urlSearchParams(
                'ticketSplitTypeId'
              )}&splitValue=${urlSearchParams(
                'splitValue'
              )}&screenType=23&type=${urlSearchParams('type')}`,
              { replace: true }
            );
          }
        } else {
          if (props.isCreditCardPayment) {
            setPaymentType(23);
            props.navigate(
              `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
              }?ticketSplitTypeId=${urlSearchParams(
                'ticketSplitTypeId'
              )}&splitValue=${urlSearchParams(
                'splitValue'
              )}&screenType=23&type=${urlSearchParams('type')}`,
              { replace: true }
            );
          } else {
            if (hasAutoGratuity ? isAutoGratuityPresent : tipInfo) {
              if (props?.deviceInfo?.deviceGroup?.brandTipId) {
                props.navigate(
                  `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                  }?ticketSplitTypeId=${urlSearchParams(
                    'ticketSplitTypeId'
                  )}&splitValue=${urlSearchParams(
                    'splitValue'
                  )}&screenType=4&type=${urlSearchParams('type')}`,
                  { replace: true }
                );
                setPaymentType(4);
              }
            } else {
              setPaymentType(31);
              props.navigate(
                `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
                }?ticketSplitTypeId=${urlSearchParams(
                  'ticketSplitTypeId'
                )}&splitValue=${urlSearchParams(
                  'splitValue'
                )}&screenType=31&type=${urlSearchParams('type')}`,
                { replace: true }
              );
            }
          }
        }
      } else {
        setPaymentType(31);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=31&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      }
    } else if (urlSearchParams('type') == 'splitType') {
      setPaymentType(urlSearchParams('screenType'));
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
        }?ticketSplitTypeId=${urlSearchParams(
          'ticketSplitTypeId'
        )}&splitValue=${urlSearchParams(
          'splitValue'
        )}&screenType=${urlSearchParams('screenType')}&type=${urlSearchParams(
          'type'
        )}`,
        { replace: true }
      );
    }
  }, []);
  const applyAnOfferScreen = data => {
    if (!props.paymentCheck?.id) {
      console.error('PaymentCheck ID not available');
      return;
    }

    const ticketSplitTypeId = urlSearchParams('ticketSplitTypeId') || '0';
    const splitValue = urlSearchParams('splitValue') || '';
    const screenType = urlSearchParams('screenType') || '1';
    const type = urlSearchParams('type') || '';

    if (data) {
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
        }?ticketSplitTypeId=${Number(ticketSplitTypeId)
        }&splitValue=${splitValue
        }&screenType=${screenType}&type=${type
        }&loyalty=yes&offer=yes&applyOffer=true`,
        { replace: true }
      );
      props.setPaymentFlowType(2);
    } else {
      props.setPaymentFlowType(2);
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
        }?ticketSplitTypeId=${Number(ticketSplitTypeId)
        }&splitValue=${splitValue
        }&screenType=${screenType}&type=${type
        }&loyalty=yes&offer=yes`,
        { replace: true }
      );
      props.handleSkipLoyalty(true);
    }
  };

  const handleDeleteOffer = data => {
    const dataToSend = {
      storeId: props.deviceInfo.storeId,
      deviceId: props.deviceInfo.deviceId,
      employeeId: props.userInfo.id,
      employeeCard: props.userInfo.employeeCard,
      checkHeaderId: tableData.id,
      offer: {
        vendorId: null,
        offerCode: data?.couponCode,
        offerAuthCode: null,
        value: null,
        quantity: 1,
        isCoupon: true,
      },
      paymentCheck: props?.seat?.paymentCheck,
      paymentChecks: props?.seat?.paymentChecks,
    };
    props
      .handleDeleteOffer(dataToSend)
      .then(res => {
        props.setSeat({
          ...props.seat,
          paymentCheck: res.paymentCheck,
          paymentChecks: res.paymentChecks,
        });
        setPaymentType(31);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=31&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      })
      .catch(err => {
        props.setErrorPopUp({
          res: err.message,
        });
      });
  };

  const closeModal = () => {
    setEditStageModal({
      isEditStageModalOpen: false,
      isClearModalOpen: false,
      data: {},
    });
  };
  const handlePaymentCheckModal = () => {
    if (
      ['31', '32'].includes(urlSearchParams('screenType')) &&
      urlSearchParams('type') === 'payType' &&
      props?.seat?.paymentCheck?.tickets?.length > 0
    ) {
      if (props.deviceInfo?.deviceGroup?.brandSurveyId) {
        setPaymentcheckLocksModal(true);
      } else {
        props.openEmployeeCheck();
      }
    } else {
      props.openEmployeeCheck();
    }
  };
  const handlePaymentCheckTicket = () => {
    setPaymentcheckTicketsModal(false);
    let tickets = props.seat?.paymentCheck?.tickets;
    if (props.deviceInfo?.deviceGroup?.brandSurveyId) {
      if (
        tickets?.length > 0 &&
        tickets[tickets.length - 1]?.paymentTypeName === 'Cash'
      ) {
        setPaymentType(22);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
          }?ticketSplitTypeId=${urlSearchParams(
            'ticketSplitTypeId'
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=22&type=${urlSearchParams('type')}`,
          { replace: true }
        );
      } else {
        getSurveyResponse();
        setPayModeType(CREDIT_CARD);
        setPaymentType(11);
        props.navigate(
          `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.checkHeaderId
          }?ticketSplitTypeId=${Number(
            urlSearchParams('ticketSplitTypeId')
          )}&splitValue=${urlSearchParams(
            'splitValue'
          )}&screenType=11&type=payType&flow=reverse`,
          { replace: true }
        );
      }
    } else {
      setPaymentType(22);
      props.navigate(
        `${APP_CONFIG.BASE_URL}/receipt/${props.paymentCheck.id
        }?ticketSplitTypeId=${urlSearchParams(
          'ticketSplitTypeId'
        )}&splitValue=${urlSearchParams(
          'splitValue'
        )}&screenType=22&type=${urlSearchParams('type')}`,
        { replace: true }
      );
    }
  };

  const classMap = {
    4: 'px-40',
    8: 'pr-40 pl-0',
    9: 'pl-40 pr-0',
    12: 'pr-40 pl-0',
    16: lockPaymentScreen && 'pr-40 pr-0',
    30: 'pl-4 ml-3',
    31: 'px-40',
    32: props.seat?.paymentCheck?.tickets?.length > 0 ? 'pl-0 pr-40' : (isLandScape ? (speedOrderMode ? style.speedorderPrPl : 'px-50') : (speedOrderMode ? style.speedorderpotraitPrPl : 'px-40')),
    36: lockPaymentScreen ? (isLandScape ? 'pr-50' : 'pr-40 pl-0') : ''
  };
  const mappedClass = classMap[paymentType] ||( urlSearchParams('screenType') == 22 ? 'px-4': 'px-0');

  const popupStyles = useMemo(() => {
    const modal = {
      background: serverAppTheme ? serverAppTheme.popUp_bg : '#2F2F2F',
      border: serverAppTheme ? serverAppTheme.popupBorder : '1px solid #626262',
      borderRadius: '16px',
      boxShadow: serverAppTheme?.popUp_box_shadow,
      width: '486px',
    };
    const icon = {
      color: serverAppTheme ? serverAppTheme?.primary_text : 'white',
    };
    const newcheck = {
      backgroundColor: serverAppTheme?.OFF_Premise_Btn,
      border: serverAppTheme?.cancleBtn_Border,
      color: serverAppTheme?.cancleBtn_font,
    };
    const gotocheck = {
      backgroundColor: serverAppTheme?.secondaryBtn,
      color: serverAppTheme?.btn_font_color,
    };
    const cross = {
      top: '0.5rem',
      right: '0.5rem',
    };
    return { modal, icon, newcheck, gotocheck, cross };
  }, [serverAppTheme]);

  const inlineStyle = useMemo(() => {
    const modal = {
      backgroundColor: serverAppTheme?.popUp_bg,
      borderRadius: '16px',
      border: serverAppTheme?.popupBorder,
      boxShadow: serverAppTheme?.popUp_box_shadow,
      width: '486px',
      margin: 'auto',
      minHeight: '216px',
      padding: '1.5rem',
      position: 'relative',
    };
    const parentContainer = { color: serverAppTheme?.primary_text };
    const noButton = {
      backgroundColor: serverAppTheme?.OFF_Premise_Btn,
      border: serverAppTheme?.cancleBtn_Border,
      color: serverAppTheme?.cancleBtn_font,
      borderRadius: '4px',
      height: '2.75rem',
    };
    const yesButton = {
      backgroundColor: serverAppTheme?.secondaryBtn,
      color: serverAppTheme?.btn_font_color,
      borderRadius: '4px',
      height: '2.75rem',
      border: 'none',
    };
    const btnPosition = {
      bottom: '1rem',
      left: 0,
    };
    return {
      modal,
      noButton,
      yesButton,
      parentContainer,
      btnPosition,
    };
  }, []);

  const handlePayFullCheck = () => {
    if (!selectedLoyalty?.id) {
      props.setErrorPopUp({
        res: `${LABEL().PF_ERR_LOYALTY_ACCOUNT}`,
        noErrorTxt: true,
      });
    } else {
      onPayFullCheckHandler();
      setOpenLoyalty(false);
    }
  };

  const authResponseMemo = useMemo(() => JSON.parse(
    window.sessionStorage.getItem('authResponse')
  ), [])

  const handleDisplayCheckNumber = (data) => {
    const selectedSplit = props?.seat?.paymentChecks?.find(e => Number(e.checkSplitId) === Number(data));
    return selectedSplit?.splitNumber;
  };
  return (
    <div
      className={cn(
        'col-12 col-md-12 mx-0 rowReverse ',
        !isSwipe ? 'h-100' : '',
        [2, 3, 8, 28].includes(paymentType) && 'position-relative',
        [19].includes(paymentType) ? 'px-0' : 'p-0',
        [1].includes(paymentType) && 'row'
      )}
      style={{
        fontFamily: 'poppins',
        paddingTop: [19].includes(paymentType) && '1.2rem',
        color: serverAppTheme?.primary_text,
      }}
    >
      {(props.loading || cardReaderConnectionState.isLoading) && (
        <Loader message={cardReaderConnectionState.message} />
      )}
      {handleBackButton().isShow &&
        [4, 31].includes(paymentType) &&
        ![2].includes(paymentType) &&
        !(
          (props?.isTipOnlyEnabled || props?.isOfflineVoid) &&
          [4].includes(paymentType)
        ) && (
          <TouchableDiv
            className={cn(
              'position-fixed od-text-primary d-flex justify-content-center align-items-center rounded',
              style.textColor
            )}
            style={{
              left: '1rem',
              top: '1rem',
              zIndex: '999',
              width: '2rem',
              height: '2rem',
              backgroundColor: serverAppTheme.iconcolor_bg_box,
            }}
            onClick={() => handleBackButton().url()}
          >
            <BackChevron fill={props.serverAppTheme?.iconcolor} alt="" />
          </TouchableDiv>
        )}

      {(props?.isTipOnlyEnabled || props?.isOfflineVoid) &&
        [4, 31, 32].includes(paymentType) && (
          <TouchableDiv
            className="position-fixed text-right od-text-primary rounded d-flex justify-content-center align-items-center"
            style={{
              right: isLandScape ? '0.75rem' : '1rem',
              top: !isLandScape && '1rem',
              zIndex: '999',
              width: '2rem',
              height: '2rem',
              backgroundColor: serverAppTheme.iconcolor_bg_box,
            }}
            onClick={event => {
              event.preventDefault();
              handleTipOnlyClose();
            }}
          >
            <Cross
              fill={serverAppTheme?.iconcolor}
              width={24}
              height={24}
              alt="cross"
            />
          </TouchableDiv>
        )}

      {!props.speedOrderStatus &&
        !hideCancelIcon &&
        !speedOrderMode &&
        !(
          (props?.isTipOnlyEnabled || props?.isOfflineVoid) &&
          [4, 31, 32].includes(paymentType)
        ) &&
        ![1, 9, 11, 12, 16, 29, 30, 33].includes(paymentType) && (
          <TouchableDiv
            className="position-fixed text-right od-text-primary rounded d-flex justify-content-center align-items-center"
            style={{
              right: isLandScape ? '0.75rem' : '1rem',
              top: !isLandScape && '1rem',
              zIndex: '999',
              width: '2rem',
              height: '2rem',
              backgroundColor: serverAppTheme.iconcolor_bg_box,
            }}
            onClick={event => {
              event.preventDefault();
              return isOrderPayMode || isKiosk || isWalkUp
                ? handleRouteToOrders()
                : handleRouteToCheckListing();
            }}
          >
            <LockIcon fill={serverAppTheme?.iconcolor} />
          </TouchableDiv>
        )}

      {!props.speedOrderStatus &&
       !speedOrderMode &&
        (!hideCancelIcon || !isTogo) &&
        [31, 32].includes(paymentType) && (!props?.isTipOnlyEnabled && !props?.isOfflineVoid)  && (
          <TouchableDiv
            className="position-fixed text-right od-text-primary rounded d-flex justify-content-center align-items-center"
            style={{
              right: '1rem',
              top: '1rem',
              zIndex: '999',
              width: '2rem',
              height: '2rem',
              backgroundColor: serverAppTheme.iconcolor_bg_box,
            }}
            onClick={() => {
              return isOrderPayMode || isKiosk || isWalkUp
                ? handleRouteToOrders()
                : handlePaymentCheckModal();
            }}
          >
            <LockIcon fill={serverAppTheme?.iconcolor} />
          </TouchableDiv>
        )}
      {(hideCancelIcon || lockPaymentScreen) &&
        [1, 2, 3, 4, 8, 9, 12, 16, 22, 28, 30, 31, 32, 33, 36, 27].includes(
          paymentType
        ) && (
          <div
            style={{
              height:
                [1, 3, 8, 12, 16, 30, 31, 32, 33, 36, 27].includes(paymentType) &&
                '4%'
            }}
            className={cn(
              [30].includes(paymentType) && 'position-absolute',
              'col-12 mx-0 h-4 w-100 p-0'
            )}
          >
            <div
              className={cn(
                'd-flex h-100 align-items-center',
                [1, 4, 8, 12, 16, 22, 28, 30, 31, 32, 33, 36, 27].includes(
                  paymentType
                )
                  ? 'pb-0'
                  : !orderingPortraitOrientation ?  'pb-3' :''
              )}
            >
              <div
                className={cn(
                  style.tableOrderNum,
                  'col-12 d-flex justify-content-center align-items-center fs_24 align-self-md-baseline',
                  mappedClass,
                  [16].includes(paymentType) && 'pl-0',
                  ([31].includes(paymentType) && (props.seat?.paymentCheck?.giftCards?.length > 0 || props.seat?.paymentCheck?.giftCard)) ? 'pl-0' : "", isLandScape && !speedOrderMode && [32, 31].includes(paymentType) ? 'mt-2' : ""
                )}
              >
                <span
                  className={cn('col-8 fs_16', isLandScape ? (speedOrderMode ? 'pl-0' : 'pl-10') : 'p-0')}
                  style={{ color: serverAppTheme?.primary_text }}
                >
                  {LABEL().TABLE}{' '}
                  {(props?.seat?.stationName?.length > ((orderingPortraitOrientation ? 4 : 8))
                    ? props?.seat?.stationName.substring(0,  (orderingPortraitOrientation ? 3 : 9)) + '...'
                    : props?.seat?.stationName) ||
                    (props?.seat?.name?.length > ((orderingPortraitOrientation ? 4 : 8))
                      ? props?.seat?.name.substring(0, (orderingPortraitOrientation ? 3 : 9)) + '...'
                      : props?.seat?.name) ||
                    props?.seat?.stationNumber}
                </span>
                <span
                className={cn(
                  'col-4 text-right fs_16',
                  [22].includes(paymentType) && !isLandScape ? 'pr-3' : '',
                  paymentType === 16 ? (speedOrderMode ? 'pr-1' : 'pr-40') :
                  [22, 28, 27].includes(paymentType) ? 'pr-40' : (isLandScape ? (speedOrderMode ? 'pr-0' : 'pr-3') : 'pr-0')
                )}
                  style={{
                    color: serverAppTheme?.primary_text,
                  }}
                >
                  #{props?.seat?.number}
                </span>
                {[22].includes(paymentType) && speedOrderMode &&
                  <TouchableDiv
                    className="position-fixed text-right od-text-primary rounded d-flex justify-content-center align-items-center"
                    style={{
                      right: isLandScape ? '0.75rem' : '1rem',
                      top: !isLandScape && '1rem',
                      zIndex: '999',
                      width: '2rem',
                      height: '2rem',
                      backgroundColor: serverAppTheme.iconcolor_bg_box,
                    }}
                    onClick={event => {
                      event.preventDefault();
                      return isOrderPayMode || isKiosk || isWalkUp
                        ? handleRouteToOrders()
                        : handleRouteToCheckListing();
                    }}
                  >
                    <LockIcon fill={serverAppTheme?.iconcolor} />
                  </TouchableDiv>}
              </div>
            </div>
          </div>
        )}
      {showCheckSeat() && (
        <TouchableDiv
          className={cn('col-12 px-0',
            ['11'].includes(urlSearchParams('screenType')) && isLandScape
              ? style.checkht
              : [
                isLandScape ? style.landscapecheckht : style.checkht,
                isLandScape ? (['33', '16'].includes(urlSearchParams('screenType')) ? "pt-3" : "pt-3 mt-2") : "pt-2"
              ].join(" ")
          )}
          onClick={e => {
            e.preventDefault();
          }}
        >
          <div
            className={cn(
              'col-12 fs_12 fs-12 fw-400 d-flex justify-content-between h-100 rounded align-items-center'
            )}
            style={{ background: serverAppTheme?.checkDetail_tabs }}
          >
            <div className={cn("col-6 text-left p-0", isLandScape ? 'h-80' : ' h-50')}>
              {/* Check{' '}
              {checkAndSeats?.stage?.name
                ? `${checkAndSeats?.stage?.number
                }(${checkAndSeats?.stage?.name?.substring(0, 4) + '...'})`
                : checkAndSeats?.stage?.number} */}
              Check {handleDisplayCheckNumber(checkAndSeats?.stage?.id)}
            </div>
            <div
              className={cn('col-6 text-right pr-0', style.scrollableText, isLandScape ? 'h-80' : ' h-50')}
            >
              Seat {moreSeats}
            </div>
          </div>
        </TouchableDiv>
      )}
      {(hideCancelIcon || lockPaymentScreen) && [2].includes(paymentType) && (
        <div
          style={{ overflow: 'hidden' }}
          className={cn(
            'col-12 mx-0 position-relative w-100 p-0',
            paymentType === 2 ? 'h-18 pt-2' : 'h-16'
          )}
        >
          <div className="w-100 h-100 position-relative">
            <img
              src={
                props.auth?.imageUrl
                  ? props.auth?.imageUrl
                  : getTheme === '2'
                    ? PaymentImg_white
                    : PaymentImg
              }
              className={cn('w-100 h-100 position-absolute')}
              style={{
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                minWidth: '100%',
                minHeight: '100%',
              }}
              alt=" "
            />
          </div>
          <div></div>
        </div>
      )}
      {
      //!props.speedOrderStatus &&
        (hideCancelIcon || isTogo || speedOrderMode) &&
        [2, 4, 8, 12, 19, 22, 28, 31, 32].includes(paymentType) && !(speedOrderMode && [22, 32].includes(paymentType)) && (
          <div
            className="position-fixed text-right od-text-primary fs-26 d-flex justify-content-center align-items-center rounded"
            style={{
              right: [1, 2, 4, 8, 12, 16, 22, 28, 31, 32].includes(paymentType)
                ? '1rem'
                : '10px',
              top: [1, 2, 4, 8, 12, 22, 28, 31, 32].includes(paymentType)
                ? '1rem'
                : [16, 19].includes(paymentType)
                  ? '10px'
                  : '5px',
              zIndex: '999',
              width: '2rem',
              height: '2rem',
              backgroundColor: serverAppTheme?.iconcolor_bg_box,
            }}
          >
            <Cross
              fill={serverAppTheme?.iconcolor}
              width={24}
              height={24}
              alt="cross"
              onClick={() => handleRouteCross()}
            />
          </div>
        )}
      {(props.speedOrderStatus) && !speedOrderMode &&
        [1, 2, 4, 12, 16, 19].includes(paymentType) && (
          <div
            className="position-fixed text-right od-text-primary fs-26"
            style={{
              right: [1].includes(paymentType)
                ? '15px'
                : [2].includes(paymentType)
                  ? '14px'
                  : [4].includes(paymentType)
                    ? '14px'
                    : [12].includes(paymentType)
                      ? '12px'
                        : '10px',
              top: [1].includes(paymentType)
                ? '10px'
                : [2].includes(paymentType)
                  ? '12px'
                  : [4].includes(paymentType)
                    ? '14px'
                    : [12].includes(paymentType)
                      ? '12px'
                      : [16].includes(paymentType)
                        ? '10px'
                        : '5px',
              zIndex: '999',
            }}
          >
            {/* {isCounter ? (
              <img
                src={isCounter ? crossCounterApp : cross}
                style={{ backgroundColor: '#433E50', borderRadius: '4px' }}
                alt="cross"
                tabIndex="0"
                role="button"
                onClick={() =>
                  props.navigate(`${APP_CONFIG.BASE_URL}/orders`, {
                    replace: true,
                  })
                }
              />
            ) : (
              <Cross
                fill={props.serverAppTheme?.iconcolor}
                onClick={() =>
                  props.navigate(`${APP_CONFIG.BASE_URL}/orders`, {
                    replace: true,
                  })
                }
              />
            )} */}
            <Cross
                fill={props.serverAppTheme?.iconcolor}
                onClick={() =>
                  props.navigate(`${APP_CONFIG.BASE_URL}/orders`, {
                    replace: true,
                  })
                }
              />
            {/* <i role="presentation" className="fa fa-times" aria-hidden="true" onClick={() => props.history.replace(`${APP_CONFIG.BASE_URL}/orders`)} /> */}
          </div>
        )}
      {/* SCP Split Modal */}
      <Modal
        isOpen={splitConfirm}
        isModalCenter
        noBackground
        customClass2="h-100 w-100 p-3 d-flex justify-content-center align-items-center my-0"
        customClass="h-100 w-100"
        style={popupStyles.modal}
      >
        <div
          className="col-12 px-0 pb-2 pt-3 justify-content-center align-items-center position-relative text-center"
          style={popupStyles.icon}
        >
          <div className="row px-0 mx-0 pb-3">
            <div className="col-12 px-0 fs_18 fw-700 text-center d-flex align-items-center justify-content-center">
              Are You Sure ?
            </div>
          </div>
          <div className="col-12 fs_18 fw-400 text-center pb-2">
            {CUSTOM_MESSAGES().SPLIT_CONFIRM}
          </div>
          <div className="col-12 w-100 row mx-0 py-2 px-0 justify-content-center align-items-center text-center p-3">
            <div className="col-6 pl-0 pr-1">
              <button
                className={cn(style.Unselected_menu_btn, 'w-100 btn44 rounded')}
                style={popupStyles.newcheck}
                type="button"
                onClick={() => setSplitConfirm(false)}
              >
                <div className="fs_24 fw-600">{LABEL().NO}</div>
              </button>
            </div>
            <div className="col-6 pr-0 pl-1">
              <button
                className={cn(
                  style.secondary_btn_color,
                  'w-100 btn44 border-0 rounded'
                )}
                style={popupStyles.gotocheck}
                type="button"
                onClick={() => splitPaymentConfirm()}
              >
                <div className="fs_24 fw-600">{LABEL().YES}</div>
              </button>
            </div>
          </div>
        </div>
      </Modal>
      {/* {!isCounter ? ( */}
        <div
          className={cn(
            paymentType === 3 ? 'col-md-6 h-96 px-0' : '',
            '',
            // [16].includes(paymentType) &&
            // isCounter &&
            // Number(tableData?.totalAmount) !== 0 &&
            // ''
          )}
        >
          <div
            className={cn(
              'row mx-0',
              [4, 6, 12, 16].includes(paymentType)
                ? ' od-container-card-background background-primary'
                : '',
              [3].includes(paymentType) ? 'h-100' : ''
            )}
            style={
              urlSearchParams('screenType') == 17
                ? { height: '' }
                : { height: 'null' }
            }
          >
            <Processindex
              history={props.history}
              isCash={
                isTableTop
                  ? getObjectValue(
                    () => props.deviceInfo.deviceGroup.paymentTypes.cash,
                    false
                  )
                  : supportCashPayment
              }
              isCreditCard={
                isTableTop
                  ? paymentBtn().key === 'creditCard' ||
                  (paymentBtn().key === 'all' &&
                    getObjectValue(
                      () =>
                        props.deviceInfo.deviceGroup.paymentTypes.creditCard,
                      false
                    ))
                  : countryCode !== '44'
              }
              sourceType={tableData?.sourceType}
              setTextToPayModelOpen={setTextToPayModelOpen}
              tipAmount={tipAmount}
              paymentAmount={paymentAmount}
              totalAmount={tableData?.totalAmount}
              paidAmount={tableData?.paidAmount}
              unpaidAmount={
                props.authResponse
                  ? getObjectValue(
                    () =>
                      authResponseMemo.checkHeader.unpaidAmount,
                    props?.authResponse?.checkHeader?.unpaidAmount
                  )
                  : { ...props.seat }.unpaidAmount
              }
              paymentType={paymentType}
              loading={props.loading}
              loaded={props.loaded}
              error={props.error}
              makeGiftCardBalanceZero={makeGiftCardBalanceZero}
              currenySymbol={currenySymbol}
              handleButtonClick={handleButtonClick}
              handleButtonClickOtherAmount={handleButtonClickOtherAmount}
              setPaymentType={setPaymentType}
              handleRouteCheck={handleRouteCheck}
              handleTipsRouteTo={handleTipsRouteTo}
              tipsList={hasAutoGratuity ? autoGratuityTipsList : tipsList}
              handleCreditCard={handleCreditCard}
              handlePrint={handlePrint}
              active={active}
              charityList={charityList}
              handleCheck={handleCheck}
              logo={props.auth.logoImageUrl}
              paymentCallBack={completeProcessSale}
              handleReceiptPopUpOpen={handleReceiptPopUpOpen}
              handleRetry={handleRetry}
              PaymentPageBtn={PaymentPageBtn}
              isGiftCard={
                isTableTop
                  ? false
                  : props.auth?.loyaltyInfo?.supportsGiftCardPayment
              }
              isSecurityCode={
                props.auth?.loyaltyInfo?.validateGiftCardSecurityCode
              }
              charity={props.auth?.charity}
              applyDonation={applyDonation}
              handleSplitEvenly={handleSplitEvenly}
              handlePayAnAmount={handlePayAnAmount}
              keyboardValue={keyboardValue}
              handleKeyboardValue={handleKeyboardValue}
              validatePayAnAmount={validatePayAnAmount}
              hideSignature={hideSignature}
              subTotalAmount={tableData?.subTotalAmount}
              handleSurveySubmit={handleSurveySubmit}
              handleGiftCard={handleGiftCard}
              giftCardPayment={giftCardPayment}
              giftBalance={giftBalance}
              paymentFlowType={props.paymentFlowType}
              giftCardSupportsSwipe={getObjectValue(
                () =>
                  props?.auth?.loyaltyInfo?.giftCardMethods?.includes('swipe'),
                false
              )}
              openCardPopUp={openCardPopUp}
              giftCardNumber={giftCardNumber}
              handleFailureRoute={handleFailureRoute}
              errorMessage={errorMessage}
              handleProcessCreditError={handleProcessCreditError}
              isDone={!lockPaymentScreen}
              totalAmountForTip={getTotalAmountForTip()}
              handleGiftCancel={handleGiftCancel}
              isQrScan={
                isTableTop || isServerApp
                  ? getObjectValue(
                    () => props.deviceInfo.deviceGroup.paymentTypes.scanToPay,
                    false
                  )
                  : false
              }
              isKiosk={isKiosk}
              isTableTop={isTableTop}
              isServerApp={isServerApp}
              pointEarnings={pointEarnings}
              successMessage={successMessage}
              authResponse={getObjectValue(
                () => JSON.parse(window.sessionStorage.getItem('authResponse')),
                null
              )}
              tableData={{ ...tableData }}
              deviceInfo={props.deviceInfo}
              handleHideCancelIcon={status => setHideCancelIcon(status)}
              tipsMessage={tipsMessage}
              showPoints={getObjectValue(
                () => props.auth?.loyaltyInfo?.supportsLoyalty,
                false
              )}
              isCounter={isCounter}
              isWalkUp={isWalkUp}
              handleChangePaymentType={handleChangePaymentType}
              userInfo={props.userInfo}
              receiptTypes={receiptTypes}
              handleDirectToCashConfirmation={handleDirectToCashConfirmation}
              isPaymentTerminal={isPaymentTerminal}
              isExternalCreditCard={isExternalCreditCard}
              giftCardImages={props.giftCardImages}
              setNotification={props.setNotification}
              setGiftBalance={setGiftBalance}
              handlePreAuth={handlePreAuth}
              setIsOpen={setIsOpen}
              isOpen={isOpen}
              preAuthFunctionCall={preAuthFunctionCall}
              seat={props.seat}
              giftCardMethods={props.auth?.loyaltyInfo?.giftCardMethods}
              creditRetryBtn={creditRetryBtn}
            />
          </div>
        </div>
      {/* ) : null} */}

      {[2].includes(paymentType) && (
        <div
          className={`${style.detailOption} d-flex h-4 justify-content-end pt-2`}
          tabIndex="0"
          role="button"
          onClick={() => {
            setViewDetailsOpen(!viewDetailsOpen);
          }}
        >
          <SearchIcon stroke={serverAppTheme?.iconcolor} className="m-1" />
          <span style={{ color: serverAppTheme?.primary_text }}>
            {' '}
            {LABEL().VIEW_DETAILS}{' '}
          </span>
        </div>
      )}
      {[23].includes(paymentType) && (
        <div
          className={cn(
            style.tableOrderNum,
            'col-12 d-flex justify-content-center align-items-center'
          )}
          style={{ height: '4%', color: serverAppTheme?.primary_text }}
        >
          <span className="fs_24">
            {' '}
            {LABEL().TABLE}{' '}
            {props?.seat?.stationName ||
              props?.seat?.name ||
              props?.seat?.stationNumber}
          </span>
        </div>
      )}
      {/* viewDetailsOpen || ItemizedCheck */}
      {viewDetailsOpen && (
        <>
          {tableData.items &&
            tableData.items.length > 0 &&
            (isPaymentTerminal ||
              (isServerApp)) ? (
            <ItemizedCheck
              viewDetailsOpen={viewDetailsOpen}
              serverAppTheme={serverAppTheme}
              setViewDetailsOpen={setViewDetailsOpen}
              paymentType={paymentType}
              tableData={tableData}
              isTableTop={isTableTop}
              isKiosk={isKiosk}
              seat={props.seat}
              isSpeedOrderMode={isSpeedOrderMode}
              isWalkUp={isWalkUp}
              countryCode={countryCode}
              renderModifier={renderModifier}
              renderModifierView={renderModifierView}
              active={active}
              handleButtonClick={handleButtonClick}
              handleButtonClickOtherAmount={handleButtonClickOtherAmount}
              charityAmount={charityAmount}
              charityList={charityList.map(e => e.displayKey)}
              keyboardValue={keyboardValue}
              handleKeyboardValue={handleKeyboardValue}
              paymentFlowType={props.paymentFlowType}
              unpaidTips={tableData?.unpaidTips}
              paidTips={tableData?.paidTips}
              deviceInfo={props.deviceInfo}
              successMessage={successMessage}
              charity={props.auth?.charity}
              authResponse={getObjectValue(
                () => JSON.parse(window.sessionStorage.getItem('authResponse')),
                null
              )}
              supportsTips={supportsTips}
              paymentCheck={props.paymentCheck}
              allMenuItems={props.menuItems}
              PaymentPageBtn={PaymentPageBtn}
              serverAppThemeNumber={serverAppThemeNumber}
              isServerApp={isServerApp}
              isTogo={isTogo}
            />
          ) : (
            <></>
          )}
        </>
      )}
      {[8].includes(paymentType) ? (
        <div
          className={cn(
            'px-2 py-4 bb',
            isServerApp ? 'col-12 col-md-12' : '',
            [8].includes(paymentType) && 'h-43'
          )}
          // style={{ marginTop: isCounter ? '392px' : '' }}
        >
          <div
            className={cn(
              'row mx-0',
              [4, 6, 12, 16, 8].includes(paymentType) ? 'h-100' : ''
            )}
          >
            <ErrorPaymentIndex
              history={props.history}
              isCash={
                isTableTop
                  ? getObjectValue(
                    () => props.deviceInfo.deviceGroup.paymentTypes.cash,
                    false
                  )
                  : supportCashPayment
              }
              isCreditCard={
                isTableTop
                  ? paymentBtn().key === 'creditCard' ||
                  (paymentBtn().key === 'all' &&
                    getObjectValue(
                      () =>
                        props.deviceInfo.deviceGroup.paymentTypes.creditCard,
                      false
                    ))
                  : countryCode !== '44'
              }
              sourceType={tableData?.sourceType}
              setTextToPayModelOpen={setTextToPayModelOpen}
              tipAmount={tipAmount}
              paymentAmount={paymentAmount}
              totalAmount={tableData?.totalAmount}
              paidAmount={tableData?.paidAmount}
              unpaidAmount={
                props.authResponse
                  ? getObjectValue(
                    () =>
                      JSON.parse(
                        window.sessionStorage.getItem('authResponse')
                      ).checkHeader.unpaidAmount,
                    // props.authResponse &&
                    // props.authResponse.checkHeader &&
                    props.authResponse?.checkHeader?.unpaidAmount
                  )
                  : { ...props.seat }.unpaidAmount
              }
              paymentType={paymentType}
              loading={props.loading}
              loaded={props.loaded}
              error={props.error}
              makeGiftCardBalanceZero={makeGiftCardBalanceZero}
              currenySymbol={currenySymbol}
              handleButtonClick={handleButtonClick}
              handleButtonClickOtherAmount={handleButtonClickOtherAmount}
              setPaymentType={setPaymentType}
              handleRouteCheck={handleRouteCheck}
              handleTipsRouteTo={handleTipsRouteTo}
              tipsList={hasAutoGratuity ? autoGratuityTipsList : tipsList}
              handleCreditCard={handleCreditCard}
              handlePrint={handlePrint}
              active={active}
              charityList={charityList}
              handleCheck={handleCheck}
              logo={props.auth.logoImageUrl}
              paymentCallBack={completeProcessSale}
              handleReceiptPopUpOpen={handleReceiptPopUpOpen}
              handleRetry={handleRetry}
              PaymentPageBtn={PaymentPageBtn}
              isGiftCard={
                isTableTop
                  ? false
                  : props.auth.loyaltyInfo.supportsGiftCardPayment
              }
              isSecurityCode={
                props.auth.loyaltyInfo.validateGiftCardSecurityCode
              }
              charity={props.auth?.charity}
              applyDonation={applyDonation}
              handleSplitEvenly={handleSplitEvenly}
              handlePayAnAmount={handlePayAnAmount}
              keyboardValue={keyboardValue}
              handleKeyboardValue={handleKeyboardValue}
              validatePayAnAmount={validatePayAnAmount}
              hideSignature={hideSignature}
              subTotalAmount={tableData?.subTotalAmount}
              handleSurveySubmit={handleSurveySubmit}
              handleGiftCard={handleGiftCard}
              giftCardPayment={giftCardPayment}
              giftBalance={giftBalance}
              paymentFlowType={props.paymentFlowType}
              giftCardSupportsSwipe={getObjectValue(
                () =>
                  props?.auth?.loyaltyInfo?.giftCardMethods?.includes('swipe'),
                false
              )}
              openCardPopUp={openCardPopUp}
              giftCardNumber={giftCardNumber}
              handleFailureRoute={handleFailureRoute}
              errorMessage={errorMessage}
              handleProcessCreditError={handleProcessCreditError}
              isDone={!lockPaymentScreen}
              totalAmountForTip={getTotalAmountForTip()}
              handleGiftCancel={handleGiftCancel}
              isQrScan={
                isTableTop
                  ? getObjectValue(
                    () => props.deviceInfo.deviceGroup.paymentTypes.scanToPay,
                    false
                  )
                  : false
              }
              isKiosk={isKiosk}
              isTableTop={isTableTop}
              isServerApp={isServerApp}
              pointEarnings={pointEarnings}
              successMessage={successMessage}
              authResponse={getObjectValue(
                () => JSON.parse(window.sessionStorage.getItem('authResponse')),
                null
              )}
              tableData={{ ...tableData }}
              deviceInfo={props.deviceInfo}
              handleHideCancelIcon={status => setHideCancelIcon(status)}
              tipsMessage={tipsMessage}
              showPoints={getObjectValue(
                () => props.auth?.loyaltyInfo?.supportsLoyalty,
                false
              )}
              isCounter={isCounter}
              isWalkUp={isWalkUp}
              handleChangePaymentType={handleChangePaymentType}
              userInfo={props.userInfo}
              receiptTypes={receiptTypes}
              handleDirectToCashConfirmation={handleDirectToCashConfirmation}
              isPaymentTerminal={isPaymentTerminal}
              isExternalCreditCard={isExternalCreditCard}
              giftCardImages={props.giftCardImages}
              setNotification={props.setNotification}
              setGiftBalance={setGiftBalance}
              handlePreAuth={handlePreAuth}
              handleBackButton={handleBackButton}
              setIsOpen={setIsOpen}
              isOpen={isOpen}
              preAuthFunctionCall={preAuthFunctionCall}
              seat={props.seat}
              giftCardMethods={props.auth?.loyaltyInfo?.giftCardMethods}
            />
          </div>
        </div>
      ) : null}
      {![
        3,
        4,
        5,
        6,
        9,
        10,
        11,
        12,
        15,
        16,
        22,
        24,
        27,
        29,
        30,
        31,
        32,
        36,
        33,
      ].includes(paymentType) &&
        !(
          [28].includes(paymentType) && urlSearchParams('type') === 'splitType'
        ) &&
        (props.deviceInfo?.deviceGroup?.startMode != 2 || isTableTop) &&
        (props.auth.deviceTypeId === 7 ||
          props.auth.deviceTypeId === 10 ||
          props.auth.deviceTypeId === 6) && (
          <div
            className={cn(
              [1].includes(paymentType) && !isPaymentTerminal
                   ? orderingPortraitOrientation ? 'col-12' : 'col-8'
                    : 'col-md-12 col-12',
                    [20].includes(paymentType) && isTogo && 'd-none',
              'px-0 pt-0',
              isLandScape
                    ? [2].includes(paymentType)
                      ? 'h-30 align-items-center justify-content-center'
                      : ![1, 28, 8].includes(paymentType)
                        ? 'h-50 align-items-center justify-content-center'
                        : [28].includes(paymentType) &&
                        urlSearchParams('type') === 'payType' &&
                          'h-88 align-items-center justify-content-center pb-1'
                    : [2].includes(paymentType)
                      ? 'h-42'
                      : [3].includes(paymentType)
                        ? 'h-20'
                        : '',
              [8].includes(paymentType) && (isLandScape ? 'h-39' : 'h-43'),
              [17].includes(paymentType) && '',
              [1].includes(paymentType) &&
              (isPaymentTerminal
                ? 'h-77 pt-3 overflowY'
                : `overflowY ${orderingPortraitOrientation ? 'pt-0 pb-2  h-78' : 'h-100 py-3'}`),
              [19].includes(paymentType) && 'h-92'
            )}
          >
            {[1, 23, 19, 28].includes(paymentType) && (
              <div
                className={cn(
                  'fs_14 h-5 row mx-0 w-100 align-items-center fw-500', isLandScape ? urlSearchParams('screenType') != 1 ? 'col-6 pt-20': 'col-12 pt-20' : 'col-12', orderingPortraitOrientation ? 'px-0' : '',
                  paymentType === 28 && 'pl-0'
                )}
                style={{
                  fontFamily: 'Poppins',
                  height: [23, 19].includes(paymentType) && '4%',
                  color:
                    serverAppThemeNumber == 1
                      ? '#bbbbbb'
                      : serverAppTheme?.secondary_text,
                }}
              >
                <div
                  className={cn(
                    'p-0',
                    paymentType === 28
                      ? 'col-2 text-center'
                      : 'col-1 text-center'
                  )}
                >
                  {' '}
                  <span> {LABEL().QTY}</span>
                </div>
                <div
                  className={cn(
                    'px-0 text-left',
                    isWalkUp ? 'col-8' : paymentType === 28 ? 'col-6' : 'col-7'
                  )}
                >
                  <div className="mx-0">{LABEL().ITEMS_LIST}</div>
                </div>
                {!isWalkUp && (
                  <div
                    className={cn(
                      paymentType === 28
                        ? (isLandScape ? 'col-2 pl-2 text-left' : 'col-2 p-0 text-center')
                        : 'col-1 p-0 text-left'
                    )}
                  >
                    {' '}
                    <span> Seat</span>
                  </div>
                )}
                <div
                  className={cn(
                    isServerApp && paymentType === 28
                      ? (isLandScape ? 'col-2 pl-0 pr-3 text-center' : 'col-2 pl-0 pr-0 text-center')
                      : 'col-3 pl-5 text-right pr-0'
                  )}
                >
                  <span>{LABEL().AMOUNT}</span>
                </div>
              </div>
            )}
            {[2].includes(paymentType) && totalVisible ? (
              <div className="row mx-0 h-100 w-100 align-items-center justify-content-center">
                <div
                  className={cn(
                    'col-12 px-0 text-center h-100 w-100 d-flex align-items-center justify-content-center fs_96',
                    isServerApp
                      ? isLandScape
                        ? (style.divForTotalAmount_server_landScape,
                          style.totalAmount)
                        : (style.divForTotalAmount_server, style.totalAmount)
                      : (style.divForTotalAmount_paymentApp, style.totalAmount)
                  )}
                  style={{ color: serverAppTheme?.primary_text }}
                >
                  {currenySymbol}
                  {(tableData.totalAmount || tableData.totalAmount === 0) &&
                    countryCode === '44' &&
                    tableData.totalAmount.toFixed(2)}
                </div>
              </div>
            ) : (
              <>
                <div
                  className={cn(
                    [24].includes(paymentType)
                      ? ''
                      : [23].includes(paymentType)
                        ? 'h-88 position-relative'
                        : [1].includes(paymentType)
                          ? 'row h-95 position-relative mx-0'
                          : [17].includes(paymentType)
                            ? 'col-12 px-0 h-100 position-relative'
                            : [19].includes(paymentType)
                              ? 'row mx-0 h-96 position-relative'
                              : [28].includes(paymentType) &&
                                urlSearchParams('type') === 'payType'
                                ? `mx-0 position-relative d-flex flex-column justify-content-between ${!isLandScape ? "" : (getLoyaltyOfferState() === 0 ? 'h-100' : 'h-92')}`
                                : 'row h-100 mx-0'
                  )}
                >
                  {/* Single Presenter Screen */}
                  {React.createElement(
                    isLandScape ? urlSearchParams('screenType') != 1 ? ReceiptScreenLandScape  : ReceiptScreen : ReceiptScreen,
                    {
                      tableData: { ...tableData },
                      currenySymbol,
                      renderModifier,
                      renderModifierView,
                      paymentType,
                      tipAmount,
                      paymentAmount,
                      active,
                      handleButtonClick,
                      handleButtonClickOtherAmount,
                      charityAmount,
                      charityList: charityList.map(e => e.displayKey),
                      keyboardValue,
                      handleKeyboardValue,
                      paymentFlowType: props.paymentFlowType,
                      unpaidTips: tableData?.unpaidTips,
                      paidTips: tableData?.paidTips,
                      countryCode,
                      deviceInfo: props.deviceInfo,
                      successMessage,
                      charity: props.auth.charity,
                      authResponse: getObjectValue(
                        () => JSON.parse(window.sessionStorage.getItem('authResponse')),
                        null
                      ),
                      supportsTips,
                      paymentCheck: props.paymentCheck,
                      allMenuItems: props.menuItems,
                      isPaymentTerminal,
                      isServerApp,
                      seat: props.seat,
                      PaymentPageBtn,
                      setViewDetailsOpen,
                      viewDetailsOpen,
                      serverAppTheme,
                      isWalkUp,
                      isLandScape,
                      isOrderingPortrait:orderingPortraitOrientation
                    }
                  )}
                </div>
                <ReceiptFooter/>
                {[23].includes(paymentType) ? (
                  <div
                    className={cn(
                      'col-12 text-center h-8 d-flex align-items-center'
                    )}
                  >
                    <span
                      style={
                        isPaymentTerminal
                          ? { fontSize: '17px', fontWeight: '500px' }
                          : {
                            fontSize: '18px',
                            fontWeight: '500px',
                            fontFamily: 'Poppins',
                            fontStyle: 'normal',
                            lineHeight: 'normal',
                          }
                      }
                      className="d-flex justify-content-center align-items-center"
                    >
                      {CUSTOM_MESSAGES().PLEASE_HAVE_YOUR_CARD_READY ? (
                        CUSTOM_MESSAGES().PLEASE_HAVE_YOUR_CARD_READY
                      ) : (
                        <span>
                          {' '}
                          Please have your card ready before you proceed.
                          <br></br>Click Pay Now, when ready.
                        </span>
                      )}{' '}
                    </span>
                  </div>
                ) : null}
              </>
            )}
          </div>
        )}
        {/* <ReceiptFooter/> */}
        
      {/* {[3].includes(paymentType) && isCounter && (
        <div
          className={cn(
            [24].includes(paymentType)
              ? ''
              : [23].includes(paymentType)
                ? 'row h-50 col-6 mx-0'
                : [3].includes(paymentType)
                  ? 'col-6 pl-0 pr-1 h-100 position-relative'
                  : 'row h-100 col-6 mx-0'
          )}
          style={{ paddingTop: isCounter && '5%' }}
        >
          <ReceiptScreen
            tableData={{ ...tableData }}
            currenySymbol={currenySymbol}
            renderModifier={renderModifier}
            renderModifierView={renderModifierView}
            paymentType={paymentType}
            tipAmount={tipAmount}
            paymentAmount={paymentAmount}
            active={active}
            handleButtonClick={handleButtonClick}
            handleButtonClickOtherAmount={handleButtonClickOtherAmount}
            charityAmount={charityAmount}
            charityList={charityList.map(e => e.displayKey)}
            keyboardValue={keyboardValue}
            handleKeyboardValue={handleKeyboardValue}
            paymentFlowType={props.paymentFlowType}
            unpaidTips={tableData.unpaidTips}
            paidTips={tableData.paidTips}
            countryCode={countryCode}
            deviceInfo={props.deviceInfo}
            successMessage={successMessage}
            charity={props.auth.charity}
            authResponse={getObjectValue(
              () => JSON.parse(window.sessionStorage.getItem('authResponse')),
              null
            )}
            supportsTips={supportsTips}
            paymentCheck={props.paymentCheck}
            allMenuItems={props.menuItems}
            isPaymentTerminal={isPaymentTerminal}
            isServerApp={isServerApp}
            isLandScape={isLandScape}
            serverAppTheme={serverAppTheme}
            isWalkUp={isWalkUp}
          />
        </div>
      )} */}
      {![23].includes(paymentType) ? (
        <div
          className={cn(
            "px-0 ee",
            [20].includes(paymentType) && !isLandScape ? "h-100" : "",
            [4, 12].includes(paymentType)
              ? showCheckSeat()
                  ? [4].includes(paymentType)
                    ? "h-91"
                    : "h-86"
                  : [12].includes(paymentType)
                    ? "h-96"
                    : "h-96"
              : "",
            [17].includes(paymentType) ? ("h-98") : "",
            [11, 24].includes(paymentType) ? "h-100" : "",
            [3].includes(paymentType) &&
            "h-12 position-absolute col-12 px-0 d-flex align-items-end",
            [4, 6, 20, 21].includes(paymentType)
              ? "col-12"
              : [1].includes(paymentType) && !isPaymentTerminal
                ?  orderingPortraitOrientation ? "col-12" : "col-4"
                : [4, 28, 31, 32].includes(paymentType) && showCheckSeat()
                    ? "col-12 col-md-12 h-91"
                    : [16, 22, 36].includes(paymentType) && showCheckSeat()
                      ? "col-12 col-md-12 h-90"
                      : [33].includes(paymentType) && showCheckSeat()
                        ? "col-12 col-md-12 h-91"
                        : [12].includes(paymentType) && showCheckSeat()
                          ? "col-12 col-md-12 h-86"
                          : [12].includes(paymentType) && !showCheckSeat()
                            ? "col-12 col-md-12 h-96"
                            : [28].includes(paymentType) &&
                              urlSearchParams("ticketSplitTypeId") === "3"
                              ? "col-12 col-md-12 h-100"
                              : [28].includes(paymentType) &&
                                urlSearchParams("type") === "payType"
                                ? (isLandScape ? "col-6 col-md-6" : "col-12 col-md-12")
                                : "col-12 col-md-12 h-96",
            [16].includes(paymentType) && Number(tableData?.totalAmount) !== 0
              ? showCheckSeat()
                  ? ""
                  : "h-96"
              : "",
            [1, 15, 27, 29, 30].includes(paymentType) && "h-100",
            [2, 28].includes(paymentType) &&
            !(
              [28].includes(paymentType) &&
              urlSearchParams("type") === "splitType"
            ) &&
            "position-absolute",
            [8].includes(paymentType) ?
            (isLandScape ? "h-14 position-absolute" : "h-10 position-absolute") : "",
            [19].includes(paymentType) ? "h-8 position-absolute" : "",
            [22, 31, 32].includes(paymentType) && !showCheckSeat() ? "h-96" : "",
            [33].includes(paymentType) && !showCheckSeat() ? "h-96" : "",
          )}
          style={{
            marginTop: [1, 2].includes(paymentType) ? "auto" : "",
            bottom:
              [1, 2, 3, 8, 19, 28].includes(paymentType) &&
                !(
                  [28].includes(paymentType) &&
                  urlSearchParams("type") === "splitType"
                )
                ? "0"
                : "",
            right: (isLandScape && [28].includes(paymentType)) ? "0" : ""
          }}
        >
          {[2].includes(paymentType) && (
            <div
              className={cn(
                "col-12 px-0 row m-auto text-center justify-content-center  pb-1 fs_20",
                style.divForPaymentOptionSelection,
              )}
              style={
                isPaymentTerminal
                  ? {
                    fontSize: "Max(2.5vw, 2.5vh)",
                    color: serverAppTheme?.primary_text,
                  }
                  : { color: serverAppTheme?.primary_text }
              }
            >
              {" "}
              {CUSTOM_MESSAGES().PAYMENT_OPTION_SELECTION}
            </div>
          )}
          <div
            className={cn(
              [4, 6, 11, 12, 16, 17, 19, 22, 24, 27, 29, 31, 32, 33].includes(
                paymentType,
              )
                ? "h-100"
                : [1].includes(paymentType)
                  ? isPaymentTerminal
                    ? "h-25"
                    : "h-100"
                  : "",
              [27, 31].includes(paymentType) ? "" : "row mx-0 h-100",
              [15, 31, 30, 36].includes(paymentType) ? "h-100" : "",
              [8].includes(paymentType) ? (isLandScape ? "mt-1" : "mt-3") : "",
              [3].includes(paymentType) ? "col-12 px-0" : "",
            )}
          >
            {/* New Flow */}
            {!isReceipt.isOpen && (
              <PaymentScreenReVamp
                history={props.history}
                isCash={
                  isServerApp || isPaymentTerminal
                    ? getObjectValue(
                      () => props?.deviceInfo?.deviceGroup?.paymentTypes?.cash,
                      false,
                    )
                    : supportCashPayment
                }
                isCreditCard={
                  isTableTop
                    ? paymentBtn().key === "creditCard" ||
                    (paymentBtn().key === "all" &&
                      getObjectValue(
                        () =>
                          props.deviceInfo.deviceGroup.paymentTypes.creditCard,
                        false,
                      ))
                    : getObjectValue(
                      () => props.deviceInfo.deviceGroup.paymentTypes.creditCard,
                      false,
                    )
                }
                isTextToPay={
                  isServerApp &&
                  getObjectValue(
                    () => props.deviceInfo.deviceGroup.paymentTypes.textToPay,
                    false,
                  )
                }
                sourceType={tableData?.sourceType}
                setTextToPayModelOpen={setTextToPayModelOpen}
                tipAmount={tipAmount}
                setCheckboxactive={setCheckboxactive}
                setCheckboxactives={setCheckboxactives}
                checkboxactive={checkboxactive}
                paymentAmount={paymentAmount}
                totalAmount={tableData?.totalAmount}
                paidAmount={tableData?.paidAmount}
                unpaidAmount={
                  props.authResponse
                    ? getObjectValue(
                      () =>
                        safeJsonParse(window.sessionStorage.getItem("authResponse"), {})
                          .checkHeader.unpaidAmount,
                      // props.authResponse &&
                      // props.authResponse.checkHeader &&
                      props.authResponse?.checkHeader?.unpaidAmount,
                    )
                    : { ...props.seat }.unpaidAmount
                }
                paymentType={paymentType}
                loading={props.loading}
                loaded={props.loaded}
                error={props.error}
                seatItemHashTable={seatItemHashTable}
                makeGiftCardBalanceZero={makeGiftCardBalanceZero}
                currenySymbol={currenySymbol}
                handleButtonClick={handleButtonClick}
                handleButtonClickOtherAmount={handleButtonClickOtherAmount}
                onChangeTipPersent={onChangeTipPersent}
                onChangeTipAmount={onChangeTipAmount}
                setPaymentType={setPaymentType}
                handleRouteCheck={handleRouteCheck}
                handleTipsRouteTo={handleTipsRouteTo}
                tipsList={hasAutoGratuity ? autoGratuityTipsList : tipsList}
                autoGratuityStoreTips={autoGratuityTipsList}
                handleCreditCard={handleCreditCard}
                handlePrint={handlePrint}
                active={active}
                charityList={charityList}
                handleCheck={handleCheck}
                logo={props.auth.logoImageUrl}
                paymentCallBack={
                  isServerApp && urlSearchParams("preAuth")
                    ? oldCompleteProcessSale
                    : completeProcessSale
                }
                handleReceiptPopUpOpen={handleReceiptPopUpOpen}
                handleRetry={handleRetry}
                PaymentPageBtn={PaymentPageBtn}
                isGiftCard={
                  isTableTop
                    ? false
                    : props.auth.loyaltyInfo.supportsGiftCardPayment &&
                    !props.speedOrderStatus &&
                    !activateGiftCards(props.seat)
                }
                isSecurityCode={props.auth?.loyaltyInfo?.validateGiftCardSecurityCode}
                charity={props.auth?.charity}
                applyDonation={applyDonation}
                handleSplitEvenly={handleSplitEvenly}
                handlePayAnAmount={handlePayAnAmount}
                keyboardValue={keyboardValue}
                handleKeyboardValue={handleKeyboardValue}
                validatePayAnAmount={validatePayAnAmount}
                hideSignature={hideSignature}
                subTotalAmount={tableData?.subTotalAmount}
                handleSurveySubmit={handleSurveySubmit}
                // stopPopUpOtherAmount={stopPopUpOtherAmount}
                setIsTipsConfirm={setIsTipsConfirm}
                setIsAdvanceTipsConfirm={setIsAdvanceTipsConfirm}
                onSubmitTips={() => handleTipsSubmit()}
                handleGiftCard={handleGiftCard}
                giftCardPayment={giftCardPayment}
                giftBalance={giftBalance}
                paymentFlowType={props.paymentFlowType}
                giftCardSupportsSwipe={getObjectValue(
                  () =>
                    props?.auth?.loyaltyInfo?.giftCardMethods?.includes("swipe"),
                  false,
                )}
                openCardPopUp={openCardPopUp}
                giftCardNumber={giftCardNumber}
                handleFailureRoute={handleFailureRoute}
                errorMessage={errorMessage}
                handleProcessCreditError={handleProcessCreditError}
                isDone={!lockPaymentScreen || props.speedOrderStatus}
                totalAmountForTip={getTotalAmountForTip()}
                handleGiftCancel={handleGiftCancel}
                isQrScan={
                  isTableTop
                    ? getObjectValue(
                      () => props.deviceInfo.deviceGroup.paymentTypes.scanToPay,
                      false,
                    )
                    : false
                }
                isKiosk={isKiosk}
                isTableTop={isTableTop}
                isServerApp={isServerApp}
                isCallCenter={isCallCenter}
                speedOrderMode={speedOrderMode}
                isTogo={isTogo}
                pointEarnings={pointEarnings}
                successMessage={successMessage}
                authResponse={safeJsonParse(window.sessionStorage.getItem("authResponse"), null)}
                tableData={{ ...tableData }}
                deviceInfo={props.deviceInfo}
                handleHideCancelIcon={(status) => setHideCancelIcon(status)}
                tipsMessage={tipsMessage}
                showPoints={getObjectValue(
                  () => props.auth?.loyaltyInfo?.supportsLoyalty,
                  false,
                )}
                isCounter={isCounter}
                isWalkUp={isWalkUp}
                handleChangePaymentType={handleChangePaymentType}
                userInfo={props.userInfo}
                receiptTypes={receiptTypes}
                handleDirectToCashConfirmation={handleDirectToCashConfirmation}
                isPaymentTerminal={isPaymentTerminal}
                isExternalCreditCard={isExternalCreditCard}
                giftCardImages={props.giftCardImages}
                setNotification={props.setNotification}
                setGiftBalance={setGiftBalance}
                handlePreAuth={handlePreAuth}
                handleBackButton={handleBackButton}
                setIsOpen={setIsOpen}
                isOpen={isOpen}
                preAuthFunctionCall={preAuthFunctionCall}
                seat={props.seat}
                giftCardMethods={props.auth?.loyaltyInfo?.giftCardMethods}
                setTipAmount={setTipAmount}
                authInfo={props.auth}
                isLandScape={isLandScape}
                countryCode={defaultCountryCode}
                headerImg={headerImg}
                smsEmailPrintObject={smsEmailPrintObject}
                setsmsEmailPrintObject={setsmsEmailPrintObject}
                handleNoReceipt={handleNoReceipt}
                handleRouteRetry={handleRouteRetry}
                enableOtherAmount={
                  hasAutoGratuity
                    ? props?.auth?.autoGratuityTipInfo?.enableOtherAmount
                    : props?.auth?.tipInfo?.enableOtherAmount
                }
                enableOtherPercent={
                  hasAutoGratuity
                    ? props?.auth?.autoGratuityTipInfo?.enableOtherPercent
                    : props?.auth?.tipInfo?.enableOtherPercent
                }
                selectedPayment={selectedPayment}
                disableOtherTip={
                  hasAutoGratuity
                    ? !props?.auth?.autoGratuityTipInfo?.disablePresetTip &&
                    !props?.auth?.autoGratuityTipInfo?.disableOtherTip
                    : !props?.auth?.tipInfo?.disablePresetTip &&
                    !props?.auth?.tipInfo?.disableOtherTip
                }
                serverAppTheme={serverAppTheme}
                validateTipsForCredit={validateTipsForCredit}
                setViewDetailsOpen={setViewDetailsOpen}
                viewDetailsOpen={viewDetailsOpen}
                swipeGiftCards={swipeGiftCards}
                continueGiftCardPayment={continueGiftCardPayment}
                allMenuItems={props.menuItems}
                unPaidAmountForTip={props.seat?.paymentCheck?.unpaidAmount}
                setOtherAmountOrPersent={setOtherAmountOrPersent}
                checkPresenterPay={checkPresenterPay}
                setPaymentFlowType={props.setPaymentFlowType}
                setIsCreditCardPayment={props.setIsCreditCardPayment}
                setCheckAndSeats={setCheckAndSeats}
                checkAndSeats={checkAndSeats}
                showCheckSeat={showCheckSeat}
                offerCouponGiftCard={props.offerCouponGiftCard}
                giftCardData={props.giftCard}
                applyAnOfferScreen={applyAnOfferScreen}
                handleDeleteOffer={handleDeleteOffer}
                groupedLoyaltyOffers={props.groupedLoyaltyOffers}
                giftCardScreen={giftCardScreen}
                handleGiftCardDeleteBalance={handleGiftCardDeleteBalance}
                isAmountEdit={isAmountEdit}
                setIsAmountEdit={setIsAmountEdit}
                onOtherPaymentOptionClick={onOtherPaymentOptionClick}
                employeeCheckInRef={employeeCheckInRef}
                toggleOtherPaymentOption={props.toggleOtherPaymentOption}
                handleApplyOffer={handleApplyOffer}
                setPayModeType={setPayModeType}
                payModeType={payModeType}
                setInfoDeletion={setInfoDeletion}
                infoDeletion={infoDeletion}
                creditCardAmount={creditCardAmount}
                setCreditCardAmount={setCreditCardAmount}
                handleCreditCardPayment={handleCreditCardPayment}
                paymentConfirmation={paymentConfirmation}
                paymentProcess={paymentProcess}
                PayByCardBtn={PayByCardBtn}
                handleGiftCardPayment={handleGiftCardPayment}
                handleCreditCardDeleteBalance={handleCreditCardDeleteBalance}
                setShowTicketDetails={setShowTicketDetails}
                creditRetryBtn={creditRetryBtn}
                setActive={setActive}
                cashMode={cashMode}
                totalPaymentAmount={AmountToPay?.paymentAmount}
                handleRouteCross={handleRouteCross} 
                handleCashClearBalance={handleCashClearBalance}
                handleCashCompletePayment={handleCashCompletePayment}
                handlePayAtCounterPayment={handlePayAtCounterPayment}
                setErrorPopUp={props.setErrorPopUp}
                handleOpenEditModal={() =>
                  setEditStageModal((prev) => ({
                    ...prev,
                    isEditStageModalOpen: true,
                  }))
                }
                splitTableData={splitTableData}
                setSplitTableData={setSplitTableData}
                setSelectedStage={setSelectedStage}
                selectedStage={selectedStage}
                selectedItem={selectedItem}
                selectedSeats={selectedSeats}
                onClearSplit={onClearSplit}
                handleStageSelection={handleStageSelection}
                handleItemSelection={handleItemSelection}
                handleCardSelection={handleCardSelection}
                handleBackButtonClick={handleBackButtonClick}
                handleSplitPayment={handleSplitPayment}
                handleStagePaymentSubmit={handleStagePaymentSubmit}
                handleCheckItems={handleCheckItems}
                handleOpenDeleteModal={() =>
                  setEditStageModal((prev) => ({ ...prev, isClearModalOpen: true }))
                }
                handleCheckAllItems={handleCheckAllItems}
                handleStageMove={handleStageMove}
                totalVisible={totalVisible}
                setTotalVisible={setTotalVisible}
                btnPrimary={btnPrimary}
                setBtnPrimary={setBtnPrimary}
                setPaymentConfirmation={setPaymentConfirmation}
                handleLoyaltyInfo={props?.handleLoyaltyInfo}
                SingedInloyaltyInfo={props.SingedInloyaltyInfo}
                applyTipForPayment={applyTipForPayment}
                navigate={props.navigate}
                location={props.location}
                hasAutoGratuity={hasAutoGratuity}
                isAutoGratuityPresent={isAutoGratuityPresent}
                disablePayment={disablePayment}
                isSwipe={isSwipe}
                isDriveThru={isDriveThru}
                newGiftCards={(() => {
                  const cards = props.seat?.paymentCheck?.giftCards || [];
                  return cards;
                })()}
                giftCardBalanceInfo={props.giftCardBalanceInfo}
                giftCardBalanceCheck={handleGiftCardBalanceCheck}
                onDeleteGiftCard={(card) => {
                  props
                    .giftCardDeleteBalance({
                      deviceId: props.deviceInfo?.deviceId,
                      employeeId: Number(props.userInfo?.id),
                      employeeCard: props.userInfo?.employeeCard,
                      checkHeaderId: tableData?.id,
                      storeId: props.deviceInfo?.storeId,
                      giftCard: {
                        accountNumber: card?.accountNumber,
                        paymentAmount: card?.paymentAmount,
                      },
                      paymentCheck: props?.seat?.paymentCheck,
                      paymentChecks: props?.seat?.paymentChecks,
                    })
                    .catch((err) => {
                      props.setErrorPopUp({
                        res: err.message || err,
                      });
                    });
                }}
                giftCardDeleteBalance={props.giftCardDeleteBalance}
                setSeat={props.setSeat}
                getLoyaltyOfferState={getLoyaltyOfferState}
                setSendOrderConfirmation={setSendOrderConfirmation}
                isOrderingPortrait={orderingPortraitOrientation}
                isTipOnlyEnabled={props?.isTipOnlyEnabled}
                validateTipForTipOnly={validateTipForTipOnly}
                orderingPortraitOrientation={orderingPortraitOrientation}
              />
            )}
          </div>
        </div>
      ) : null}
      {[23].includes(paymentType) ? (
        <div
          className={cn(
            'col-12 px-0 h-8 d-flex align-items-end justify-content-center position-absolute'
          )}
          style={{ bottom: 0 }}
        >
          <button
            type="submit"
            className={cn(
              'col-12 border-0 btn-ripple od-btn-primary fs_28 fw-600'
            )}
            style={{
              backgroundColor: '#0060FF',
              color: '#fff',
              height: '7.5vh',
              fontWeight: '600',
              borderRadius: '5px',
            }}
            onClick={() => {
              const cardReaderType = props.auth?.cardReaderType
                getObjectValue(
                  () =>
                    cardReaderType === 3 ||
                    cardReaderType === 5 ||
                    cardReaderType === 6 ||
                    cardReaderType === 7 ||
                    cardReaderType === 8 ||
                    cardReaderType === 9
                )
                ? handleCheck('tips')
                : handleCreditCard();
            }}
          >
            {LABEL().PAY_NOW} {currenySymbol}
            {tableData &&
              (
                tableData.totalAmount -
                tableData.paidAmount +
                Number(tipAmount)
              ).toFixed(2)}{' '}
          </button>
        </div>
      ) : null}
      {props.isEmployeeCheck && (
        <EmployeeCheck
          auth={props.auth}
          {...props}
          callBack={lockCallBack}
          caseType={isCashPaymentCheck ? 'cashCheck' : flowTypeValue}
          setPaymentType={setPaymentType}
          getSurveyResponse={getSurveyResponse}
          handleCloseCaseType={() => setIsCashPaymentCheck(false)}
          isLandScape={isLandScape}
        />
      )}
      {isReceipt.isOpen && (
        <ReceiptScreenPopUp
          onClose={() => setIsReceipt({ isOpen: false, type: '' })}
          isOpen={isReceipt.isOpen}
          type={isReceipt.type}
          handleReceipt={handleReceipt}
          countryCode={countryCode}
          phoneNumberMaxLength={phoneNumberMaxLength}
          handleCountryCodeChange={handleCountryCodeChange}
          isCounter={isCounter}
          isLandScape={isLandScape}
          SingedInloyaltyInfo={props.SingedInloyaltyInfo}
          paymentType={paymentType}
        />
      )}
      {isTipsConfirm && (
        <TipsConfirmPopUp
          isOpen={isTipsConfirm}
          supportsWarnOnUnusualTip={supportsWarnOnUnusualTip}
          onClose={() => setIsTipsConfirm(false)}
          onSubmitTips={() => handleTipsSubmit()}
          totalAmountForTip={getTotalAmountForTip()}
          tipAmount={tipAmount}
          totalAmount={tableData?.subTotalAmount.toFixed(2)}
          isCounter={isCounter}
          seat={props?.seat}
          auth={props.auth}
          isLandScape={isLandScape}
        />
      )}
      {isAdvanceTipsConfirm && (
        <TipsAdvanceConfirmPopUp
          isOpen={isAdvanceTipsConfirm}
          onClose={() => setIsAdvanceTipsConfirm(false)}
          onSubmitTips={() => handleTipsSubmit()}
          totalAmount={tableData?.subTotalAmount.toFixed(2)}
          seat={props?.seat}
          serverAppTheme={props.serverAppTheme}
          auth={props.auth}
          tipAmount={tipAmount}
          totalAmountForTip={getTotalAmountForTip()}
          isLandScape={isLandScape}
          // supportsWarnOnUnusualTip={supportsWarnOnUnusualTip}
          // isCounter={isCounter}
        />
      )}
      {props.isPrintOpen && (
        <Modal
          customClass="px-3"
          isOpen={props.isPrintOpen}
          isModalCenter
          noBackground
          style={{
            backgroundColor: props.serverAppTheme.popUp_bg,
            borderRadius: '8px',
            border: props.serverAppTheme?.popupBorder,
            boxShadow: props.serverAppTheme?.popUp_box_shadow,
          }}
        >
          <div
            className="col-12 my-2 justify-content-center align-items-center position-relative text-center "
            style={{ color: serverAppTheme?.primary_text }}
          >
            {/* <div className="p-1 position-absolute" style={{ right: '5px', top: '0px' }}>
              <div className="" role="presentation" onClick={() => { props.closeModal(); }}>
                <i className="fa fa-times" aria-hidden="true" />
              </div>
            </div> */}
            <div>
              {/* <div className="text-left">Printer IP Address :{props.printData.printerIpAddress}</div><br /> */}
              <br />
              <br />
              <div className="text-left">
                Printer Name: {props.printData.printerName}
              </div>
              <br />
              <br />
              {/* <div className="text-left">Printer Port: {props.printData.printerPort} </div> */}
            </div>
            <div
              className={cn(style.imgSpin, 'od-spinner position-absolute')}
            />
          </div>
        </Modal>
      )}
      {confirmCashPayment && (
        <Modal isOpen={confirmCashPayment} isModalCenter>
          <div className="col-12 my-2 justify-content-center align-items-center position-relative text-center ">
            {/* <div className="p-1 position-absolute" style={{ right: '5px', top: '0px' }}>
            <div className="" role="presentation" onClick={() => setConfirmCashPayment(false)}>
              <i className="fa fa-times" aria-hidden="true" />
            </div>
          </div> */}
            <div className="px-2 text-right">
              <i
                role="presentation"
                onClick={() => setConfirmCashPayment(false)}
                className="fa fa-times fs-18"
                aria-hidden="true"
              />
            </div>
            <div className="col-12 fs-18 mt-10 fw-700 text-center">
              <div className="fs-20">
                {CUSTOM_MESSAGES().PROCEED_WITH_CASH_PAYMENT_OF} {currenySymbol}
                {tableData &&
                  Number(tableData.totalAmount - tableData.paidAmount).toFixed(
                    2
                  )}
                ?
              </div>
            </div>
            <div className="col-12 d-flex justify-content-center">
              <button
                type="submit"
                className="col-4 m-2 btn btn-secondary od-btn-secondary"
                onClick={() => setConfirmCashPayment(false)}
              >
                <div className="fs-18">{LABEL().NO}</div>
              </button>
              <button
                type="submit"
                className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary"
                onClick={() => {
                  handleCashPayment();
                }}
              >
                <div className="fs-18">{LABEL().YES}</div>
              </button>
            </div>
          </div>
        </Modal>
      )}
      {isSwipe && (
        <div className="h-100">
          <div className="row mx-0 mb-0 h-100 d-flex flex-column" style={{ paddingTop: isLandScape ? '1%' : '20%', paddingBottom: isLandScape ? '1%' : '0' }}>
            <div
              className="col-12 fw-600 justify-content-center align-items-center text-center"
              style={{
                color: serverAppTheme?.primary_text,
                padding: isLandScape ? '0.3rem 10%' : '0 20%',
                fontSize: isLandScape ? '18px' : '28px',
                flex: isLandScape ? '0 0 auto' : '0 0 12%'
              }}
            >
              {CUSTOM_MESSAGES().SWIPE_CARD_AFTER_BEEP}
            </div>
            <div
              className={cn(
                isPaymentTerminal
                  ? 'mx-0 mt-5 row align-items-end col-12 justify-content-center text-center'
                  : 'mx-0 row align-items-center col-12 px-0 justify-content-center text-center'
              )}
              style={{
                flex: isLandScape ? '1 1 auto' : '0 0 70%',
                marginTop: isLandScape ? '0.3rem' : '0',
                marginBottom: isLandScape ? '0.3rem' : '0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                overflow: 'hidden'
              }}
            >
              <img
                src={swipeGiftCard}
                alt="success"
                style={{
                  width: isLandScape ? 'auto' : '100%',
                  height: isLandScape ? '240px' : '100%',
                  maxWidth: isLandScape ? '380px' : '100%',
                  objectFit: 'contain'
                }}
              />
            </div>
            <div
              className={cn(
                'row mx-0 col-12 justify-content-center text-center',
                !showCheckSeat() ? style.cancelTopInit : style.cancelTop
              )}
              style={{
                flex: isLandScape ? '0 0 80px' : '0 0 18%',
                paddingTop: isLandScape ? '0.8rem' : '0',
                paddingBottom: isLandScape ? '0.5rem' : '0.75rem',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}
            >
              <TouchableButton
                className="btn-ripple mr-1 od-primary-btn-bg-color od-primary-btn-font-color"
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  handleStopMagneticRead();
                }}
                style={{
                  height: isLandScape ? '50px' : '7.8vh',
                  backgroundColor: serverAppTheme?.secondaryBtn,
                  color: '#FFFFFF',
                  width: isLandScape ? '250px' : '60%',
                  fontSize: isLandScape ? '22px' : '28px',
                  fontWeight: '600'
                }}
                rippleEffect={true}
              >
                {LABEL().SWIPE_CARD_CANCEL}
              </TouchableButton>
            </div>
          </div>
          {/* </FullWithModal> */}
        </div>
      )}
      {textToPayModelOpen && (
        <Modal
          isOpen={textToPayModelOpen}
          isModalCenter
          style={{
            fontFamily: 'Poppins',
            fontWeight: '600',
            letterSpacing: '0px',
            margin: '16px',
            backgroundColor: serverAppTheme?.popUp_bg,
            borderRadius: '16px',
            border: serverAppTheme?.popupBorder,
          }}
        >
          <div
            className="col-12 justify-content-center align-items-center position-relative text-center od-text-primary p-3"
            style={{
              color: serverAppTheme?.primary_text,
              fontFamily: 'Poppins',
              boxShadow: serverAppTheme?.boxShadow,
            }}
          >
            <div
              className="position-absolute"
              style={{
                right: '4px',
                top: '4px',
                color: serverAppTheme?.iconcolor,
              }}
            >
              <div
                className=""
                role="presentation"
                onClick={() => {
                  setTextToPayModelOpen(false);
                }}
              >
                <Cross
                  fill={serverAppTheme?.iconcolor}
                  role="presentation"
                  aria-hidden="true"
                />
              </div>
            </div>
            <div className="col-12 mt-2 text-center">
              <div className="fs_24" style={{ fontWeight: '400' }}>
                This will send a text to pay link to phone number{' '}
                {getObjectValue(() => props.seat.orders[0].phoneNumber, '')}. Do
                you want to continue?{' '}
              </div>
            </div>
            <div className="col-11 d-flex justify-content-center mt-2 mx-3">
              <button
                type="submit"
                className={cn('col-6 m-1 btn btn-secondary', style.btnSecond)}
                style={{ color: serverAppTheme?.primary_text }}
                onClick={() => setTextToPayModelOpen(false)}
              >
                <div className="fs_28">{LABEL().NO}</div>
              </button>
              <button
                type="submit"
                className={cn(
                  'col-6 m-1 btn btn-primary btn-ripple btn-lg od-btn-primary',
                  style.btnPrim
                )}
                onClick={() => {
                  handleCheck('textToPay');
                  setTextToPayModelOpen(false);
                }}
              >
                <div className="fs_28">{LABEL().YES}</div>
              </button>
            </div>
          </div>
        </Modal>
      )}
      {cancelOrderConfirm && (
        <Modal isOpen={cancelOrderConfirm} isModalCenter>
          <div className="col-12 my-2 px-0 justify-content-center align-items-center position-relative text-center od-text-primary">
            <div className="px-2 text-right fs-18">
              <i
                onClick={() => {
                  setCancelOrderConfirm(false);
                }}
                role="presentation"
                className="fa fa-times"
                aria-hidden="true"
              />
            </div>
            <div className="col-12 fs-18 fw-700 text-center">
              {CUSTOM_MESSAGES().CANCEL_ORDER}
            </div>
            <div className="col-12 d-flex justify-content-center">
              <button
                type="submit"
                className="col-4 m-2 btn btn-secondary od-btn-secondary"
                onClick={() => setCancelOrderConfirm(false)}
              >
                <div className="fs-18">{LABEL().NO}</div>
              </button>
              <button
                type="submit"
                className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary"
                onClick={() => {
                  speedOrderRouteToChecks();
                }}
              >
                <div className="fs-18">{LABEL().YES}</div>
              </button>
            </div>
          </div>
        </Modal>
      )}
      {confirmPopup && (
        <Modal
          isOpen={confirmPopup}
          customClass2={cn('h-96 m-3', style.tipPopup)}
          customClass3={cn(style.tipPopupH)}
        >
          <div
            className={cn(
              'col-12 d-flex justify-content-center align-items-center position-relative text-center',
              style.confirmationPopup
            )}
            style={{
              backgroundColor: serverAppTheme?.popUp_bg,
              border: serverAppTheme?.popupBorder,
              boxShadow: serverAppTheme?.boxShadow,
              color: serverAppTheme?.primary_text,
            }}
          >
            <div
              className="p-1 px-2 py-2 position-absolute"
              style={{ right: '0', top: '0' }}
            >
              <Cross
                fill={serverAppTheme?.iconcolor}
                alt="x"
                role="presentation"
                onClick={() => {
                  setConfirmPopup(false);
                  setTipAmount(0);
                }}
              />
            </div>
            <div className="col-12 fw-600">
              <div
                className="text-center justify-content-center"
                style={{ fontSize: '2rem' }}
              >
                Are you sure?
                <br /> <br />
                <div style={{ fontSize: '28px' }}>
                  {returnCustomMessageWithReplace()}
                </div>
              </div>
            </div>
            <div
              className="col-12 pb-2 d-flex justify-content-center position-fixed w-85 pr-0 pl-0"
              style={{ bottom: '3%' }}
            >
              <div className="col-6 pl-0 pr-1 h-100">
                <button
                  type="submit"
                  className={cn(
                    'col-12 px-0 rounded fs-30 fw-600 od-btn-secondary',
                    style.btnSecondary
                  )}
                  style={{
                    border: serverAppTheme?.cancleBtn_Border,
                    background: serverAppTheme?.OFF_Premise_Btn,
                    color: serverAppTheme?.cancleBtn_font,
                  }}
                  onClick={() => {
                    setConfirmPopup(false);
                    setTipAmount(0);
                  }}
                >
                  {LABEL().NO}
                </button>
              </div>
              <div className="col-6 pl-1 pr-0 h-100">
                <button
                  type="submit"
                  className={cn(
                    'col-12 px-0 rounded fs-30 fw-600 btn-ripple od-btn-primary',
                    style.btnPrimary
                  )}
                  onClick={() => {
                    setConfirmPopup(false);
                    handleCashPayment();
                    setHideCancelIcon(false);
                    lockPaymentScreen
                      ? setHideCancelIcon(false)
                      : setHideCancelIcon(true);
                  }}
                >
                  {LABEL().YES}
                </button>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {cancelOrderConfirm && (
        <Modal isOpen={cancelOrderConfirm} isModalCenter>
          <div className="col-12 my-2 px-0 justify-content-center align-items-center position-relative text-center od-text-primary">
            <div className="px-2 text-right fs-18">
              <i
                onClick={() => {
                  setCancelOrderConfirm(false);
                }}
                role="presentation"
                className="fa fa-times"
                aria-hidden="true"
              />
            </div>
            <div className="col-12 fs-18 fw-700 text-center">
              {CUSTOM_MESSAGES().CANCEL_ORDER}
            </div>
            <div className="col-12 d-flex justify-content-center">
              <button
                type="submit"
                className="col-4 m-2 btn btn-secondary od-btn-secondary"
                onClick={() => setCancelOrderConfirm(false)}
              >
                <div className="fs-18">{LABEL().NO}</div>
              </button>
              <button
                type="submit"
                className="col-4 m-2 btn btn-primary btn-ripple btn-lg od-btn-primary"
                onClick={() => {
                  speedOrderRouteToChecks();
                }}
              >
                <div className="fs-18">{LABEL().YES}</div>
              </button>
            </div>
          </div>
        </Modal>
      )}
      {isCustomTipModelOpen && (
        <FullWithModal
          isOpen={isCustomTipModelOpen}
          isModalCenter
          customClass2={cn('w-100 h-100 p-3')}
          noBackground
          style={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            pointerEvents: 'auto',
            backgroundColor: serverAppTheme?.popUp_bg,
            border: serverAppTheme?.popupBorder,
            boxShadow: serverAppTheme?.boxShadow,
            backgroundClip: 'padding-box',
            height: '100%',
            borderRadius: '16px',
          }}
        >
          <div
            className="col-12 justify-content-center align-items-center position-relative text-center"
            style={{ color: serverAppTheme?.primary_text }}
          >
            <div
              className="position-absolute"
              role="presentation"
              onClick={() => {
                handelCustomTipModelClose();
              }}
              style={{ top: '0.5rem', right: '0.5rem' }}
            >
              <Cross fill={serverAppTheme?.iconcolor} alt="x" />
            </div>
            <div style={{ height: '5vh' }} />
            <div className="col-12 w-100 mt-2">
              <div
                className={cn('m-auto fs-32 align-items-center text-center')}
              >
                {active === `${LABEL().CUSTOM_AMOUNT}`
                  ? LABEL().ENTER_THE_AMOUNT_YOU_WANT_TO_TIP
                    ? LABEL().ENTER_THE_AMOUNT_YOU_WANT_TO_TIP
                    : CUSTOM_MESSAGES().ENTER_TIP_AMOUNT_TEXT
                  : LABEL().ENTER_THE_PERCENT_YOU_WANT_TO_TIP
                    ? LABEL().ENTER_THE_PERCENT_YOU_WANT_TO_TIP
                    : CUSTOM_MESSAGES().ENTER_TIP_PERCENT}
              </div>
            </div>
            <div style={{ height: '5vh' }} />
            <div className={cn('col-12 text-center py-3', style.padding20)}>
              <NumberKeyboard
                name="tipsAmount"
                haveCurrency={
                  active === `${LABEL().CUSTOM_AMOUNT}`
                    ? `${LABEL().CURRENCY_SYMBOL}`
                    : '%'
                }
                type="withoutDone"
                placeholder="0"
                isDotRequired
                isOpen={isCustomTipModelOpen}
                value={active === `${LABEL().ROUND_UP}` ? '' : keyboardValue}
                onChange={e => {
                  handleKeyboardValue(e);
                }}
              />
            </div>
            <div
              style={{ height: '10%' }}
              className="d-flex justify-content-center"
            >
              <button
                type="submit"
                className={cn('fs-30 w-95 text-white od-btn-primary fw-600')}
                style={{
                  fontFamily: 'Poppins',
                  height: '7.5vh',
                  backgroundColor: '#0060ff',
                  borderRadius: '4px',
                  border: 'none',
                  bottom: '10px',
                  left: '12px',
                }}
                onClick={() => handleCustomButtonClick(active, keyboardValue)}
              >
                {LABEL().CONTINUE}
              </button>
            </div>
          </div>
        </FullWithModal>
      )}
      {isConfirmSplit && (
        <Modal
          isOpen={isConfirmSplit}
          customClass={cn('h-100 p-3 ')}
          customClass2={cn('h-100 m-0 position-relative')}
          style={{
            height: '100%',
            backgroundColor: serverAppTheme?.popUp_bg,
            borderRadius: '16px',
            border: serverAppTheme?.popupBorder,
            boxShadow: serverAppTheme?.popUp_box_shadow,
          }}
        >
          <div
            className="col-12 h-95 p-3 d-flex justify-content-center align-items-center position-relative text-center "
            style={{ color: serverAppTheme?.primary_text }}
          >
            <div
              className="h-5 position-absolute text-right fs-28"
              style={{ top: '6px', right: '6px' }}
              tabIndex="0"
              role="button"
              onClick={() => {
                setIsConfirmSplit(false);
              }}
            >
              <Cross
                fill={serverAppTheme?.iconcolor}
                role="presentation"
                aria-hidden="true"
              />
            </div>
            <div style={{ top: '30%' }} className="position-absolute">
              <div
                className="col-12 justify-content-center align-items-center fw-400 text-center fs-36 fw-600"
                style={{ fontFamily: 'Poppins' }}
              >
                <p>Warning</p>
              </div>
              <div
                className="col-12 justify-content-center align-items-center fw-400 text-center fs-22 fw-500"
                style={{ fontFamily: 'Poppins' }}
              >
                {CUSTOM_MESSAGES().CONFIRM_SPLIT}
              </div>
            </div>
            <div
              className="col-12 h-10 pb-2 d-flex justify-content-center position-fixed w-85 pr-0 pl-0"
              style={{ bottom: '2%', left: '7%' }}
            >
              <button
                style={{
                  border: serverAppTheme?.cancleBtn_Border,
                  background: serverAppTheme?.OFF_Premise_Btn,
                  color: serverAppTheme?.cancleBtn_font,
                }}
                type="submit"
                className={cn('col-6 m-1 btn ', style.btnSecondary)}
                onClick={() => setIsConfirmSplit(false)}
              >
                <div className="fs-30 fw-600">{LABEL().NO}</div>
              </button>
              <button
                type="submit"
                className={cn(
                  'col-6 m-1 btn btn-ripple btn-lg ',
                  style.btnPrimary
                )}
                style={{
                  backgroundColor: serverAppTheme?.secondaryBtn,
                  color: serverAppTheme?.btn_font_color,
                }}
                onClick={() => {
                  handleConfirmSplit();
                }}
              >
                <div className="fs-30 fw-600">{LABEL().YES}</div>
              </button>
            </div>
          </div>
        </Modal>
      )}

      {/* details screen */}
      {showTicketDetails && (
        <FullWidthModal
          isOpen={showTicketDetails}
          isModalCenter={true}
          customClass={cn('h-100')}
          customClass2="h-100 w-100"
          customWidth={true}
          noBackground
          style={{ backgroundColor: serverAppTheme?.popUp_bg, height: '100%' }}
        >
          <div className={cn("col-12 h-100 position-relative", isLandScape ? 'p-12' : 'p-3')}>
            <div className="col-12 h-4 fs_18 fw-700 row mx-0 px-0">
              <div className="col-6 px-0 text-left">
                {LABEL().TABLE}{' '}
                {(props?.seat?.stationName?.length > 8
                  ? props?.seat?.stationName?.substring(0, 9) + '...'
                  : props?.seat?.stationName) ||
                  (props?.seat?.name?.length > 8
                    ? props?.seat?.name?.substring(0, 9) + '...'
                    : props?.seat?.name) ||
                  props?.seat?.stationNumber}{' '}
              </div>
              <div className="col-6 px-0 text-right">
                #{`${props?.seat?.number}`}
              </div>
            </div>

            {/* Dynamic section STARTS */}
            <div
              style={{
                display: 'flex',
                flexDirection: isLandScape ? 'row' : 'column',
                // minHeight: '90%',
                height: '100%',
                position: 'relative',
                paddingTop: isLandScape && '16px',
                paddingBottom: !isLandScape && '85px'
              }}
            >
              {/* Items section (anchored to top) */}
              {isLandScape ?
                <div className={cn('col-6 pl-0 pt-0 pr-2')}>
                  <div
                    key={`${billingHeight}-${paymentHeight}`}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      flex: '1',
                      // maxHeight: '',
                      minHeight: '100px',
                    }}
                  >
                    <Items
                      billingHeight={billingHeight}
                      paymentHeight={paymentHeight}
                      loyaltyOffset={loyaltyOffset}
                      allMenuItems={props.menuItems}
                      seat={props.seat}
                      tableData={tableData}
                      countryCode={countryCode}
                      serverAppTheme={serverAppTheme}
                      currenySymbol={currenySymbol}
                      serviceChargeAmount={tableData?.serviceChargeAmount}
                      currentTipValue={tableData?.currentTipValue}
                      tipAmount={tipAmount}
                      detailSection
                      isDriveThru={isDriveThru}
                      isCounter={isCounter}
                      renderModifier={renderModifier}
                      renderModifierView={renderModifierView}
                      loyaltyState={loyaltyState}
                      isLandScape={isLandScape}
                      getLoyaltyOfferState={getLoyaltyOfferState}
                      isCallCenter={isCallCenter}

                    />
                  </div>

                  {/* LoyaltyOffers & Subtotal & Payments sections start (anchored at bottom) */}
                  <DetailLoyaltyOffers
                    serverAppTheme={serverAppTheme}
                    tableData={tableData}
                    getLoyaltyOfferState={getLoyaltyOfferState}
                  />
                  {['28', '22'].includes(urlSearchParams('screenType')) && (
                    <div
                      className={cn(
                        (getLoyaltyOfferState() !== 0 || displayCoupon) && "my-0"
                      )}
                      style={{
                        maxHeight: "150px", // optional: scroll if too many offers
                        overflowY: "auto",
                      }}
                    >
                      {/* Coupon */}
                      {/* {displayCoupon && ['22'].includes(urlSearchParams('screenType')) && (
                        <div
                          className={cn(
                            'col-12 row mx-0 mt-0 mb-1 w-100 align-content-center fs_18 fw-500 d-flex pl-75 justify-content-between',
                            style.spanForPaymentt
                          )}
                          style={{
                            background: serverAppTheme?.itemsBg,
                            borderRadius: '4px',
                            color: serverAppTheme?.primary_text,
                            height: '40px',
                          }}
                        >
                          <div className="d-flex justify-content-start">
                            {seatData?.paymentCheck?.offer?.name
                              ? seatData?.paymentCheck?.offer?.name
                              : LABEL().RECEIPT_COUPON_KEY}
                          </div>
                          <div className="d-flex justify-content-end">
                            <SuccessIcon />
                          </div>
                        </div>
                      )} */}
                    </div>
                  )}
                </div>
                :
                <>
                  {/* <div className={cn(isLandScape && 'col-6 px-1')}> */}
                  <div
                    key={`${billingHeight}-${paymentHeight}`}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      flex: '1',
                      maxHeight: `calc(${'86vh'} - ${billingHeight + paymentHeight}px)`,
                      minHeight: '100px',
                    }}
                  >
                    <Items
                      billingHeight={billingHeight}
                      paymentHeight={paymentHeight}
                      loyaltyOffset={loyaltyOffset}
                      allMenuItems={props.menuItems}
                      seat={props.seat}
                      tableData={tableData}
                      countryCode={countryCode}
                      serverAppTheme={serverAppTheme}
                      currenySymbol={currenySymbol}
                      serviceChargeAmount={tableData?.serviceChargeAmount}
                      currentTipValue={tableData?.currentTipValue}
                      tipAmount={tipAmount}
                      detailSection
                      isDriveThru={isDriveThru}
                      isCounter={isCounter}
                      renderModifier={renderModifier}
                      renderModifierView={renderModifierView}
                      loyaltyState={loyaltyState}
                      isCallCenter={isCallCenter}
                    />
                  </div>

                  {/* LoyaltyOffers & Subtotal & Payments sections start (anchored at bottom) */}
                  <DetailLoyaltyOffers
                    serverAppTheme={serverAppTheme}
                    tableData={tableData}
                    getLoyaltyOfferState={getLoyaltyOfferState}
                  />
                  {['28', '22'].includes(urlSearchParams('screenType')) && (
                    <div
                      className={cn(
                        (getLoyaltyOfferState() !== 0 || displayCoupon) && "my-0"
                      )}
                      style={{
                        maxHeight: "150px", // optional: scroll if too many offers
                        overflowY: "auto",
                      }}
                    >
                      {/* Coupon */}
                      {displayCoupon && ['22'].includes(urlSearchParams('screenType')) && (
                        <div
                          className={cn(
                            'col-12 row mx-0 mt-0 mb-1 w-100 align-content-center fs_18 fw-500 d-flex pl-75 justify-content-between',
                            style.spanForPaymentt
                          )}
                          style={{
                            background: serverAppTheme?.itemsBg,
                            borderRadius: '4px',
                            color: serverAppTheme?.primary_text,
                            height: '40px',
                          }}
                        >
                          <div className="d-flex justify-content-start">
                            {seatData?.paymentCheck?.offer?.name
                              ? seatData?.paymentCheck?.offer?.name
                              : LABEL().RECEIPT_COUPON_KEY}
                          </div>
                          <div className="d-flex justify-content-end">
                            <SuccessIcon />
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </>
              }
              {/* <div className={cn(isLandScape ? 'col-6 pl-2 pr-0 mt-0 mb-0' : 'px-0 mt-auto')}> */}
              <div
                className={cn(isLandScape ? 'col-6 pl-2 pr-0 mt-0 mb-0' : 'px-0 mt-auto')}
                style={{
                  height: isLandScape ? '85%' : 'auto',
                  overflow: 'hidden',
                  flexShrink: 0,
                }}
              >


                {/* Subtotal section START*/}
                <div className={cn('px-0 col-12 pb-1')}>

                  <Subtotal
                    ref={billingRef}
                    seat={props.seat}
                    tableData={tableData}
                    countryCode={countryCode}
                    serverAppTheme={serverAppTheme}
                    currenySymbol={currenySymbol}
                    serviceChargeAmount={tableData?.serviceChargeAmount}
                    currentTipValue={tableData?.currentTipValue}
                    tipAmount={tipAmount}
                    discountAmount={props.seat?.paymentCheck?.discountAmount}
                    deviceInfo={props?.deviceInfo}
                    paymentFlowType={props.paymentFlowType}
                    isLandScape={isLandScape}
                    detailSection
                  />
                </div>
                <ReceiptFooter/>
                {/* Subtotal section END*/}
                {/* Payments section START*/}
                <div
                  ref={paymentRef}
                  className={cn("p-2 justify-content-center fw-600 rounded col-12")}
                  style={{
                    backgroundColor: serverAppTheme?.checkDetail_tabs,
                    flexShrink: 0,
                    overflowY: isLandScape && 'auto',
                    maxHeight: isLandScape ? (!props.seat?.paidAmount == 0 ? '190px' : '250px') : ''
                  }}
                >
                  <div
                    className="col-12 h-5 fs_14 fw-500 text-center"
                    style={{ color: serverAppTheme?.paymentTitle }}
                  >
                    {LABEL().PAYMENTS}
                  </div>
                  <div className="col-12 px-0 pb-1" style={{ overflowY: 'auto' }}>
                    {props?.seat?.paymentCheck?.tickets?.map((item) => (
                      <div key={item.id}>
                        {item.paymentTypeName === 'Cash' ? (
                          <div>
                            <div className="col-12 px-0 d-flex fs_20 fw-500">
                              <div className="col-9 px-0 text-left">
                                {item?.paymentTypeName}
                              </div>
                              <div className="col-3 px-0 text-right">
                                {LABEL().CURRENCY_SYMBOL}
                                {item?.ticketAmount?.toFixed(2)}
                              </div>
                            </div>
                            <div
                              className="col-12 px-0 d-flex fs_14 fw-400"
                              style={{
                                color: serverAppTheme?.paymentsCollectedDetail,
                              }}
                            >
                              <div className="col-6 px-0 text-left">
                                <span>{LABEL().COLLECTED}:</span>
                                <span className="pl-1">
                                  {LABEL().CURRENCY_SYMBOL}
                                  {item?.cashCollectedAmount?.toFixed(2)}
                                </span>
                              </div>
                              <div className="col-6 px-0 text-right">
                                <span>{LABEL().CHANGE}:</span>
                                <span className="pl-1">
                                  {LABEL().CURRENCY_SYMBOL}
                                  {item?.cashChangeAmount?.toFixed(2)}
                                </span>
                              </div>
                            </div>
                          </div>
                        ) : (
                          <div className="payment-item">
                            <div className="col-12 px-0 d-flex">
                              <div className="col-9 px-0 text-left fs_20 fw-500">
                                {item?.paymentTypeName}{' '}
                                {item?.paymentTypeName === 'Gift Card'
                                  ? item?.redactedCardNumber
                                  : `${item?.cardType
                                  }-${item?.redactedCardNumber?.substr(
                                    item?.redactedCardNumber?.length - 4
                                  )}`}
                              </div>
                              <div className="col-3 px-0 text-right fs_20 fw-500">
                                {LABEL().CURRENCY_SYMBOL}
                                {item?.ticketAmount?.toFixed(2)}
                              </div>
                            </div>
                            {item.paymentTypeName === 'Gift Card' && (
                              <div
                                className="col-12 px-0 d-flex fs_14 fw-400"
                                style={{
                                  color: serverAppTheme?.paymentsCollectedDetail,
                                }}
                              >
                                <div className="col-9 pl-0 pr-1 text-left">
                                  {LABEL().RS_BALANCE_AMOUNT}
                                </div>
                                <div className="col-3 pl-1 pr-0 text-right">
                                  {LABEL().CURRENCY_SYMBOL}
                                  {item?.balanceAmount?.toFixed(2) || 0.0}
                                </div>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
            {/* Payments section ENDS*/}
            {/* Dynamic section ENDS */}
            <ReceiptFooter serverAppTheme={serverAppTheme} />
          </div>
          <div
            className={cn("col-12 h-5 position-absolute", isLandScape ? 'd-flex justify-content-end pl-2 pt-1 pr-0 w-96' : 'px-3' )}
            style={{ bottom: isLandScape ? '35px' : '16px', left: isLandScape ? '21px' : '' }}
          >
            <TouchableButton
              type="submit"
              className={cn("rounded btn-ripple fs_24 fw-600 od-primary-btn-bg-color od-primary-btn-font-color", isLandScape ? 'col-6' : 'col-12')}
              onClick={e => {
                e.preventDefault();
                setShowTicketDetails(false);
              }}
              style={{ height: '2.75rem', background: serverAppTheme?.secondaryBtn, color: serverAppTheme?.btn_font_color }}
              rippleEffect={true}
            >
              {LABEL().CLOSE}
            </TouchableButton>
          </div>
        </FullWidthModal>
      )}
      {editStageModal?.isEditStageModalOpen && (
        <AddSeat
          check={props.seat}
          loading={props.loading}
          isModalOpen={editStageModal?.isEditStageModalOpen}
          closeModal={closeModal}
          submitSeatNumber={handleOccupySeatApiCall}
          serverAppTheme={serverAppTheme}
          setErrorPopUp={props.setErrorPopUp}
        />
      )}
      {editStageModal?.isClearModalOpen && (
        <DeleteSeat
          check={props.seat}
          isSeatDelOpen={editStageModal?.isClearModalOpen}
          setIsSeatDelOpen={closeModal}
          selectedSeat={selectedSeat}
          setSelectedSeat={setSelectedSeat}
          serverAppTheme={serverAppTheme}
          handleClear={handleClearSeatApiCall}
          setErrorPopUp={props.setErrorPopUp}
          deviceInfo={props?.deviceInfo}
        />
      )}
      {isMoveModalOpen && (
        <FullWithModal
          isOpen={isMoveModalOpen}
          customClass2={cn('w-100 h-100 position-relative')}
          noBackground
          style={{
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            height: '100%',
            pointerEvents: 'auto',
            backgroundColor: serverAppTheme?.popUp_bg,
            backgroundClip: 'padding-box',
            border: '0',
            boxShadow: serverAppTheme?.popUp_box_shadow,
          }}
        >
          <div
            className="col-12 px-0"
            style={{ margin: 'auto', color: serverAppTheme?.primary_text }}
          >
            {/* 1. header */}
            <div className={cn('col-12 px-2 d-flex', style.moretitlebg)}>
              <div className="col-4 p-0">
                {tickets?.tab ? 'Tab' : 'Table'}:
                {tickets?.stationName?.length > 8
                  ? tickets?.stationName.substring(0, 8) + '...'
                  : tickets?.stationName}
              </div>
              <div className="col-4 p-0 text-center">
                {seatMove === splitSeat
                  ? CUSTOM_MESSAGES().SBS_MOVE_ITEMS_HEADER
                  : CUSTOM_MESSAGES().SBSS_MOVE_ITEMS_HEADER}
              </div>
              <div className="col-4 p-0 text-right">#{tickets?.number}</div>
            </div>
            {/* 2. Instruction label will be added here */}
            <div className="col-12 text-center fs_16 fw-600 pt-3 pb-1">
              {seatMove === splitSeat
                ? CUSTOM_MESSAGES().SBS_SELECT_CHECKS_TO_MOVE
                : CUSTOM_MESSAGES().SBSS_SELECT_CHECKS_TO_MOVE}
            </div>
            <div className="col-12 d-flex">
              {splitTableData.splits &&
                (() => {
                  const checkedItems = Object.values(
                    splitTableData.splits
                  ).flatMap(
                    split => split.items?.filter(item => item.isCheck) || []
                  );

                  const itemNames = checkedItems.map(item => item.menuItemName);
                  const seatIds = checkedItems.flatMap(
                    item => item.seats?.map(s => s.seatId) || []
                  );
                  const uniqueSeatNumbers = [...new Set(seatIds)]
                    .map(id => {
                      const seat = splitTableData.seats?.find(s => s.id === id);
                      return seat?.number;
                    })
                    .filter(Boolean);

                  return (
                    <div>
                      Item: {itemNames.join(', ')}, &nbsp; Seat:{' '}
                      {uniqueSeatNumbers.join(', ')}
                    </div>
                  );
                })()}
            </div>
            {/* 3. checks */}
            <div
              className="col-12 px-0 justify-content-center align-items-center position-relative text-center overflowY"
              style={{ maxHeight: orderingPortraitOrientation ? '680px' : '350px' }}
            >
              <div className={cn('col-12 col-md-12 w-100 h-100 overflowY', orderingPortraitOrientation ? 'px-12' : '')}>
                <div className={cn('col-12 px-0 py-1', orderingPortraitOrientation ? style.gridContainerPortrait : style.gridContainer)}>
                  {splitTableData.splits &&
                    Object.values(splitTableData.splits).map((item, index) => {
                      return (
                        Number(item.status) === 0 && (
                          <TouchableDiv
                            key={item.id}
                            role="presentation"
                            onClick={() => handleCardSelection(item)}
                            className={cn('w-100')}
                            style={{ maxHeight: '113px' }}
                          >
                            <div
                              className={cn('h-100 p-2 rounded')}
                              style={{
                                background: selectedSeats.some(
                                  e => e.id === item.id
                                )
                                  ? '#D2E2FF'
                                  : serverAppTheme?.splitUnselectedTile,
                                color: serverAppTheme?.primary_text,
                              }}
                            >
                              <div className="h-100 align-items-center justify-content-center fs_16 fw-500">
                                <div className="col-12 px-0 pb-2 text-left">
                                  {item?.name?.length > 0 ? (
                                    <span>
                                      Check: {index + 1}{' '}
                                      {item?.name?.length > 5
                                        ? item?.name
                                          ?.substring(0, 5)
                                          ?.concat('...')
                                        : item?.name}
                                    </span>
                                  ) : (
                                    <span>
                                      {LABEL().SBS_CHECK}: {index + 1}
                                    </span>
                                  )}
                                </div>
                                <div className="col-12 px-0 overflowX pb-2">
                                  <div className={'col-12 px-0 d-flex'}>
                                    {item.seats && item.seats.length > 0 && (
                                      <>
                                        <span className="mr-1">Seat: </span>
                                        <div className="d-flex">
                                          {item.seats
                                            .map(data => {
                                              const seatObj = splitTableData.seats.find(
                                                e => e.id === data.seatId
                                              );
                                              return seatObj?.number;
                                            })
                                            .filter(Boolean)
                                            .join(', ')}
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                                <div className="col-12 px-0 text-left">
                                  {item.totalAmount != null
                                    ? `${LABEL().CURRENCY_SYMBOL}${Number(
                                      item.totalAmount
                                    ).toFixed(2)}`
                                    : ''}
                                </div>
                              </div>
                            </div>
                          </TouchableDiv>
                        )
                      );
                    })}
                </div>
              </div>
            </div>
            {/* 4. buttons */}
            <div
              className="col-12 px-0 pt-2 d-flex align-items-center justify-content-center"
              style={{ bottom: '20px', position: 'fixed' }}
            >
              <div className="col-12 d-flex">
                <div className="col-4 pr-1 pl-0">
                  <TouchableButton
                    type="button"
                    className={cn("fw-600 btn-ripple w-100 p-0 d-flex align-items-center justify-content-center", orderingPortraitOrientation ? 'fs_20' : 'fs_28')}
                    onClick={event => {
                      event.preventDefault();
                      handleCancel();
                    }}
                    style={{
                      background: serverAppTheme?.OFF_Premise_Btn,
                      border: serverAppTheme?.cancleBtn_Border,
                      color: serverAppTheme?.cancleBtn_font,
                      height: orderingPortraitOrientation ? '68px' : '44px',
                      borderRadius: '3px',
                    }}
                  >
                    {LABEL().CANCEL}
                  </TouchableButton>
                </div>
                <div className="col-4 px-1">
                  <TouchableDiv
                    role="presentation"
                    className={cn(' w-100 btn44')}
                    onClick={() => {
                      handleMove();
                    }}
                  >
                    <div
                      className={cn(
                        'justify-content-center align-items-center rounded fw-600 text-center d-flex',  orderingPortraitOrientation ? 'fs_20' : 'btn44 fs_28'
                      )}
                      style={{
                        height : orderingPortraitOrientation ? '68px' : '44px',
                        background: serverAppTheme?.primaryBtn,
                        border:
                          selectedSeats.includes('allStages') &&
                          serverAppTheme?.splitSelectedBorder,
                        color: serverAppTheme?.btn_font_color,
                      }}
                    >
                      {LABEL().SBSS_ALL_CHECKS}
                    </div>
                  </TouchableDiv>
                </div>
                <div className="col-4 pl-1 pr-0">
                  <TouchableButton
                    type="button"
                    style={{
                      background: serverAppTheme?.secondaryBtn,
                      color: serverAppTheme?.btn_font_color,
                      height : orderingPortraitOrientation ? '68px' : '44px',
                      border: '0',
                      borderRadius: '3px',
                    }}
                    className={cn("w-100 btn-ripple fw-600 d-flex align-items-center justify-content-center ",  orderingPortraitOrientation ? 'fs_20' : 'btn44 fs_28')}
                    onClick={event => {
                      event.preventDefault();
                      if (selectedSeats.length === 0) {
                        props.setErrorPopUp({
                          res:
                            seatMove === splitSeat
                              ? CUSTOM_MESSAGES()
                                .SBS_PLEASE_SELECT_CHECKS_TO_MOVE
                              : CUSTOM_MESSAGES()
                                .SBSS_PLEASE_SELECT_CHECKS_TO_MOVE,
                          noErrorTxt: true,
                          onClickChange: () => {},
                        });
                      } else {
                        handleMove();
                      }
                    }}
                  >
                    {LABEL().MOVE}
                  </TouchableButton>
                </div>
              </div>
            </div>
          </div>
        </FullWithModal>
      )}

      {paymentcheckTicketsModal && (
        <Modal
          isOpen={paymentcheckTicketsModal}
          isModalCenter
          style={{
            backgroundColor: serverAppTheme?.popUp_bg,
            borderRadius: '16px',
            border: serverAppTheme?.popupBorder,
            boxShadow: serverAppTheme?.popUp_box_shadow,
            width: '486px',
            margin: 'auto',
            minHeight: '216px',
            padding: '1.5rem',
            position: 'relative',
          }}
          customClass="h-100 w-100"
          customClass2="h-100 w-100"
          noBackground
        >
          <div
            className="justify-content-center align-items-center text-center h-100"
            style={{ color: serverAppTheme?.primary_text }}
          >
            <div className="col-12 p-0 h-70 justify-content-center d-flex flex-column">
              <div
                className={cn('col-12 px-0 fs_16 fw-400 text-center h-auto')}
              >
                <div className="py-3">
                  {CUSTOM_MESSAGES().EPS_CHECK_DUE_AMOUNT} {currenySymbol}
                  {props?.seat?.paymentCheck?.paymentAmount?.toFixed(2)}
                  {CUSTOM_MESSAGES().EPS_YOU_WANT_TO_EXIT}
                </div>
              </div>
            </div>
            <div
              className={cn(
                'col-12 px-4 h-30 d-flex mt-auto justify-content-center align-items-center text-center position-absolute'
              )}
              style={{ left: 0, bottom: '1.5rem' }}
            >
              <div className="col-6 pl-0 pr-1">
                <TouchableButton
                  type="submit"
                  className={cn(style.btnSecond, 'col-12 fs_24 fw-600 btn-44')}
                  onClick={event => {
                    event.preventDefault();
                    setPaymentcheckTicketsModal(false);
                  }}
                  style={{ color: serverAppTheme?.cancleBtn_font }}
                >
                  {LABEL().NO}
                </TouchableButton>
              </div>
              <div className="col-6 pl-1 pr-0">
                <TouchableButton
                  type="submit"
                  className={cn(
                    style.btnPrimary,
                    'col-12 btn-ripple fs_24 fw-600'
                  )}
                  onClick={event => {
                    event.preventDefault();
                    handlePaymentCheckTicket();
                  }}
                >
                  {LABEL().YES}
                </TouchableButton>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {paymentcheckLocksModal && (
        <Modal
          isOpen={paymentcheckLocksModal}
          isModalCenter
          style={{
            backgroundColor: serverAppTheme?.popUp_bg,
            borderRadius: '16px',
            border: serverAppTheme?.popupBorder,
            boxShadow: serverAppTheme?.popUp_box_shadow,
            width: '486px',
            margin: 'auto',
            minHeight: '216px',
            padding: '1.5rem',
            position: 'relative',
          }}
          customClass="h-100 w-100"
          customClass2="h-100 w-100"
          noBackground
        >
          <div
            className="justify-content-center align-items-center text-center h-100"
            style={{ color: serverAppTheme?.primary_text }}
          >
            <div className="col-12 p-0 h-70 justify-content-center d-flex flex-column">
              <div
                className={cn('col-12 px-0 fs_16 fw-400 text-center h-auto')}
              >
                <div className="py-3">
                  {CUSTOM_MESSAGES().EPS_CHECK_DUE_AMOUNT} {currenySymbol}
                  {props?.seat?.paymentCheck?.paymentAmount?.toFixed(2)}{' '}
                  {CUSTOM_MESSAGES().EPS_YOU_WANT_TO_EXIT}
                </div>
              </div>
            </div>
            <div
              className={cn(
                'col-12 px-4 h-30 d-flex mt-auto justify-content-center align-items-center text-center position-absolute'
              )}
              style={{ left: 0, bottom: '1.5rem' }}
            >
              <div className="col-6 pl-0 pr-1">
                <TouchableButton
                  type="submit"
                  className={cn(
                    style.btnSecond,
                    'col-12 fs_24 fw-600 btn-44 od-cancel-btn-bg-color  od-cancel-btn-font-color od-cancel-btn-st-color'
                  )}
                  onClick={event => {
                    event.preventDefault();
                    setPaymentcheckLocksModal(false);
                  }}
                  style={{ color: serverAppTheme?.cancleBtn_font }}
                  rippleEffect={true}
                >
                  {LABEL().PARTIAL_PAYMENT_NO}
                </TouchableButton>
              </div>
              <div className="col-6 pl-1 pr-0">
                <TouchableButton
                  type="submit"
                  className={cn(
                    style.btnPrimary,
                    'col-12 btn-ripple fs_24 fw-600 od-primary-btn-bg-color od-primary-btn-font-color'
                  )}
                  onClick={event => {
                    event.preventDefault();
                    setPaymentcheckLocksModal(false);
                    props.openEmployeeCheck();
                  }}
                  rippleEffect={true}
                >
                  {LABEL().PARTIAL_PAYMENT_YES}
                </TouchableButton>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {printSuccess && (
        <FullWithModal
          isOpen={printSuccess}
          customClass2={cn(
            'w-100 h-100 p-3 d-flex justify-content-center align-items-center'
          )}
          noBackground
          style={{
            position: 'relative',
            display: 'flex',
            flexDirection: 'column',
            width: '486px',
            padding: '1.5rem',
            pointerEvents: 'auto',
            backgroundClip: 'padding-box',
            height: '216px',
            borderRadius: '16px',
            backgroundColor: serverAppTheme?.popUp_bg,
            border: serverAppTheme?.offers_Border,
            boxShadow: serverAppTheme?.popUp_box_shadow,
          }}
        >
          <div className="col-12 fs_18 fw-400 d-flex justify-content-center align-items-center text-center">
            <div>
              <div
                className="text-center pb-25 mb-10"
                style={{ color: serverAppTheme?.primary_text }}
              >
                {CUSTOM_MESSAGES().PRINT_SUCCESS}
              </div>
            </div>
            <div
              className="col-12 px-0 mt-2 position-absolute"
              style={{ bottom: 0, left: 0 }}
            >
              <TouchableButton
                className="col-12 px-0 btn44 btn-ripple fs-24  od-primary-btn-bg-color od-primary-btn-font-color"
                style={{
                  background: serverAppTheme?.secondaryBtn,
                  color: serverAppTheme?.btn_font_color,
                }}
                onClick={() => {
                  setPrintSuccess(false);
                  props.closePrintSuccessPopUp();
                  props.closePrint();
                }}
                rippleEffect={true}
              >
                {CUSTOM_MESSAGES().PRINT_CLOSE}
              </TouchableButton>
            </div>
          </div>
        </FullWithModal>
      )}
      {giftCardReceiptModal?.isOpen && (
        <Modal
          isOpen={
            giftCardReceiptModal?.isOpen &&
            (receiptTypes?.sms || receiptTypes?.print || receiptTypes?.email)
          }
          isModalCenter
          customClass="h-100 w-100"
          customClass2="h-100 w-100"
          noBackground
          style={inlineStyle.modal}
        >
          <div
            className="justify-content-center align-items-center text-center h-100"
            style={inlineStyle.parentContainer}
          >
            <div className="col-12 p-0 h-70 justify-content-center d-flex flex-column">
              <div className="col-12 fs_18 fw-700 text-center h-auto">
                Are You Sure ?
              </div>
              <br />
              <div className="col-12 px-0 fs_15 fw-400 text-center h-auto">
                {CUSTOM_MESSAGES().RS_NO_RECEIPT_SELECTED}
              </div>
            </div>
            <div
              className={cn(
                'col-12 px-4 h-30 d-flex mt-auto justify-content-center align-items-center text-center position-absolute'
              )}
              style={inlineStyle.btnPosition}
            >
              <div className="col-6 pl-0 pr-1">
                <TouchableButton
                  type="submit"
                  className={cn(
                    'col-12 fs_24 fw-600 btn-44 od-cancel-btn-st-color od-cancel-btn-font-color od-cancel-btn-bg-color'
                  )}
                  onClick={event => {
                    event.preventDefault();
                    setGiftCardReceiptModal({ isOpen: false, show: true });
                  }}
                  style={inlineStyle.noButton}
                >
                  {LABEL().NO}
                </TouchableButton>
              </div>
              <div className="col-6 pl-1 pr-0">
                <TouchableButton
                  type="submit"
                  className={cn(
                    'col-12 btn-ripple fs_24 fw-600 od-primary-btn-bg-color od-primary-btn-font-color'
                  )}
                  onClick={event => {
                    event.preventDefault();
                    continueGiftCardPayment(true);
                  }}
                  style={inlineStyle.yesButton}
                >
                  {LABEL().YES}
                </TouchableButton>
              </div>
            </div>
          </div>
        </Modal>
      )}
      {openLoyalty && (
        <LoyaltyListPopUp
          openLoyalty={openLoyalty}
          setOpenLoyalty={setOpenLoyalty}
          serverAppTheme={serverAppTheme}
          seat={props?.seat}
          loyaltyList={loyaltyList}
          setSelectedLoyalty={setSelectedLoyalty}
          handleLoyaltySubmit={handlePayFullCheck}
          selectedLoyalty={selectedLoyalty}
        />
      )}
      {newOfferPopUp && (!props.isSplitEvenly || props.fromPay) && (
        <SplitOffersList
          newOfferPopUp={newOfferPopUp}
          serverAppTheme={serverAppTheme}
          seat={props?.seat}
          checkAndSeats={checkAndSeats}
          setNewOfferPopUp={setNewOfferPopUp}
          handleSplitOffer={handleSplitOffer}
          handleSplitLyltSubmit={handleSplitLyltSubmit}
          handleSplitCancel={handleSplitCancel}
          loading={props?.loading}
        />
      )}
      {sendOrderConfirmation?.isOpen &&
        (
          <Modal
            isOpen={sendOrderConfirmation?.isOpen}
            customClass="p-4"
            customClass2="d-flex justify-content-center align-items-center"
            // customClass3={cn(styles.paycounterPopupH)}
            isModalCenter
          >
            <div
              className={'col-12 row mx-0 justify-content-center p-4 align-items-center position-relative text-center'}
              style={{
                backgroundColor: serverAppTheme?.popUp_bg,
                color: serverAppTheme?.primary_text,
                fontFamily: 'Poppins',
                border: serverAppTheme?.popupBorder,
                borderRadius: '16px',
                boxShadow: serverAppTheme?.popUp_box_shadow,
              }}
            >
              <div className="col-12 fw-400">
                <div className="text-center justify-content-center pb-25 mb-15">
                  <div
                    className={cn('fs_18 pb-20')}
                  >
                    {/* {sendOrderConfirmation?.type === 'orderAtRes' ? CUSTOM_MESSAGES().CC_SEND_ORDER_CONFIRMATION_MESSAGE : (speedOrderMode ? CUSTOM_MESSAGES().SPO_SEND_ORDER_CONFIRMATION_MESSAGE  : CUSTOM_MESSAGES().CC_TEXT_TO_PAY_CONFIRMATION_MESSAGE)} */}
                  {sendOrderConfirmation?.type === 'orderAtRes'
                    ? speedOrderMode
                      ? CUSTOM_MESSAGES().SPO_SEND_ORDER_CONFIRMATION_MESSAGE
                      : isTogo
                        ? CUSTOM_MESSAGES().TG_SEND_ORDER_CONFIRMATION_MESSAGE
                        : CUSTOM_MESSAGES().CC_SEND_ORDER_CONFIRMATION_MESSAGE
                    : isTogo
                      ? CUSTOM_MESSAGES().TG_TEXT_TO_PAY_CONFIRMATION_MESSAGE
                      : CUSTOM_MESSAGES().CC_TEXT_TO_PAY_CONFIRMATION_MESSAGE}

                </div>
                </div>
              </div>
              <div
                className={cn(
                  'col-12 d-flex justify-content-center position-absolute p-4',
                )}
                style={{ bottom: '0' }}
              >
                <div className="col-6 pr-1 pl-0">
                  <TouchableButton
                    type="submit"
                    className={cn(
                      'col-12 btn44 od-cancel-btn-bg-color od-cancel-btn-font-color od-cancel-btn-st-color'
                    )}
                    style={{
                      backgroundColor: serverAppTheme?.OFF_Premise_Btn,
                      color: serverAppTheme?.primary_text,
                      border: '1px solid #2541A4',
                    }}
                    onClick={e => {
                      setSendOrderConfirmation(false);
                      e.preventDefault();
                    }}
                    rippleEffect={true}
                  >
                  <div className={cn('fs_24')}>
                    {/* {speedOrderMode ? LABEL().SPO_NO : LABEL().CC_NO} */}
                    {isTogo
                      ? LABEL().TG_NO
                      : speedOrderMode
                        ? LABEL().SPO_NO
                        : LABEL().CC_NO
                    }
                  </div>
                </TouchableButton>
                </div>
                <div className="col-6 pl-1 pr-0">
                  <TouchableButton
                    type="submit"
                    className={cn(
                      'col-12 btn-ripple btn-lg btn44 od-primary-btn-bg-color od-primary-btn-font-color'
                    )}
                    style={{
                      background: serverAppTheme?.secondaryBtn,
                      color: serverAppTheme?.btn_font_color,
                    }}
                    onClick={e => {
                      if (isDriveThru || speedOrderMode) {
                        handlePayAtCounterPayment();
                      } else {
                        handleSendAndPayCallCenter(sendOrderConfirmation?.type);
                      }
                      setSendOrderConfirmation(false);
                      e.preventDefault();
                    }}
                    rippleEffect={true}
                  >
                    <div className={cn('fs_24')}>
                      {/* {speedOrderMode ? LABEL().SPO_YES : LABEL().CC_YES} */}
                    {isTogo
                      ? LABEL().TG_YES
                      : speedOrderMode
                        ? LABEL().SPO_YES
                        : LABEL().CC_YES
                    }
                  </div>
                  </TouchableButton>
                </div>
              </div>
            </div>
          </Modal>)}
      {(props?.isTipOnlyEnabled || props?.isOfflineVoid) && voidCancel && (
        <Modal
          isOpen={voidCancel}
          isModalCenter
          style={popupModal.speedOrderModal}
          customClass="h-100 w-100"
          customClass2="h-100 w-100"
          noBackground
        >
          <div
            className="col-12 h-100 justify-content-center align-items-center text-center h-100 "
            style={popupModal.messageStyle}
          >
            <div className="col-12 fs_18 fw-700 text-center h-20">Are You Sure?</div>

            <div className="col-12 fs_15 fw-400 py-2 pt-3 text-center">
              {CUSTOM_MESSAGES().CANCEL_ORDER}
            </div>
          </div>

          <div className="col-12 d-flex justify-content-center mt-4">
            <TouchableButton
              className={cn("col-6 mr-1 btn44  fs_24 fw-600", styles.btnSecondary1)}
              style={popupModal.noButton}
              type="button"
              onClick={(e) => {
                e.preventDefault();
                setVoidCancel(false);
              }}
            >
              {LABEL().NO}
            </TouchableButton>
            <TouchableButton
              className={cn(
                "col-6 ml-1 btn44 btn-ripple fs_24 fw-600",
                styles.btnPrimary1,
              )}
              type="button"
              onClick={(e) => {
                e.preventDefault();
                handleCancelOrderConfirm();
              }}
            >
              {LABEL().YES}
            </TouchableButton>
          </div>
        </Modal>
      )}
    </div>
  );
};

ProcessSaleFlowLandscape.propTypes = {
  ShowLandscapeMode: PropTypes.bool,
  checkAndSeats: PropTypes.object,
  setCheckAndSeats: PropTypes.func,
  paymentCheck: PropTypes.object,
  seat: PropTypes.object,
  auth: PropTypes.object,
  deviceInfo: PropTypes.object,
  serverAppTheme: PropTypes.object,
};

ProcessSaleFlowLandscape.defaultProps = {
  ShowLandscapeMode: false,
  checkAndSeats: {},
  setCheckAndSeats: () => {},
  paymentCheck: {},
  seat: {},
  auth: {},
  deviceInfo: {},
  serverAppTheme: {},
};

const mapStateToProps = (state) => ({
  loading:
    state.payment.loading ||
    state.storeChecks.loading ||
    state.survey.loading ||
    state.orders.loading ||
    state.loyalty.loading,
  deviceInfo: state.oauth.deviceInformation,
  userInfo: state.oauth.loggedInUserData,
  auth: state.oauth.authInfo,
  seat: state.orders.seats,
  paymentCheck: state.orders.paymentCheck,
  cart: state.orders.cart,
  menuItemsHashTable: state.orders.menuItemsHashTable,
  menuItems: state.orders.menuItems,
  speedOrderStatus: state.orders.speedOrderStatus,
  speedOrderName: state.orders.speedOrderName,
  sendModeStatus: state.orders.sendModeStatus,
  authResponse: state.payment.authResponse,
  giftCard: state.payment.newGiftCard,
  newGiftCards: state.payment.newGiftCards,
  giftCardBalanceInfo: state.payment.giftCardBalanceInfo,
  isOfferAvailable: state.payment.isOfferAvailable,
  isOtherPaymentOption: state.payment.isOtherPaymentOption,
  isPrintOpen: state.notification.isPrintOpen,
  isPrintSuccess: state.notification.isPrintSuccessOpen,
  printData: state.notification.printData,
  surveyData: state.survey.surveyData,
  isEmployeeCheck: state.oauth.isEmployeeCheck,
  cardReaderStatus: state.oauth.cardReaderStatus,
  employeeJobHashTable: state.oauth.employeeJobHashTable,
  offerCouponGiftCard: state.loyalty.offerCouponGiftCard,
  groupedLoyaltyOffers:
    state.loyalty.groupedLoyaltyOffers || state.loyalty.groupedLoyaltyOffer,
  SingedInloyaltyInfo: state.loyalty.SingedInloyaltyInfo,
  fromPay: state.orders.fromPay,
  isTipOnlyEnabled: state.storeChecks.isTipOnlyEnabled,
  isOfflineVoid: state.orders.isOfflineVoid,
  orderingPortraitOrientation: state.orders.orderingPortraitOrientation,
  paymentLandscapeOrientation: state.payment.paymentLandscapeOrientation
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      paymentInitialization,
      giftCardBalance,
      giftCardBalanceCheck,
      clearGiftCardBalanceInfo,
      getTips,
      paymentCash,
      ingenicoLog,
      paymentAuth,
      paymentAuthError,
      setNotification,
      paymentAuthComplete,
      paymentSale,
      paymentNewPaymentCreditSale,
      receiptSms,
      paymentSignature,
      setAuthResponse,
      receiptEmail,
      updateChecksAfterResponse,
      removeSeat,
      removePaymentCheck,
      receiptPrint,
      updateSeatInfo,
      setPaymentCheck,
      setPrintNotification,
      closePrintNotification,
      submitSurvey,
      textToPay,
      getSurvey,
      giftCardPaymentInit,
      giftCardPayments,
      openEmployeeCheck,
      callServer,
      clearAuthResponse,
      checkVoid,
      ingenicoPayment,
      setConfirmStageSplit,
      orderTicketPrint,
      giftCardImages,
      setSeat,
      preAuthPayment,
      setErrorPopUp,
      paymentSplitCheck,
      applyTipForPayment,
      handleDeleteOffer,
      applyGiftCardBalance,
      showSuccessCheckMark,
      giftCardDeleteBalance,
      applyLoyaltyOffer,
      toggleOtherPaymentOption,
      payByCreditCard,
      paymentNewInitialization,
      paymentNewPaymentComplete,
      paymentNewPaymentAtCounter,
      clearSelectedOffers,
      paymentNewPaymentError,
      creditCardDeleteBalance,
      paymentByCash,
      cashClearBalance,
      updateWithPaymentStages,
      occupySeat,
      setPosition,
      seatClear,
      moveChecks,
      tipClear,
      paymentClearSplit,
      newIngenicoPayment,
      handleLoyaltyInfo,
      getPaymentNewSurvey,
      closePrintSuccessPopUp,
      closePrint,
      spiltCheckPayment,
      loyaltySplitOffers,
      sendChecks,
      orderPayNewPaymentComplete,
      setOfflineVoid,
      setIsTipOnlyEnabled,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(ProcessSaleFlowLandscape);
